import { defineComponent as nt, useSlots as Pu, ref as le, toRef as Iu, provide as Qe, computed as En, openBlock as J, createElementBlock as pn, normalizeClass as wt, normalizeStyle as Xr, unref as gn, createElementVNode as yn, createCommentVNode as Zt, renderSlot as De, pushScopeId as Ep, popScopeId as Cp, inject as mt, reactive as Sp, onUnmounted as Mu, watch as Yr, onMounted as gs, Fragment as Ae, renderList as Fe, createBlock as ce, resolveDynamicComponent as je, withCtx as Te, createVNode as Zr, TransitionGroup as Lp, createSlots as Pp, h as Mp, createTextVNode as Bp } from "vue";
import { useThemeVars as Es, NButton as Cs, NIcon as Wp, NScrollbar as Up, NH2 as Fp } from "naive-ui";
function Bu(u, o) {
  return o === void 0 && (o = "i"), new RegExp(u.map(function(r) {
    return r.source;
  }).join("|"), o);
}
var Dp = /^(([0-9a-f])+([.]([0-9a-f])+)?)$/i, Ss = /^#(?:([0-9a-f]{3}))$/i, Ls = /^#(?:([0-9a-f]{3})([0-9a-f]{1}))$/i, Ps = Bu([Ss, Ls]), Ms = /^#(?:([0-9a-f]{6}))$/i, Bs = /^#(?:([0-9a-f]{6})([0-9a-f]{2}))$/i, Ws = Bu([Ms, Bs]), kp = Bu([Ps, Ws]), Hp = /[0-9a-f]{2}$/i, ei = {
  generic: Dp,
  shortWithoutAlpha: Ss,
  shortWithAlpha: Ls,
  short: Ps,
  longWithoutAlpha: Ms,
  longWithAlpha: Bs,
  long: Ws,
  color: kp,
  alpha: Hp
};
function yt(u, o) {
  var r = Math.min.apply(Math, o), s = Math.max.apply(Math, o);
  return u >= r && u <= s;
}
function Np(u) {
  if (!ei.generic.test(u))
    throw new Error(u + " is not a valid hexadecimal string.");
  var o = u.split("."), r = o[0], s = o[1];
  return s ? parseInt(r, 16) + parseInt(s, 16) / Math.pow(16, s.length) : parseInt(r, 16);
}
function Vt(u, o) {
  return u.sort().toString() === o.sort().toString();
}
function xt(u) {
  return ei.color.test(u);
}
function ti(u) {
  var o = Object.keys(u);
  if (o.length !== 3 || !Vt(o, ["r", "g", "b"]))
    return !1;
  var r = function(d) {
    return typeof d == "number" && yt(d, [0, 255]);
  }, s = r(u.r), c = r(u.g), p = r(u.b);
  return s && c && p;
}
function Us(u) {
  var o = Object.keys(u);
  if (o.length !== 4 || !Vt(o, ["r", "g", "b", "a"]))
    return !1;
  var r = u.r, s = u.g, c = u.b, p = ti({ r, g: s, b: c }), d = typeof u.a == "number" && yt(u.a, [0, 1]);
  return p && d;
}
function Fs(u) {
  var o = Object.keys(u);
  if (o.length !== 4 || !Vt(o, ["c", "m", "y", "k"]))
    return !1;
  var r = function(b) {
    return typeof b == "number" && yt(b, [0, 100]);
  }, s = r(u.c), c = r(u.m), p = r(u.y), d = r(u.k);
  return s && c && p && d;
}
function Wu(u) {
  var o = Object.keys(u);
  if (o.length !== 3 || !Vt(o, ["h", "s", "l"]))
    return !1;
  var r = function(d, b) {
    return typeof d == "number" && yt(d, b);
  }, s = r(u.h, [0, 359]), c = r(u.s, [0, 100]), p = r(u.l, [0, 100]);
  return s && c && p;
}
function $p(u) {
  var o = Object.keys(u);
  if (o.length !== 4 || !Vt(o, ["h", "s", "l", "a"]))
    return !1;
  var r = u.h, s = u.s, c = u.l, p = Wu({ h: r, s, l: c }), d = typeof u.a == "number" && yt(u.a, [0, 1]);
  return p && d;
}
function Gp(u) {
  return xt(u) || ti(u) || Us(u) || Fs(u) || Wu(u) || $p(u);
}
var Kt = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {}, Jr = { exports: {} };
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
(function(u, o) {
  (function() {
    var r, s = "4.17.21", c = 200, p = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", d = "Expected a function", b = "Invalid `variable` option passed into `_.template`", A = "__lodash_hash_undefined__", O = 500, E = "__lodash_placeholder__", C = 1, H = 2, U = 4, P = 1, Q = 2, z = 1, dn = 2, Fn = 4, fn = 8, an = 16, j = 32, Cn = 64, vn = 128, en = 256, on = 512, et = 30, $ = "...", On = 800, wn = 16, xn = 1, He = 2, jt = 3, ae = 1 / 0, jn = 9007199254740991, ii = 17976931348623157e292, tt = 0 / 0, zn = 4294967295, ui = zn - 1, At = zn >>> 1, nr = [
      ["ary", vn],
      ["bind", z],
      ["bindKey", dn],
      ["curry", fn],
      ["curryRight", an],
      ["flip", on],
      ["partial", j],
      ["partialRight", Cn],
      ["rearg", en]
    ], he = "[object Arguments]", Oe = "[object Array]", Tt = "[object AsyncFunction]", Re = "[object Boolean]", Ie = "[object Date]", er = "[object DOMException]", Ne = "[object Error]", Ot = "[object Function]", tr = "[object GeneratorFunction]", ne = "[object Map]", Rt = "[object Number]", zs = "[object Null]", ge = "[object Object]", Uu = "[object Promise]", qs = "[object Proxy]", It = "[object RegExp]", ee = "[object Set]", Et = "[object String]", rr = "[object Symbol]", Ks = "[object Undefined]", Ct = "[object WeakMap]", Xs = "[object WeakSet]", St = "[object ArrayBuffer]", rt = "[object DataView]", ai = "[object Float32Array]", oi = "[object Float64Array]", si = "[object Int8Array]", fi = "[object Int16Array]", li = "[object Int32Array]", ci = "[object Uint8Array]", hi = "[object Uint8ClampedArray]", gi = "[object Uint16Array]", pi = "[object Uint32Array]", Ys = /\b__p \+= '';/g, Zs = /\b(__p \+=) '' \+/g, Js = /(__e\(.*?\)|\b__t\)) \+\n'';/g, Fu = /&(?:amp|lt|gt|quot|#39);/g, Du = /[&<>"']/g, Vs = RegExp(Fu.source), Qs = RegExp(Du.source), js = /<%-([\s\S]+?)%>/g, nf = /<%([\s\S]+?)%>/g, ku = /<%=([\s\S]+?)%>/g, ef = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, tf = /^\w*$/, rf = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, di = /[\\^$.*+?()[\]{}|]/g, uf = RegExp(di.source), vi = /^\s+/, af = /\s/, of = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, sf = /\{\n\/\* \[wrapped with (.+)\] \*/, ff = /,? & /, lf = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g, cf = /[()=,{}\[\]\/\s]/, hf = /\\(\\)?/g, gf = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g, Hu = /\w*$/, pf = /^[-+]0x[0-9a-f]+$/i, df = /^0b[01]+$/i, vf = /^\[object .+?Constructor\]$/, _f = /^0o[0-7]+$/i, mf = /^(?:0|[1-9]\d*)$/, wf = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, ir = /($^)/, bf = /['\n\r\u2028\u2029\\]/g, ur = "\\ud800-\\udfff", yf = "\\u0300-\\u036f", xf = "\\ufe20-\\ufe2f", Af = "\\u20d0-\\u20ff", Nu = yf + xf + Af, $u = "\\u2700-\\u27bf", Gu = "a-z\\xdf-\\xf6\\xf8-\\xff", Tf = "\\xac\\xb1\\xd7\\xf7", Of = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", Rf = "\\u2000-\\u206f", If = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", zu = "A-Z\\xc0-\\xd6\\xd8-\\xde", qu = "\\ufe0e\\ufe0f", Ku = Tf + Of + Rf + If, _i = "['\u2019]", Ef = "[" + ur + "]", Xu = "[" + Ku + "]", ar = "[" + Nu + "]", Yu = "\\d+", Cf = "[" + $u + "]", Zu = "[" + Gu + "]", Ju = "[^" + ur + Ku + Yu + $u + Gu + zu + "]", mi = "\\ud83c[\\udffb-\\udfff]", Sf = "(?:" + ar + "|" + mi + ")", Vu = "[^" + ur + "]", wi = "(?:\\ud83c[\\udde6-\\uddff]){2}", bi = "[\\ud800-\\udbff][\\udc00-\\udfff]", it = "[" + zu + "]", Qu = "\\u200d", ju = "(?:" + Zu + "|" + Ju + ")", Lf = "(?:" + it + "|" + Ju + ")", na = "(?:" + _i + "(?:d|ll|m|re|s|t|ve))?", ea = "(?:" + _i + "(?:D|LL|M|RE|S|T|VE))?", ta = Sf + "?", ra = "[" + qu + "]?", Pf = "(?:" + Qu + "(?:" + [Vu, wi, bi].join("|") + ")" + ra + ta + ")*", Mf = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", Bf = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", ia = ra + ta + Pf, Wf = "(?:" + [Cf, wi, bi].join("|") + ")" + ia, Uf = "(?:" + [Vu + ar + "?", ar, wi, bi, Ef].join("|") + ")", Ff = RegExp(_i, "g"), Df = RegExp(ar, "g"), yi = RegExp(mi + "(?=" + mi + ")|" + Uf + ia, "g"), kf = RegExp([
      it + "?" + Zu + "+" + na + "(?=" + [Xu, it, "$"].join("|") + ")",
      Lf + "+" + ea + "(?=" + [Xu, it + ju, "$"].join("|") + ")",
      it + "?" + ju + "+" + na,
      it + "+" + ea,
      Bf,
      Mf,
      Yu,
      Wf
    ].join("|"), "g"), Hf = RegExp("[" + Qu + ur + Nu + qu + "]"), Nf = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/, $f = [
      "Array",
      "Buffer",
      "DataView",
      "Date",
      "Error",
      "Float32Array",
      "Float64Array",
      "Function",
      "Int8Array",
      "Int16Array",
      "Int32Array",
      "Map",
      "Math",
      "Object",
      "Promise",
      "RegExp",
      "Set",
      "String",
      "Symbol",
      "TypeError",
      "Uint8Array",
      "Uint8ClampedArray",
      "Uint16Array",
      "Uint32Array",
      "WeakMap",
      "_",
      "clearTimeout",
      "isFinite",
      "parseInt",
      "setTimeout"
    ], Gf = -1, rn = {};
    rn[ai] = rn[oi] = rn[si] = rn[fi] = rn[li] = rn[ci] = rn[hi] = rn[gi] = rn[pi] = !0, rn[he] = rn[Oe] = rn[St] = rn[Re] = rn[rt] = rn[Ie] = rn[Ne] = rn[Ot] = rn[ne] = rn[Rt] = rn[ge] = rn[It] = rn[ee] = rn[Et] = rn[Ct] = !1;
    var tn = {};
    tn[he] = tn[Oe] = tn[St] = tn[rt] = tn[Re] = tn[Ie] = tn[ai] = tn[oi] = tn[si] = tn[fi] = tn[li] = tn[ne] = tn[Rt] = tn[ge] = tn[It] = tn[ee] = tn[Et] = tn[rr] = tn[ci] = tn[hi] = tn[gi] = tn[pi] = !0, tn[Ne] = tn[Ot] = tn[Ct] = !1;
    var zf = {
      \u00C0: "A",
      \u00C1: "A",
      \u00C2: "A",
      \u00C3: "A",
      \u00C4: "A",
      \u00C5: "A",
      \u00E0: "a",
      \u00E1: "a",
      \u00E2: "a",
      \u00E3: "a",
      \u00E4: "a",
      \u00E5: "a",
      \u00C7: "C",
      \u00E7: "c",
      \u00D0: "D",
      \u00F0: "d",
      \u00C8: "E",
      \u00C9: "E",
      \u00CA: "E",
      \u00CB: "E",
      \u00E8: "e",
      \u00E9: "e",
      \u00EA: "e",
      \u00EB: "e",
      \u00CC: "I",
      \u00CD: "I",
      \u00CE: "I",
      \u00CF: "I",
      \u00EC: "i",
      \u00ED: "i",
      \u00EE: "i",
      \u00EF: "i",
      \u00D1: "N",
      \u00F1: "n",
      \u00D2: "O",
      \u00D3: "O",
      \u00D4: "O",
      \u00D5: "O",
      \u00D6: "O",
      \u00D8: "O",
      \u00F2: "o",
      \u00F3: "o",
      \u00F4: "o",
      \u00F5: "o",
      \u00F6: "o",
      \u00F8: "o",
      \u00D9: "U",
      \u00DA: "U",
      \u00DB: "U",
      \u00DC: "U",
      \u00F9: "u",
      \u00FA: "u",
      \u00FB: "u",
      \u00FC: "u",
      \u00DD: "Y",
      \u00FD: "y",
      \u00FF: "y",
      \u00C6: "Ae",
      \u00E6: "ae",
      \u00DE: "Th",
      \u00FE: "th",
      \u00DF: "ss",
      \u0100: "A",
      \u0102: "A",
      \u0104: "A",
      \u0101: "a",
      \u0103: "a",
      \u0105: "a",
      \u0106: "C",
      \u0108: "C",
      \u010A: "C",
      \u010C: "C",
      \u0107: "c",
      \u0109: "c",
      \u010B: "c",
      \u010D: "c",
      \u010E: "D",
      \u0110: "D",
      \u010F: "d",
      \u0111: "d",
      \u0112: "E",
      \u0114: "E",
      \u0116: "E",
      \u0118: "E",
      \u011A: "E",
      \u0113: "e",
      \u0115: "e",
      \u0117: "e",
      \u0119: "e",
      \u011B: "e",
      \u011C: "G",
      \u011E: "G",
      \u0120: "G",
      \u0122: "G",
      \u011D: "g",
      \u011F: "g",
      \u0121: "g",
      \u0123: "g",
      \u0124: "H",
      \u0126: "H",
      \u0125: "h",
      \u0127: "h",
      \u0128: "I",
      \u012A: "I",
      \u012C: "I",
      \u012E: "I",
      \u0130: "I",
      \u0129: "i",
      \u012B: "i",
      \u012D: "i",
      \u012F: "i",
      \u0131: "i",
      \u0134: "J",
      \u0135: "j",
      \u0136: "K",
      \u0137: "k",
      \u0138: "k",
      \u0139: "L",
      \u013B: "L",
      \u013D: "L",
      \u013F: "L",
      \u0141: "L",
      \u013A: "l",
      \u013C: "l",
      \u013E: "l",
      \u0140: "l",
      \u0142: "l",
      \u0143: "N",
      \u0145: "N",
      \u0147: "N",
      \u014A: "N",
      \u0144: "n",
      \u0146: "n",
      \u0148: "n",
      \u014B: "n",
      \u014C: "O",
      \u014E: "O",
      \u0150: "O",
      \u014D: "o",
      \u014F: "o",
      \u0151: "o",
      \u0154: "R",
      \u0156: "R",
      \u0158: "R",
      \u0155: "r",
      \u0157: "r",
      \u0159: "r",
      \u015A: "S",
      \u015C: "S",
      \u015E: "S",
      \u0160: "S",
      \u015B: "s",
      \u015D: "s",
      \u015F: "s",
      \u0161: "s",
      \u0162: "T",
      \u0164: "T",
      \u0166: "T",
      \u0163: "t",
      \u0165: "t",
      \u0167: "t",
      \u0168: "U",
      \u016A: "U",
      \u016C: "U",
      \u016E: "U",
      \u0170: "U",
      \u0172: "U",
      \u0169: "u",
      \u016B: "u",
      \u016D: "u",
      \u016F: "u",
      \u0171: "u",
      \u0173: "u",
      \u0174: "W",
      \u0175: "w",
      \u0176: "Y",
      \u0177: "y",
      \u0178: "Y",
      \u0179: "Z",
      \u017B: "Z",
      \u017D: "Z",
      \u017A: "z",
      \u017C: "z",
      \u017E: "z",
      \u0132: "IJ",
      \u0133: "ij",
      \u0152: "Oe",
      \u0153: "oe",
      \u0149: "'n",
      \u017F: "s"
    }, qf = {
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;"
    }, Kf = {
      "&amp;": "&",
      "&lt;": "<",
      "&gt;": ">",
      "&quot;": '"',
      "&#39;": "'"
    }, Xf = {
      "\\": "\\",
      "'": "'",
      "\n": "n",
      "\r": "r",
      "\u2028": "u2028",
      "\u2029": "u2029"
    }, Yf = parseFloat, Zf = parseInt, ua = typeof Kt == "object" && Kt && Kt.Object === Object && Kt, Jf = typeof self == "object" && self && self.Object === Object && self, An = ua || Jf || Function("return this")(), xi = o && !o.nodeType && o, $e = xi && !0 && u && !u.nodeType && u, aa = $e && $e.exports === xi, Ai = aa && ua.process, qn = function() {
      try {
        var v = $e && $e.require && $e.require("util").types;
        return v || Ai && Ai.binding && Ai.binding("util");
      } catch {
      }
    }(), oa = qn && qn.isArrayBuffer, sa = qn && qn.isDate, fa = qn && qn.isMap, la = qn && qn.isRegExp, ca = qn && qn.isSet, ha = qn && qn.isTypedArray;
    function Dn(v, w, m) {
      switch (m.length) {
        case 0:
          return v.call(w);
        case 1:
          return v.call(w, m[0]);
        case 2:
          return v.call(w, m[0], m[1]);
        case 3:
          return v.call(w, m[0], m[1], m[2]);
      }
      return v.apply(w, m);
    }
    function Vf(v, w, m, I) {
      for (var F = -1, Y = v == null ? 0 : v.length; ++F < Y; ) {
        var _n = v[F];
        w(I, _n, m(_n), v);
      }
      return I;
    }
    function Kn(v, w) {
      for (var m = -1, I = v == null ? 0 : v.length; ++m < I && w(v[m], m, v) !== !1; )
        ;
      return v;
    }
    function Qf(v, w) {
      for (var m = v == null ? 0 : v.length; m-- && w(v[m], m, v) !== !1; )
        ;
      return v;
    }
    function ga(v, w) {
      for (var m = -1, I = v == null ? 0 : v.length; ++m < I; )
        if (!w(v[m], m, v))
          return !1;
      return !0;
    }
    function Ee(v, w) {
      for (var m = -1, I = v == null ? 0 : v.length, F = 0, Y = []; ++m < I; ) {
        var _n = v[m];
        w(_n, m, v) && (Y[F++] = _n);
      }
      return Y;
    }
    function or(v, w) {
      var m = v == null ? 0 : v.length;
      return !!m && ut(v, w, 0) > -1;
    }
    function Ti(v, w, m) {
      for (var I = -1, F = v == null ? 0 : v.length; ++I < F; )
        if (m(w, v[I]))
          return !0;
      return !1;
    }
    function un(v, w) {
      for (var m = -1, I = v == null ? 0 : v.length, F = Array(I); ++m < I; )
        F[m] = w(v[m], m, v);
      return F;
    }
    function Ce(v, w) {
      for (var m = -1, I = w.length, F = v.length; ++m < I; )
        v[F + m] = w[m];
      return v;
    }
    function Oi(v, w, m, I) {
      var F = -1, Y = v == null ? 0 : v.length;
      for (I && Y && (m = v[++F]); ++F < Y; )
        m = w(m, v[F], F, v);
      return m;
    }
    function jf(v, w, m, I) {
      var F = v == null ? 0 : v.length;
      for (I && F && (m = v[--F]); F--; )
        m = w(m, v[F], F, v);
      return m;
    }
    function Ri(v, w) {
      for (var m = -1, I = v == null ? 0 : v.length; ++m < I; )
        if (w(v[m], m, v))
          return !0;
      return !1;
    }
    var nl = Ii("length");
    function el(v) {
      return v.split("");
    }
    function tl(v) {
      return v.match(lf) || [];
    }
    function pa(v, w, m) {
      var I;
      return m(v, function(F, Y, _n) {
        if (w(F, Y, _n))
          return I = Y, !1;
      }), I;
    }
    function sr(v, w, m, I) {
      for (var F = v.length, Y = m + (I ? 1 : -1); I ? Y-- : ++Y < F; )
        if (w(v[Y], Y, v))
          return Y;
      return -1;
    }
    function ut(v, w, m) {
      return w === w ? pl(v, w, m) : sr(v, da, m);
    }
    function rl(v, w, m, I) {
      for (var F = m - 1, Y = v.length; ++F < Y; )
        if (I(v[F], w))
          return F;
      return -1;
    }
    function da(v) {
      return v !== v;
    }
    function va(v, w) {
      var m = v == null ? 0 : v.length;
      return m ? Ci(v, w) / m : tt;
    }
    function Ii(v) {
      return function(w) {
        return w == null ? r : w[v];
      };
    }
    function Ei(v) {
      return function(w) {
        return v == null ? r : v[w];
      };
    }
    function _a(v, w, m, I, F) {
      return F(v, function(Y, _n, nn) {
        m = I ? (I = !1, Y) : w(m, Y, _n, nn);
      }), m;
    }
    function il(v, w) {
      var m = v.length;
      for (v.sort(w); m--; )
        v[m] = v[m].value;
      return v;
    }
    function Ci(v, w) {
      for (var m, I = -1, F = v.length; ++I < F; ) {
        var Y = w(v[I]);
        Y !== r && (m = m === r ? Y : m + Y);
      }
      return m;
    }
    function Si(v, w) {
      for (var m = -1, I = Array(v); ++m < v; )
        I[m] = w(m);
      return I;
    }
    function ul(v, w) {
      return un(w, function(m) {
        return [m, v[m]];
      });
    }
    function ma(v) {
      return v && v.slice(0, xa(v) + 1).replace(vi, "");
    }
    function kn(v) {
      return function(w) {
        return v(w);
      };
    }
    function Li(v, w) {
      return un(w, function(m) {
        return v[m];
      });
    }
    function Lt(v, w) {
      return v.has(w);
    }
    function wa(v, w) {
      for (var m = -1, I = v.length; ++m < I && ut(w, v[m], 0) > -1; )
        ;
      return m;
    }
    function ba(v, w) {
      for (var m = v.length; m-- && ut(w, v[m], 0) > -1; )
        ;
      return m;
    }
    function al(v, w) {
      for (var m = v.length, I = 0; m--; )
        v[m] === w && ++I;
      return I;
    }
    var ol = Ei(zf), sl = Ei(qf);
    function fl(v) {
      return "\\" + Xf[v];
    }
    function ll(v, w) {
      return v == null ? r : v[w];
    }
    function at(v) {
      return Hf.test(v);
    }
    function cl(v) {
      return Nf.test(v);
    }
    function hl(v) {
      for (var w, m = []; !(w = v.next()).done; )
        m.push(w.value);
      return m;
    }
    function Pi(v) {
      var w = -1, m = Array(v.size);
      return v.forEach(function(I, F) {
        m[++w] = [F, I];
      }), m;
    }
    function ya(v, w) {
      return function(m) {
        return v(w(m));
      };
    }
    function Se(v, w) {
      for (var m = -1, I = v.length, F = 0, Y = []; ++m < I; ) {
        var _n = v[m];
        (_n === w || _n === E) && (v[m] = E, Y[F++] = m);
      }
      return Y;
    }
    function fr(v) {
      var w = -1, m = Array(v.size);
      return v.forEach(function(I) {
        m[++w] = I;
      }), m;
    }
    function gl(v) {
      var w = -1, m = Array(v.size);
      return v.forEach(function(I) {
        m[++w] = [I, I];
      }), m;
    }
    function pl(v, w, m) {
      for (var I = m - 1, F = v.length; ++I < F; )
        if (v[I] === w)
          return I;
      return -1;
    }
    function dl(v, w, m) {
      for (var I = m + 1; I--; )
        if (v[I] === w)
          return I;
      return I;
    }
    function ot(v) {
      return at(v) ? _l(v) : nl(v);
    }
    function te(v) {
      return at(v) ? ml(v) : el(v);
    }
    function xa(v) {
      for (var w = v.length; w-- && af.test(v.charAt(w)); )
        ;
      return w;
    }
    var vl = Ei(Kf);
    function _l(v) {
      for (var w = yi.lastIndex = 0; yi.test(v); )
        ++w;
      return w;
    }
    function ml(v) {
      return v.match(yi) || [];
    }
    function wl(v) {
      return v.match(kf) || [];
    }
    var bl = function v(w) {
      w = w == null ? An : st.defaults(An.Object(), w, st.pick(An, $f));
      var m = w.Array, I = w.Date, F = w.Error, Y = w.Function, _n = w.Math, nn = w.Object, Mi = w.RegExp, yl = w.String, Xn = w.TypeError, lr = m.prototype, xl = Y.prototype, ft = nn.prototype, cr = w["__core-js_shared__"], hr = xl.toString, V = ft.hasOwnProperty, Al = 0, Aa = function() {
        var n = /[^.]+$/.exec(cr && cr.keys && cr.keys.IE_PROTO || "");
        return n ? "Symbol(src)_1." + n : "";
      }(), gr = ft.toString, Tl = hr.call(nn), Ol = An._, Rl = Mi(
        "^" + hr.call(V).replace(di, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
      ), pr = aa ? w.Buffer : r, Le = w.Symbol, dr = w.Uint8Array, Ta = pr ? pr.allocUnsafe : r, vr = ya(nn.getPrototypeOf, nn), Oa = nn.create, Ra = ft.propertyIsEnumerable, _r = lr.splice, Ia = Le ? Le.isConcatSpreadable : r, Pt = Le ? Le.iterator : r, Ge = Le ? Le.toStringTag : r, mr = function() {
        try {
          var n = Ye(nn, "defineProperty");
          return n({}, "", {}), n;
        } catch {
        }
      }(), Il = w.clearTimeout !== An.clearTimeout && w.clearTimeout, El = I && I.now !== An.Date.now && I.now, Cl = w.setTimeout !== An.setTimeout && w.setTimeout, wr = _n.ceil, br = _n.floor, Bi = nn.getOwnPropertySymbols, Sl = pr ? pr.isBuffer : r, Ea = w.isFinite, Ll = lr.join, Pl = ya(nn.keys, nn), mn = _n.max, Rn = _n.min, Ml = I.now, Bl = w.parseInt, Ca = _n.random, Wl = lr.reverse, Wi = Ye(w, "DataView"), Mt = Ye(w, "Map"), Ui = Ye(w, "Promise"), lt = Ye(w, "Set"), Bt = Ye(w, "WeakMap"), Wt = Ye(nn, "create"), yr = Bt && new Bt(), ct = {}, Ul = Ze(Wi), Fl = Ze(Mt), Dl = Ze(Ui), kl = Ze(lt), Hl = Ze(Bt), xr = Le ? Le.prototype : r, Ut = xr ? xr.valueOf : r, Sa = xr ? xr.toString : r;
      function f(n) {
        if (ln(n) && !D(n) && !(n instanceof K)) {
          if (n instanceof Yn)
            return n;
          if (V.call(n, "__wrapped__"))
            return Po(n);
        }
        return new Yn(n);
      }
      var ht = function() {
        function n() {
        }
        return function(e) {
          if (!sn(e))
            return {};
          if (Oa)
            return Oa(e);
          n.prototype = e;
          var t = new n();
          return n.prototype = r, t;
        };
      }();
      function Ar() {
      }
      function Yn(n, e) {
        this.__wrapped__ = n, this.__actions__ = [], this.__chain__ = !!e, this.__index__ = 0, this.__values__ = r;
      }
      f.templateSettings = {
        escape: js,
        evaluate: nf,
        interpolate: ku,
        variable: "",
        imports: {
          _: f
        }
      }, f.prototype = Ar.prototype, f.prototype.constructor = f, Yn.prototype = ht(Ar.prototype), Yn.prototype.constructor = Yn;
      function K(n) {
        this.__wrapped__ = n, this.__actions__ = [], this.__dir__ = 1, this.__filtered__ = !1, this.__iteratees__ = [], this.__takeCount__ = zn, this.__views__ = [];
      }
      function Nl() {
        var n = new K(this.__wrapped__);
        return n.__actions__ = Mn(this.__actions__), n.__dir__ = this.__dir__, n.__filtered__ = this.__filtered__, n.__iteratees__ = Mn(this.__iteratees__), n.__takeCount__ = this.__takeCount__, n.__views__ = Mn(this.__views__), n;
      }
      function $l() {
        if (this.__filtered__) {
          var n = new K(this);
          n.__dir__ = -1, n.__filtered__ = !0;
        } else
          n = this.clone(), n.__dir__ *= -1;
        return n;
      }
      function Gl() {
        var n = this.__wrapped__.value(), e = this.__dir__, t = D(n), i = e < 0, a = t ? n.length : 0, l = eh(0, a, this.__views__), h = l.start, g = l.end, _ = g - h, y = i ? g : h - 1, x = this.__iteratees__, T = x.length, R = 0, L = Rn(_, this.__takeCount__);
        if (!t || !i && a == _ && L == _)
          return no(n, this.__actions__);
        var B = [];
        n:
          for (; _-- && R < L; ) {
            y += e;
            for (var N = -1, W = n[y]; ++N < T; ) {
              var q = x[N], X = q.iteratee, $n = q.type, Pn = X(W);
              if ($n == He)
                W = Pn;
              else if (!Pn) {
                if ($n == xn)
                  continue n;
                break n;
              }
            }
            B[R++] = W;
          }
        return B;
      }
      K.prototype = ht(Ar.prototype), K.prototype.constructor = K;
      function ze(n) {
        var e = -1, t = n == null ? 0 : n.length;
        for (this.clear(); ++e < t; ) {
          var i = n[e];
          this.set(i[0], i[1]);
        }
      }
      function zl() {
        this.__data__ = Wt ? Wt(null) : {}, this.size = 0;
      }
      function ql(n) {
        var e = this.has(n) && delete this.__data__[n];
        return this.size -= e ? 1 : 0, e;
      }
      function Kl(n) {
        var e = this.__data__;
        if (Wt) {
          var t = e[n];
          return t === A ? r : t;
        }
        return V.call(e, n) ? e[n] : r;
      }
      function Xl(n) {
        var e = this.__data__;
        return Wt ? e[n] !== r : V.call(e, n);
      }
      function Yl(n, e) {
        var t = this.__data__;
        return this.size += this.has(n) ? 0 : 1, t[n] = Wt && e === r ? A : e, this;
      }
      ze.prototype.clear = zl, ze.prototype.delete = ql, ze.prototype.get = Kl, ze.prototype.has = Xl, ze.prototype.set = Yl;
      function pe(n) {
        var e = -1, t = n == null ? 0 : n.length;
        for (this.clear(); ++e < t; ) {
          var i = n[e];
          this.set(i[0], i[1]);
        }
      }
      function Zl() {
        this.__data__ = [], this.size = 0;
      }
      function Jl(n) {
        var e = this.__data__, t = Tr(e, n);
        if (t < 0)
          return !1;
        var i = e.length - 1;
        return t == i ? e.pop() : _r.call(e, t, 1), --this.size, !0;
      }
      function Vl(n) {
        var e = this.__data__, t = Tr(e, n);
        return t < 0 ? r : e[t][1];
      }
      function Ql(n) {
        return Tr(this.__data__, n) > -1;
      }
      function jl(n, e) {
        var t = this.__data__, i = Tr(t, n);
        return i < 0 ? (++this.size, t.push([n, e])) : t[i][1] = e, this;
      }
      pe.prototype.clear = Zl, pe.prototype.delete = Jl, pe.prototype.get = Vl, pe.prototype.has = Ql, pe.prototype.set = jl;
      function de(n) {
        var e = -1, t = n == null ? 0 : n.length;
        for (this.clear(); ++e < t; ) {
          var i = n[e];
          this.set(i[0], i[1]);
        }
      }
      function nc() {
        this.size = 0, this.__data__ = {
          hash: new ze(),
          map: new (Mt || pe)(),
          string: new ze()
        };
      }
      function ec(n) {
        var e = Ur(this, n).delete(n);
        return this.size -= e ? 1 : 0, e;
      }
      function tc(n) {
        return Ur(this, n).get(n);
      }
      function rc(n) {
        return Ur(this, n).has(n);
      }
      function ic(n, e) {
        var t = Ur(this, n), i = t.size;
        return t.set(n, e), this.size += t.size == i ? 0 : 1, this;
      }
      de.prototype.clear = nc, de.prototype.delete = ec, de.prototype.get = tc, de.prototype.has = rc, de.prototype.set = ic;
      function qe(n) {
        var e = -1, t = n == null ? 0 : n.length;
        for (this.__data__ = new de(); ++e < t; )
          this.add(n[e]);
      }
      function uc(n) {
        return this.__data__.set(n, A), this;
      }
      function ac(n) {
        return this.__data__.has(n);
      }
      qe.prototype.add = qe.prototype.push = uc, qe.prototype.has = ac;
      function re(n) {
        var e = this.__data__ = new pe(n);
        this.size = e.size;
      }
      function oc() {
        this.__data__ = new pe(), this.size = 0;
      }
      function sc(n) {
        var e = this.__data__, t = e.delete(n);
        return this.size = e.size, t;
      }
      function fc(n) {
        return this.__data__.get(n);
      }
      function lc(n) {
        return this.__data__.has(n);
      }
      function cc(n, e) {
        var t = this.__data__;
        if (t instanceof pe) {
          var i = t.__data__;
          if (!Mt || i.length < c - 1)
            return i.push([n, e]), this.size = ++t.size, this;
          t = this.__data__ = new de(i);
        }
        return t.set(n, e), this.size = t.size, this;
      }
      re.prototype.clear = oc, re.prototype.delete = sc, re.prototype.get = fc, re.prototype.has = lc, re.prototype.set = cc;
      function La(n, e) {
        var t = D(n), i = !t && Je(n), a = !t && !i && Ue(n), l = !t && !i && !a && vt(n), h = t || i || a || l, g = h ? Si(n.length, yl) : [], _ = g.length;
        for (var y in n)
          (e || V.call(n, y)) && !(h && (y == "length" || a && (y == "offset" || y == "parent") || l && (y == "buffer" || y == "byteLength" || y == "byteOffset") || we(y, _))) && g.push(y);
        return g;
      }
      function Pa(n) {
        var e = n.length;
        return e ? n[Xi(0, e - 1)] : r;
      }
      function hc(n, e) {
        return Fr(Mn(n), Ke(e, 0, n.length));
      }
      function gc(n) {
        return Fr(Mn(n));
      }
      function Fi(n, e, t) {
        (t !== r && !ie(n[e], t) || t === r && !(e in n)) && ve(n, e, t);
      }
      function Ft(n, e, t) {
        var i = n[e];
        (!(V.call(n, e) && ie(i, t)) || t === r && !(e in n)) && ve(n, e, t);
      }
      function Tr(n, e) {
        for (var t = n.length; t--; )
          if (ie(n[t][0], e))
            return t;
        return -1;
      }
      function pc(n, e, t, i) {
        return Pe(n, function(a, l, h) {
          e(i, a, t(a), h);
        }), i;
      }
      function Ma(n, e) {
        return n && se(e, bn(e), n);
      }
      function dc(n, e) {
        return n && se(e, Wn(e), n);
      }
      function ve(n, e, t) {
        e == "__proto__" && mr ? mr(n, e, {
          configurable: !0,
          enumerable: !0,
          value: t,
          writable: !0
        }) : n[e] = t;
      }
      function Di(n, e) {
        for (var t = -1, i = e.length, a = m(i), l = n == null; ++t < i; )
          a[t] = l ? r : mu(n, e[t]);
        return a;
      }
      function Ke(n, e, t) {
        return n === n && (t !== r && (n = n <= t ? n : t), e !== r && (n = n >= e ? n : e)), n;
      }
      function Zn(n, e, t, i, a, l) {
        var h, g = e & C, _ = e & H, y = e & U;
        if (t && (h = a ? t(n, i, a, l) : t(n)), h !== r)
          return h;
        if (!sn(n))
          return n;
        var x = D(n);
        if (x) {
          if (h = rh(n), !g)
            return Mn(n, h);
        } else {
          var T = In(n), R = T == Ot || T == tr;
          if (Ue(n))
            return ro(n, g);
          if (T == ge || T == he || R && !a) {
            if (h = _ || R ? {} : Ao(n), !g)
              return _ ? Kc(n, dc(h, n)) : qc(n, Ma(h, n));
          } else {
            if (!tn[T])
              return a ? n : {};
            h = ih(n, T, g);
          }
        }
        l || (l = new re());
        var L = l.get(n);
        if (L)
          return L;
        l.set(n, h), Qo(n) ? n.forEach(function(W) {
          h.add(Zn(W, e, t, W, n, l));
        }) : Jo(n) && n.forEach(function(W, q) {
          h.set(q, Zn(W, e, t, q, n, l));
        });
        var B = y ? _ ? iu : ru : _ ? Wn : bn, N = x ? r : B(n);
        return Kn(N || n, function(W, q) {
          N && (q = W, W = n[q]), Ft(h, q, Zn(W, e, t, q, n, l));
        }), h;
      }
      function vc(n) {
        var e = bn(n);
        return function(t) {
          return Ba(t, n, e);
        };
      }
      function Ba(n, e, t) {
        var i = t.length;
        if (n == null)
          return !i;
        for (n = nn(n); i--; ) {
          var a = t[i], l = e[a], h = n[a];
          if (h === r && !(a in n) || !l(h))
            return !1;
        }
        return !0;
      }
      function Wa(n, e, t) {
        if (typeof n != "function")
          throw new Xn(d);
        return zt(function() {
          n.apply(r, t);
        }, e);
      }
      function Dt(n, e, t, i) {
        var a = -1, l = or, h = !0, g = n.length, _ = [], y = e.length;
        if (!g)
          return _;
        t && (e = un(e, kn(t))), i ? (l = Ti, h = !1) : e.length >= c && (l = Lt, h = !1, e = new qe(e));
        n:
          for (; ++a < g; ) {
            var x = n[a], T = t == null ? x : t(x);
            if (x = i || x !== 0 ? x : 0, h && T === T) {
              for (var R = y; R--; )
                if (e[R] === T)
                  continue n;
              _.push(x);
            } else
              l(e, T, i) || _.push(x);
          }
        return _;
      }
      var Pe = so(oe), Ua = so(Hi, !0);
      function _c(n, e) {
        var t = !0;
        return Pe(n, function(i, a, l) {
          return t = !!e(i, a, l), t;
        }), t;
      }
      function Or(n, e, t) {
        for (var i = -1, a = n.length; ++i < a; ) {
          var l = n[i], h = e(l);
          if (h != null && (g === r ? h === h && !Nn(h) : t(h, g)))
            var g = h, _ = l;
        }
        return _;
      }
      function mc(n, e, t, i) {
        var a = n.length;
        for (t = k(t), t < 0 && (t = -t > a ? 0 : a + t), i = i === r || i > a ? a : k(i), i < 0 && (i += a), i = t > i ? 0 : ns(i); t < i; )
          n[t++] = e;
        return n;
      }
      function Fa(n, e) {
        var t = [];
        return Pe(n, function(i, a, l) {
          e(i, a, l) && t.push(i);
        }), t;
      }
      function Tn(n, e, t, i, a) {
        var l = -1, h = n.length;
        for (t || (t = ah), a || (a = []); ++l < h; ) {
          var g = n[l];
          e > 0 && t(g) ? e > 1 ? Tn(g, e - 1, t, i, a) : Ce(a, g) : i || (a[a.length] = g);
        }
        return a;
      }
      var ki = fo(), Da = fo(!0);
      function oe(n, e) {
        return n && ki(n, e, bn);
      }
      function Hi(n, e) {
        return n && Da(n, e, bn);
      }
      function Rr(n, e) {
        return Ee(e, function(t) {
          return be(n[t]);
        });
      }
      function Xe(n, e) {
        e = Be(e, n);
        for (var t = 0, i = e.length; n != null && t < i; )
          n = n[fe(e[t++])];
        return t && t == i ? n : r;
      }
      function ka(n, e, t) {
        var i = e(n);
        return D(n) ? i : Ce(i, t(n));
      }
      function Sn(n) {
        return n == null ? n === r ? Ks : zs : Ge && Ge in nn(n) ? nh(n) : gh(n);
      }
      function Ni(n, e) {
        return n > e;
      }
      function wc(n, e) {
        return n != null && V.call(n, e);
      }
      function bc(n, e) {
        return n != null && e in nn(n);
      }
      function yc(n, e, t) {
        return n >= Rn(e, t) && n < mn(e, t);
      }
      function $i(n, e, t) {
        for (var i = t ? Ti : or, a = n[0].length, l = n.length, h = l, g = m(l), _ = 1 / 0, y = []; h--; ) {
          var x = n[h];
          h && e && (x = un(x, kn(e))), _ = Rn(x.length, _), g[h] = !t && (e || a >= 120 && x.length >= 120) ? new qe(h && x) : r;
        }
        x = n[0];
        var T = -1, R = g[0];
        n:
          for (; ++T < a && y.length < _; ) {
            var L = x[T], B = e ? e(L) : L;
            if (L = t || L !== 0 ? L : 0, !(R ? Lt(R, B) : i(y, B, t))) {
              for (h = l; --h; ) {
                var N = g[h];
                if (!(N ? Lt(N, B) : i(n[h], B, t)))
                  continue n;
              }
              R && R.push(B), y.push(L);
            }
          }
        return y;
      }
      function xc(n, e, t, i) {
        return oe(n, function(a, l, h) {
          e(i, t(a), l, h);
        }), i;
      }
      function kt(n, e, t) {
        e = Be(e, n), n = Io(n, e);
        var i = n == null ? n : n[fe(Vn(e))];
        return i == null ? r : Dn(i, n, t);
      }
      function Ha(n) {
        return ln(n) && Sn(n) == he;
      }
      function Ac(n) {
        return ln(n) && Sn(n) == St;
      }
      function Tc(n) {
        return ln(n) && Sn(n) == Ie;
      }
      function Ht(n, e, t, i, a) {
        return n === e ? !0 : n == null || e == null || !ln(n) && !ln(e) ? n !== n && e !== e : Oc(n, e, t, i, Ht, a);
      }
      function Oc(n, e, t, i, a, l) {
        var h = D(n), g = D(e), _ = h ? Oe : In(n), y = g ? Oe : In(e);
        _ = _ == he ? ge : _, y = y == he ? ge : y;
        var x = _ == ge, T = y == ge, R = _ == y;
        if (R && Ue(n)) {
          if (!Ue(e))
            return !1;
          h = !0, x = !1;
        }
        if (R && !x)
          return l || (l = new re()), h || vt(n) ? bo(n, e, t, i, a, l) : Qc(n, e, _, t, i, a, l);
        if (!(t & P)) {
          var L = x && V.call(n, "__wrapped__"), B = T && V.call(e, "__wrapped__");
          if (L || B) {
            var N = L ? n.value() : n, W = B ? e.value() : e;
            return l || (l = new re()), a(N, W, t, i, l);
          }
        }
        return R ? (l || (l = new re()), jc(n, e, t, i, a, l)) : !1;
      }
      function Rc(n) {
        return ln(n) && In(n) == ne;
      }
      function Gi(n, e, t, i) {
        var a = t.length, l = a, h = !i;
        if (n == null)
          return !l;
        for (n = nn(n); a--; ) {
          var g = t[a];
          if (h && g[2] ? g[1] !== n[g[0]] : !(g[0] in n))
            return !1;
        }
        for (; ++a < l; ) {
          g = t[a];
          var _ = g[0], y = n[_], x = g[1];
          if (h && g[2]) {
            if (y === r && !(_ in n))
              return !1;
          } else {
            var T = new re();
            if (i)
              var R = i(y, x, _, n, e, T);
            if (!(R === r ? Ht(x, y, P | Q, i, T) : R))
              return !1;
          }
        }
        return !0;
      }
      function Na(n) {
        if (!sn(n) || sh(n))
          return !1;
        var e = be(n) ? Rl : vf;
        return e.test(Ze(n));
      }
      function Ic(n) {
        return ln(n) && Sn(n) == It;
      }
      function Ec(n) {
        return ln(n) && In(n) == ee;
      }
      function Cc(n) {
        return ln(n) && Gr(n.length) && !!rn[Sn(n)];
      }
      function $a(n) {
        return typeof n == "function" ? n : n == null ? Un : typeof n == "object" ? D(n) ? qa(n[0], n[1]) : za(n) : cs(n);
      }
      function zi(n) {
        if (!Gt(n))
          return Pl(n);
        var e = [];
        for (var t in nn(n))
          V.call(n, t) && t != "constructor" && e.push(t);
        return e;
      }
      function Sc(n) {
        if (!sn(n))
          return hh(n);
        var e = Gt(n), t = [];
        for (var i in n)
          i == "constructor" && (e || !V.call(n, i)) || t.push(i);
        return t;
      }
      function qi(n, e) {
        return n < e;
      }
      function Ga(n, e) {
        var t = -1, i = Bn(n) ? m(n.length) : [];
        return Pe(n, function(a, l, h) {
          i[++t] = e(a, l, h);
        }), i;
      }
      function za(n) {
        var e = au(n);
        return e.length == 1 && e[0][2] ? Oo(e[0][0], e[0][1]) : function(t) {
          return t === n || Gi(t, n, e);
        };
      }
      function qa(n, e) {
        return su(n) && To(e) ? Oo(fe(n), e) : function(t) {
          var i = mu(t, n);
          return i === r && i === e ? wu(t, n) : Ht(e, i, P | Q);
        };
      }
      function Ir(n, e, t, i, a) {
        n !== e && ki(e, function(l, h) {
          if (a || (a = new re()), sn(l))
            Lc(n, e, h, t, Ir, i, a);
          else {
            var g = i ? i(lu(n, h), l, h + "", n, e, a) : r;
            g === r && (g = l), Fi(n, h, g);
          }
        }, Wn);
      }
      function Lc(n, e, t, i, a, l, h) {
        var g = lu(n, t), _ = lu(e, t), y = h.get(_);
        if (y) {
          Fi(n, t, y);
          return;
        }
        var x = l ? l(g, _, t + "", n, e, h) : r, T = x === r;
        if (T) {
          var R = D(_), L = !R && Ue(_), B = !R && !L && vt(_);
          x = _, R || L || B ? D(g) ? x = g : cn(g) ? x = Mn(g) : L ? (T = !1, x = ro(_, !0)) : B ? (T = !1, x = io(_, !0)) : x = [] : qt(_) || Je(_) ? (x = g, Je(g) ? x = es(g) : (!sn(g) || be(g)) && (x = Ao(_))) : T = !1;
        }
        T && (h.set(_, x), a(x, _, i, l, h), h.delete(_)), Fi(n, t, x);
      }
      function Ka(n, e) {
        var t = n.length;
        if (!!t)
          return e += e < 0 ? t : 0, we(e, t) ? n[e] : r;
      }
      function Xa(n, e, t) {
        e.length ? e = un(e, function(l) {
          return D(l) ? function(h) {
            return Xe(h, l.length === 1 ? l[0] : l);
          } : l;
        }) : e = [Un];
        var i = -1;
        e = un(e, kn(M()));
        var a = Ga(n, function(l, h, g) {
          var _ = un(e, function(y) {
            return y(l);
          });
          return { criteria: _, index: ++i, value: l };
        });
        return il(a, function(l, h) {
          return zc(l, h, t);
        });
      }
      function Pc(n, e) {
        return Ya(n, e, function(t, i) {
          return wu(n, i);
        });
      }
      function Ya(n, e, t) {
        for (var i = -1, a = e.length, l = {}; ++i < a; ) {
          var h = e[i], g = Xe(n, h);
          t(g, h) && Nt(l, Be(h, n), g);
        }
        return l;
      }
      function Mc(n) {
        return function(e) {
          return Xe(e, n);
        };
      }
      function Ki(n, e, t, i) {
        var a = i ? rl : ut, l = -1, h = e.length, g = n;
        for (n === e && (e = Mn(e)), t && (g = un(n, kn(t))); ++l < h; )
          for (var _ = 0, y = e[l], x = t ? t(y) : y; (_ = a(g, x, _, i)) > -1; )
            g !== n && _r.call(g, _, 1), _r.call(n, _, 1);
        return n;
      }
      function Za(n, e) {
        for (var t = n ? e.length : 0, i = t - 1; t--; ) {
          var a = e[t];
          if (t == i || a !== l) {
            var l = a;
            we(a) ? _r.call(n, a, 1) : Ji(n, a);
          }
        }
        return n;
      }
      function Xi(n, e) {
        return n + br(Ca() * (e - n + 1));
      }
      function Bc(n, e, t, i) {
        for (var a = -1, l = mn(wr((e - n) / (t || 1)), 0), h = m(l); l--; )
          h[i ? l : ++a] = n, n += t;
        return h;
      }
      function Yi(n, e) {
        var t = "";
        if (!n || e < 1 || e > jn)
          return t;
        do
          e % 2 && (t += n), e = br(e / 2), e && (n += n);
        while (e);
        return t;
      }
      function G(n, e) {
        return cu(Ro(n, e, Un), n + "");
      }
      function Wc(n) {
        return Pa(_t(n));
      }
      function Uc(n, e) {
        var t = _t(n);
        return Fr(t, Ke(e, 0, t.length));
      }
      function Nt(n, e, t, i) {
        if (!sn(n))
          return n;
        e = Be(e, n);
        for (var a = -1, l = e.length, h = l - 1, g = n; g != null && ++a < l; ) {
          var _ = fe(e[a]), y = t;
          if (_ === "__proto__" || _ === "constructor" || _ === "prototype")
            return n;
          if (a != h) {
            var x = g[_];
            y = i ? i(x, _, g) : r, y === r && (y = sn(x) ? x : we(e[a + 1]) ? [] : {});
          }
          Ft(g, _, y), g = g[_];
        }
        return n;
      }
      var Ja = yr ? function(n, e) {
        return yr.set(n, e), n;
      } : Un, Fc = mr ? function(n, e) {
        return mr(n, "toString", {
          configurable: !0,
          enumerable: !1,
          value: yu(e),
          writable: !0
        });
      } : Un;
      function Dc(n) {
        return Fr(_t(n));
      }
      function Jn(n, e, t) {
        var i = -1, a = n.length;
        e < 0 && (e = -e > a ? 0 : a + e), t = t > a ? a : t, t < 0 && (t += a), a = e > t ? 0 : t - e >>> 0, e >>>= 0;
        for (var l = m(a); ++i < a; )
          l[i] = n[i + e];
        return l;
      }
      function kc(n, e) {
        var t;
        return Pe(n, function(i, a, l) {
          return t = e(i, a, l), !t;
        }), !!t;
      }
      function Er(n, e, t) {
        var i = 0, a = n == null ? i : n.length;
        if (typeof e == "number" && e === e && a <= At) {
          for (; i < a; ) {
            var l = i + a >>> 1, h = n[l];
            h !== null && !Nn(h) && (t ? h <= e : h < e) ? i = l + 1 : a = l;
          }
          return a;
        }
        return Zi(n, e, Un, t);
      }
      function Zi(n, e, t, i) {
        var a = 0, l = n == null ? 0 : n.length;
        if (l === 0)
          return 0;
        e = t(e);
        for (var h = e !== e, g = e === null, _ = Nn(e), y = e === r; a < l; ) {
          var x = br((a + l) / 2), T = t(n[x]), R = T !== r, L = T === null, B = T === T, N = Nn(T);
          if (h)
            var W = i || B;
          else
            y ? W = B && (i || R) : g ? W = B && R && (i || !L) : _ ? W = B && R && !L && (i || !N) : L || N ? W = !1 : W = i ? T <= e : T < e;
          W ? a = x + 1 : l = x;
        }
        return Rn(l, ui);
      }
      function Va(n, e) {
        for (var t = -1, i = n.length, a = 0, l = []; ++t < i; ) {
          var h = n[t], g = e ? e(h) : h;
          if (!t || !ie(g, _)) {
            var _ = g;
            l[a++] = h === 0 ? 0 : h;
          }
        }
        return l;
      }
      function Qa(n) {
        return typeof n == "number" ? n : Nn(n) ? tt : +n;
      }
      function Hn(n) {
        if (typeof n == "string")
          return n;
        if (D(n))
          return un(n, Hn) + "";
        if (Nn(n))
          return Sa ? Sa.call(n) : "";
        var e = n + "";
        return e == "0" && 1 / n == -ae ? "-0" : e;
      }
      function Me(n, e, t) {
        var i = -1, a = or, l = n.length, h = !0, g = [], _ = g;
        if (t)
          h = !1, a = Ti;
        else if (l >= c) {
          var y = e ? null : Jc(n);
          if (y)
            return fr(y);
          h = !1, a = Lt, _ = new qe();
        } else
          _ = e ? [] : g;
        n:
          for (; ++i < l; ) {
            var x = n[i], T = e ? e(x) : x;
            if (x = t || x !== 0 ? x : 0, h && T === T) {
              for (var R = _.length; R--; )
                if (_[R] === T)
                  continue n;
              e && _.push(T), g.push(x);
            } else
              a(_, T, t) || (_ !== g && _.push(T), g.push(x));
          }
        return g;
      }
      function Ji(n, e) {
        return e = Be(e, n), n = Io(n, e), n == null || delete n[fe(Vn(e))];
      }
      function ja(n, e, t, i) {
        return Nt(n, e, t(Xe(n, e)), i);
      }
      function Cr(n, e, t, i) {
        for (var a = n.length, l = i ? a : -1; (i ? l-- : ++l < a) && e(n[l], l, n); )
          ;
        return t ? Jn(n, i ? 0 : l, i ? l + 1 : a) : Jn(n, i ? l + 1 : 0, i ? a : l);
      }
      function no(n, e) {
        var t = n;
        return t instanceof K && (t = t.value()), Oi(e, function(i, a) {
          return a.func.apply(a.thisArg, Ce([i], a.args));
        }, t);
      }
      function Vi(n, e, t) {
        var i = n.length;
        if (i < 2)
          return i ? Me(n[0]) : [];
        for (var a = -1, l = m(i); ++a < i; )
          for (var h = n[a], g = -1; ++g < i; )
            g != a && (l[a] = Dt(l[a] || h, n[g], e, t));
        return Me(Tn(l, 1), e, t);
      }
      function eo(n, e, t) {
        for (var i = -1, a = n.length, l = e.length, h = {}; ++i < a; ) {
          var g = i < l ? e[i] : r;
          t(h, n[i], g);
        }
        return h;
      }
      function Qi(n) {
        return cn(n) ? n : [];
      }
      function ji(n) {
        return typeof n == "function" ? n : Un;
      }
      function Be(n, e) {
        return D(n) ? n : su(n, e) ? [n] : Lo(Z(n));
      }
      var Hc = G;
      function We(n, e, t) {
        var i = n.length;
        return t = t === r ? i : t, !e && t >= i ? n : Jn(n, e, t);
      }
      var to = Il || function(n) {
        return An.clearTimeout(n);
      };
      function ro(n, e) {
        if (e)
          return n.slice();
        var t = n.length, i = Ta ? Ta(t) : new n.constructor(t);
        return n.copy(i), i;
      }
      function nu(n) {
        var e = new n.constructor(n.byteLength);
        return new dr(e).set(new dr(n)), e;
      }
      function Nc(n, e) {
        var t = e ? nu(n.buffer) : n.buffer;
        return new n.constructor(t, n.byteOffset, n.byteLength);
      }
      function $c(n) {
        var e = new n.constructor(n.source, Hu.exec(n));
        return e.lastIndex = n.lastIndex, e;
      }
      function Gc(n) {
        return Ut ? nn(Ut.call(n)) : {};
      }
      function io(n, e) {
        var t = e ? nu(n.buffer) : n.buffer;
        return new n.constructor(t, n.byteOffset, n.length);
      }
      function uo(n, e) {
        if (n !== e) {
          var t = n !== r, i = n === null, a = n === n, l = Nn(n), h = e !== r, g = e === null, _ = e === e, y = Nn(e);
          if (!g && !y && !l && n > e || l && h && _ && !g && !y || i && h && _ || !t && _ || !a)
            return 1;
          if (!i && !l && !y && n < e || y && t && a && !i && !l || g && t && a || !h && a || !_)
            return -1;
        }
        return 0;
      }
      function zc(n, e, t) {
        for (var i = -1, a = n.criteria, l = e.criteria, h = a.length, g = t.length; ++i < h; ) {
          var _ = uo(a[i], l[i]);
          if (_) {
            if (i >= g)
              return _;
            var y = t[i];
            return _ * (y == "desc" ? -1 : 1);
          }
        }
        return n.index - e.index;
      }
      function ao(n, e, t, i) {
        for (var a = -1, l = n.length, h = t.length, g = -1, _ = e.length, y = mn(l - h, 0), x = m(_ + y), T = !i; ++g < _; )
          x[g] = e[g];
        for (; ++a < h; )
          (T || a < l) && (x[t[a]] = n[a]);
        for (; y--; )
          x[g++] = n[a++];
        return x;
      }
      function oo(n, e, t, i) {
        for (var a = -1, l = n.length, h = -1, g = t.length, _ = -1, y = e.length, x = mn(l - g, 0), T = m(x + y), R = !i; ++a < x; )
          T[a] = n[a];
        for (var L = a; ++_ < y; )
          T[L + _] = e[_];
        for (; ++h < g; )
          (R || a < l) && (T[L + t[h]] = n[a++]);
        return T;
      }
      function Mn(n, e) {
        var t = -1, i = n.length;
        for (e || (e = m(i)); ++t < i; )
          e[t] = n[t];
        return e;
      }
      function se(n, e, t, i) {
        var a = !t;
        t || (t = {});
        for (var l = -1, h = e.length; ++l < h; ) {
          var g = e[l], _ = i ? i(t[g], n[g], g, t, n) : r;
          _ === r && (_ = n[g]), a ? ve(t, g, _) : Ft(t, g, _);
        }
        return t;
      }
      function qc(n, e) {
        return se(n, ou(n), e);
      }
      function Kc(n, e) {
        return se(n, yo(n), e);
      }
      function Sr(n, e) {
        return function(t, i) {
          var a = D(t) ? Vf : pc, l = e ? e() : {};
          return a(t, n, M(i, 2), l);
        };
      }
      function gt(n) {
        return G(function(e, t) {
          var i = -1, a = t.length, l = a > 1 ? t[a - 1] : r, h = a > 2 ? t[2] : r;
          for (l = n.length > 3 && typeof l == "function" ? (a--, l) : r, h && Ln(t[0], t[1], h) && (l = a < 3 ? r : l, a = 1), e = nn(e); ++i < a; ) {
            var g = t[i];
            g && n(e, g, i, l);
          }
          return e;
        });
      }
      function so(n, e) {
        return function(t, i) {
          if (t == null)
            return t;
          if (!Bn(t))
            return n(t, i);
          for (var a = t.length, l = e ? a : -1, h = nn(t); (e ? l-- : ++l < a) && i(h[l], l, h) !== !1; )
            ;
          return t;
        };
      }
      function fo(n) {
        return function(e, t, i) {
          for (var a = -1, l = nn(e), h = i(e), g = h.length; g--; ) {
            var _ = h[n ? g : ++a];
            if (t(l[_], _, l) === !1)
              break;
          }
          return e;
        };
      }
      function Xc(n, e, t) {
        var i = e & z, a = $t(n);
        function l() {
          var h = this && this !== An && this instanceof l ? a : n;
          return h.apply(i ? t : this, arguments);
        }
        return l;
      }
      function lo(n) {
        return function(e) {
          e = Z(e);
          var t = at(e) ? te(e) : r, i = t ? t[0] : e.charAt(0), a = t ? We(t, 1).join("") : e.slice(1);
          return i[n]() + a;
        };
      }
      function pt(n) {
        return function(e) {
          return Oi(fs(ss(e).replace(Ff, "")), n, "");
        };
      }
      function $t(n) {
        return function() {
          var e = arguments;
          switch (e.length) {
            case 0:
              return new n();
            case 1:
              return new n(e[0]);
            case 2:
              return new n(e[0], e[1]);
            case 3:
              return new n(e[0], e[1], e[2]);
            case 4:
              return new n(e[0], e[1], e[2], e[3]);
            case 5:
              return new n(e[0], e[1], e[2], e[3], e[4]);
            case 6:
              return new n(e[0], e[1], e[2], e[3], e[4], e[5]);
            case 7:
              return new n(e[0], e[1], e[2], e[3], e[4], e[5], e[6]);
          }
          var t = ht(n.prototype), i = n.apply(t, e);
          return sn(i) ? i : t;
        };
      }
      function Yc(n, e, t) {
        var i = $t(n);
        function a() {
          for (var l = arguments.length, h = m(l), g = l, _ = dt(a); g--; )
            h[g] = arguments[g];
          var y = l < 3 && h[0] !== _ && h[l - 1] !== _ ? [] : Se(h, _);
          if (l -= y.length, l < t)
            return vo(
              n,
              e,
              Lr,
              a.placeholder,
              r,
              h,
              y,
              r,
              r,
              t - l
            );
          var x = this && this !== An && this instanceof a ? i : n;
          return Dn(x, this, h);
        }
        return a;
      }
      function co(n) {
        return function(e, t, i) {
          var a = nn(e);
          if (!Bn(e)) {
            var l = M(t, 3);
            e = bn(e), t = function(g) {
              return l(a[g], g, a);
            };
          }
          var h = n(e, t, i);
          return h > -1 ? a[l ? e[h] : h] : r;
        };
      }
      function ho(n) {
        return me(function(e) {
          var t = e.length, i = t, a = Yn.prototype.thru;
          for (n && e.reverse(); i--; ) {
            var l = e[i];
            if (typeof l != "function")
              throw new Xn(d);
            if (a && !h && Wr(l) == "wrapper")
              var h = new Yn([], !0);
          }
          for (i = h ? i : t; ++i < t; ) {
            l = e[i];
            var g = Wr(l), _ = g == "wrapper" ? uu(l) : r;
            _ && fu(_[0]) && _[1] == (vn | fn | j | en) && !_[4].length && _[9] == 1 ? h = h[Wr(_[0])].apply(h, _[3]) : h = l.length == 1 && fu(l) ? h[g]() : h.thru(l);
          }
          return function() {
            var y = arguments, x = y[0];
            if (h && y.length == 1 && D(x))
              return h.plant(x).value();
            for (var T = 0, R = t ? e[T].apply(this, y) : x; ++T < t; )
              R = e[T].call(this, R);
            return R;
          };
        });
      }
      function Lr(n, e, t, i, a, l, h, g, _, y) {
        var x = e & vn, T = e & z, R = e & dn, L = e & (fn | an), B = e & on, N = R ? r : $t(n);
        function W() {
          for (var q = arguments.length, X = m(q), $n = q; $n--; )
            X[$n] = arguments[$n];
          if (L)
            var Pn = dt(W), Gn = al(X, Pn);
          if (i && (X = ao(X, i, a, L)), l && (X = oo(X, l, h, L)), q -= Gn, L && q < y) {
            var hn = Se(X, Pn);
            return vo(
              n,
              e,
              Lr,
              W.placeholder,
              t,
              X,
              hn,
              g,
              _,
              y - q
            );
          }
          var ue = T ? t : this, xe = R ? ue[n] : n;
          return q = X.length, g ? X = ph(X, g) : B && q > 1 && X.reverse(), x && _ < q && (X.length = _), this && this !== An && this instanceof W && (xe = N || $t(xe)), xe.apply(ue, X);
        }
        return W;
      }
      function go(n, e) {
        return function(t, i) {
          return xc(t, n, e(i), {});
        };
      }
      function Pr(n, e) {
        return function(t, i) {
          var a;
          if (t === r && i === r)
            return e;
          if (t !== r && (a = t), i !== r) {
            if (a === r)
              return i;
            typeof t == "string" || typeof i == "string" ? (t = Hn(t), i = Hn(i)) : (t = Qa(t), i = Qa(i)), a = n(t, i);
          }
          return a;
        };
      }
      function eu(n) {
        return me(function(e) {
          return e = un(e, kn(M())), G(function(t) {
            var i = this;
            return n(e, function(a) {
              return Dn(a, i, t);
            });
          });
        });
      }
      function Mr(n, e) {
        e = e === r ? " " : Hn(e);
        var t = e.length;
        if (t < 2)
          return t ? Yi(e, n) : e;
        var i = Yi(e, wr(n / ot(e)));
        return at(e) ? We(te(i), 0, n).join("") : i.slice(0, n);
      }
      function Zc(n, e, t, i) {
        var a = e & z, l = $t(n);
        function h() {
          for (var g = -1, _ = arguments.length, y = -1, x = i.length, T = m(x + _), R = this && this !== An && this instanceof h ? l : n; ++y < x; )
            T[y] = i[y];
          for (; _--; )
            T[y++] = arguments[++g];
          return Dn(R, a ? t : this, T);
        }
        return h;
      }
      function po(n) {
        return function(e, t, i) {
          return i && typeof i != "number" && Ln(e, t, i) && (t = i = r), e = ye(e), t === r ? (t = e, e = 0) : t = ye(t), i = i === r ? e < t ? 1 : -1 : ye(i), Bc(e, t, i, n);
        };
      }
      function Br(n) {
        return function(e, t) {
          return typeof e == "string" && typeof t == "string" || (e = Qn(e), t = Qn(t)), n(e, t);
        };
      }
      function vo(n, e, t, i, a, l, h, g, _, y) {
        var x = e & fn, T = x ? h : r, R = x ? r : h, L = x ? l : r, B = x ? r : l;
        e |= x ? j : Cn, e &= ~(x ? Cn : j), e & Fn || (e &= ~(z | dn));
        var N = [
          n,
          e,
          a,
          L,
          T,
          B,
          R,
          g,
          _,
          y
        ], W = t.apply(r, N);
        return fu(n) && Eo(W, N), W.placeholder = i, Co(W, n, e);
      }
      function tu(n) {
        var e = _n[n];
        return function(t, i) {
          if (t = Qn(t), i = i == null ? 0 : Rn(k(i), 292), i && Ea(t)) {
            var a = (Z(t) + "e").split("e"), l = e(a[0] + "e" + (+a[1] + i));
            return a = (Z(l) + "e").split("e"), +(a[0] + "e" + (+a[1] - i));
          }
          return e(t);
        };
      }
      var Jc = lt && 1 / fr(new lt([, -0]))[1] == ae ? function(n) {
        return new lt(n);
      } : Tu;
      function _o(n) {
        return function(e) {
          var t = In(e);
          return t == ne ? Pi(e) : t == ee ? gl(e) : ul(e, n(e));
        };
      }
      function _e(n, e, t, i, a, l, h, g) {
        var _ = e & dn;
        if (!_ && typeof n != "function")
          throw new Xn(d);
        var y = i ? i.length : 0;
        if (y || (e &= ~(j | Cn), i = a = r), h = h === r ? h : mn(k(h), 0), g = g === r ? g : k(g), y -= a ? a.length : 0, e & Cn) {
          var x = i, T = a;
          i = a = r;
        }
        var R = _ ? r : uu(n), L = [
          n,
          e,
          t,
          i,
          a,
          x,
          T,
          l,
          h,
          g
        ];
        if (R && ch(L, R), n = L[0], e = L[1], t = L[2], i = L[3], a = L[4], g = L[9] = L[9] === r ? _ ? 0 : n.length : mn(L[9] - y, 0), !g && e & (fn | an) && (e &= ~(fn | an)), !e || e == z)
          var B = Xc(n, e, t);
        else
          e == fn || e == an ? B = Yc(n, e, g) : (e == j || e == (z | j)) && !a.length ? B = Zc(n, e, t, i) : B = Lr.apply(r, L);
        var N = R ? Ja : Eo;
        return Co(N(B, L), n, e);
      }
      function mo(n, e, t, i) {
        return n === r || ie(n, ft[t]) && !V.call(i, t) ? e : n;
      }
      function wo(n, e, t, i, a, l) {
        return sn(n) && sn(e) && (l.set(e, n), Ir(n, e, r, wo, l), l.delete(e)), n;
      }
      function Vc(n) {
        return qt(n) ? r : n;
      }
      function bo(n, e, t, i, a, l) {
        var h = t & P, g = n.length, _ = e.length;
        if (g != _ && !(h && _ > g))
          return !1;
        var y = l.get(n), x = l.get(e);
        if (y && x)
          return y == e && x == n;
        var T = -1, R = !0, L = t & Q ? new qe() : r;
        for (l.set(n, e), l.set(e, n); ++T < g; ) {
          var B = n[T], N = e[T];
          if (i)
            var W = h ? i(N, B, T, e, n, l) : i(B, N, T, n, e, l);
          if (W !== r) {
            if (W)
              continue;
            R = !1;
            break;
          }
          if (L) {
            if (!Ri(e, function(q, X) {
              if (!Lt(L, X) && (B === q || a(B, q, t, i, l)))
                return L.push(X);
            })) {
              R = !1;
              break;
            }
          } else if (!(B === N || a(B, N, t, i, l))) {
            R = !1;
            break;
          }
        }
        return l.delete(n), l.delete(e), R;
      }
      function Qc(n, e, t, i, a, l, h) {
        switch (t) {
          case rt:
            if (n.byteLength != e.byteLength || n.byteOffset != e.byteOffset)
              return !1;
            n = n.buffer, e = e.buffer;
          case St:
            return !(n.byteLength != e.byteLength || !l(new dr(n), new dr(e)));
          case Re:
          case Ie:
          case Rt:
            return ie(+n, +e);
          case Ne:
            return n.name == e.name && n.message == e.message;
          case It:
          case Et:
            return n == e + "";
          case ne:
            var g = Pi;
          case ee:
            var _ = i & P;
            if (g || (g = fr), n.size != e.size && !_)
              return !1;
            var y = h.get(n);
            if (y)
              return y == e;
            i |= Q, h.set(n, e);
            var x = bo(g(n), g(e), i, a, l, h);
            return h.delete(n), x;
          case rr:
            if (Ut)
              return Ut.call(n) == Ut.call(e);
        }
        return !1;
      }
      function jc(n, e, t, i, a, l) {
        var h = t & P, g = ru(n), _ = g.length, y = ru(e), x = y.length;
        if (_ != x && !h)
          return !1;
        for (var T = _; T--; ) {
          var R = g[T];
          if (!(h ? R in e : V.call(e, R)))
            return !1;
        }
        var L = l.get(n), B = l.get(e);
        if (L && B)
          return L == e && B == n;
        var N = !0;
        l.set(n, e), l.set(e, n);
        for (var W = h; ++T < _; ) {
          R = g[T];
          var q = n[R], X = e[R];
          if (i)
            var $n = h ? i(X, q, R, e, n, l) : i(q, X, R, n, e, l);
          if (!($n === r ? q === X || a(q, X, t, i, l) : $n)) {
            N = !1;
            break;
          }
          W || (W = R == "constructor");
        }
        if (N && !W) {
          var Pn = n.constructor, Gn = e.constructor;
          Pn != Gn && "constructor" in n && "constructor" in e && !(typeof Pn == "function" && Pn instanceof Pn && typeof Gn == "function" && Gn instanceof Gn) && (N = !1);
        }
        return l.delete(n), l.delete(e), N;
      }
      function me(n) {
        return cu(Ro(n, r, Wo), n + "");
      }
      function ru(n) {
        return ka(n, bn, ou);
      }
      function iu(n) {
        return ka(n, Wn, yo);
      }
      var uu = yr ? function(n) {
        return yr.get(n);
      } : Tu;
      function Wr(n) {
        for (var e = n.name + "", t = ct[e], i = V.call(ct, e) ? t.length : 0; i--; ) {
          var a = t[i], l = a.func;
          if (l == null || l == n)
            return a.name;
        }
        return e;
      }
      function dt(n) {
        var e = V.call(f, "placeholder") ? f : n;
        return e.placeholder;
      }
      function M() {
        var n = f.iteratee || xu;
        return n = n === xu ? $a : n, arguments.length ? n(arguments[0], arguments[1]) : n;
      }
      function Ur(n, e) {
        var t = n.__data__;
        return oh(e) ? t[typeof e == "string" ? "string" : "hash"] : t.map;
      }
      function au(n) {
        for (var e = bn(n), t = e.length; t--; ) {
          var i = e[t], a = n[i];
          e[t] = [i, a, To(a)];
        }
        return e;
      }
      function Ye(n, e) {
        var t = ll(n, e);
        return Na(t) ? t : r;
      }
      function nh(n) {
        var e = V.call(n, Ge), t = n[Ge];
        try {
          n[Ge] = r;
          var i = !0;
        } catch {
        }
        var a = gr.call(n);
        return i && (e ? n[Ge] = t : delete n[Ge]), a;
      }
      var ou = Bi ? function(n) {
        return n == null ? [] : (n = nn(n), Ee(Bi(n), function(e) {
          return Ra.call(n, e);
        }));
      } : Ou, yo = Bi ? function(n) {
        for (var e = []; n; )
          Ce(e, ou(n)), n = vr(n);
        return e;
      } : Ou, In = Sn;
      (Wi && In(new Wi(new ArrayBuffer(1))) != rt || Mt && In(new Mt()) != ne || Ui && In(Ui.resolve()) != Uu || lt && In(new lt()) != ee || Bt && In(new Bt()) != Ct) && (In = function(n) {
        var e = Sn(n), t = e == ge ? n.constructor : r, i = t ? Ze(t) : "";
        if (i)
          switch (i) {
            case Ul:
              return rt;
            case Fl:
              return ne;
            case Dl:
              return Uu;
            case kl:
              return ee;
            case Hl:
              return Ct;
          }
        return e;
      });
      function eh(n, e, t) {
        for (var i = -1, a = t.length; ++i < a; ) {
          var l = t[i], h = l.size;
          switch (l.type) {
            case "drop":
              n += h;
              break;
            case "dropRight":
              e -= h;
              break;
            case "take":
              e = Rn(e, n + h);
              break;
            case "takeRight":
              n = mn(n, e - h);
              break;
          }
        }
        return { start: n, end: e };
      }
      function th(n) {
        var e = n.match(sf);
        return e ? e[1].split(ff) : [];
      }
      function xo(n, e, t) {
        e = Be(e, n);
        for (var i = -1, a = e.length, l = !1; ++i < a; ) {
          var h = fe(e[i]);
          if (!(l = n != null && t(n, h)))
            break;
          n = n[h];
        }
        return l || ++i != a ? l : (a = n == null ? 0 : n.length, !!a && Gr(a) && we(h, a) && (D(n) || Je(n)));
      }
      function rh(n) {
        var e = n.length, t = new n.constructor(e);
        return e && typeof n[0] == "string" && V.call(n, "index") && (t.index = n.index, t.input = n.input), t;
      }
      function Ao(n) {
        return typeof n.constructor == "function" && !Gt(n) ? ht(vr(n)) : {};
      }
      function ih(n, e, t) {
        var i = n.constructor;
        switch (e) {
          case St:
            return nu(n);
          case Re:
          case Ie:
            return new i(+n);
          case rt:
            return Nc(n, t);
          case ai:
          case oi:
          case si:
          case fi:
          case li:
          case ci:
          case hi:
          case gi:
          case pi:
            return io(n, t);
          case ne:
            return new i();
          case Rt:
          case Et:
            return new i(n);
          case It:
            return $c(n);
          case ee:
            return new i();
          case rr:
            return Gc(n);
        }
      }
      function uh(n, e) {
        var t = e.length;
        if (!t)
          return n;
        var i = t - 1;
        return e[i] = (t > 1 ? "& " : "") + e[i], e = e.join(t > 2 ? ", " : " "), n.replace(of, `{
/* [wrapped with ` + e + `] */
`);
      }
      function ah(n) {
        return D(n) || Je(n) || !!(Ia && n && n[Ia]);
      }
      function we(n, e) {
        var t = typeof n;
        return e = e == null ? jn : e, !!e && (t == "number" || t != "symbol" && mf.test(n)) && n > -1 && n % 1 == 0 && n < e;
      }
      function Ln(n, e, t) {
        if (!sn(t))
          return !1;
        var i = typeof e;
        return (i == "number" ? Bn(t) && we(e, t.length) : i == "string" && e in t) ? ie(t[e], n) : !1;
      }
      function su(n, e) {
        if (D(n))
          return !1;
        var t = typeof n;
        return t == "number" || t == "symbol" || t == "boolean" || n == null || Nn(n) ? !0 : tf.test(n) || !ef.test(n) || e != null && n in nn(e);
      }
      function oh(n) {
        var e = typeof n;
        return e == "string" || e == "number" || e == "symbol" || e == "boolean" ? n !== "__proto__" : n === null;
      }
      function fu(n) {
        var e = Wr(n), t = f[e];
        if (typeof t != "function" || !(e in K.prototype))
          return !1;
        if (n === t)
          return !0;
        var i = uu(t);
        return !!i && n === i[0];
      }
      function sh(n) {
        return !!Aa && Aa in n;
      }
      var fh = cr ? be : Ru;
      function Gt(n) {
        var e = n && n.constructor, t = typeof e == "function" && e.prototype || ft;
        return n === t;
      }
      function To(n) {
        return n === n && !sn(n);
      }
      function Oo(n, e) {
        return function(t) {
          return t == null ? !1 : t[n] === e && (e !== r || n in nn(t));
        };
      }
      function lh(n) {
        var e = Nr(n, function(i) {
          return t.size === O && t.clear(), i;
        }), t = e.cache;
        return e;
      }
      function ch(n, e) {
        var t = n[1], i = e[1], a = t | i, l = a < (z | dn | vn), h = i == vn && t == fn || i == vn && t == en && n[7].length <= e[8] || i == (vn | en) && e[7].length <= e[8] && t == fn;
        if (!(l || h))
          return n;
        i & z && (n[2] = e[2], a |= t & z ? 0 : Fn);
        var g = e[3];
        if (g) {
          var _ = n[3];
          n[3] = _ ? ao(_, g, e[4]) : g, n[4] = _ ? Se(n[3], E) : e[4];
        }
        return g = e[5], g && (_ = n[5], n[5] = _ ? oo(_, g, e[6]) : g, n[6] = _ ? Se(n[5], E) : e[6]), g = e[7], g && (n[7] = g), i & vn && (n[8] = n[8] == null ? e[8] : Rn(n[8], e[8])), n[9] == null && (n[9] = e[9]), n[0] = e[0], n[1] = a, n;
      }
      function hh(n) {
        var e = [];
        if (n != null)
          for (var t in nn(n))
            e.push(t);
        return e;
      }
      function gh(n) {
        return gr.call(n);
      }
      function Ro(n, e, t) {
        return e = mn(e === r ? n.length - 1 : e, 0), function() {
          for (var i = arguments, a = -1, l = mn(i.length - e, 0), h = m(l); ++a < l; )
            h[a] = i[e + a];
          a = -1;
          for (var g = m(e + 1); ++a < e; )
            g[a] = i[a];
          return g[e] = t(h), Dn(n, this, g);
        };
      }
      function Io(n, e) {
        return e.length < 2 ? n : Xe(n, Jn(e, 0, -1));
      }
      function ph(n, e) {
        for (var t = n.length, i = Rn(e.length, t), a = Mn(n); i--; ) {
          var l = e[i];
          n[i] = we(l, t) ? a[l] : r;
        }
        return n;
      }
      function lu(n, e) {
        if (!(e === "constructor" && typeof n[e] == "function") && e != "__proto__")
          return n[e];
      }
      var Eo = So(Ja), zt = Cl || function(n, e) {
        return An.setTimeout(n, e);
      }, cu = So(Fc);
      function Co(n, e, t) {
        var i = e + "";
        return cu(n, uh(i, dh(th(i), t)));
      }
      function So(n) {
        var e = 0, t = 0;
        return function() {
          var i = Ml(), a = wn - (i - t);
          if (t = i, a > 0) {
            if (++e >= On)
              return arguments[0];
          } else
            e = 0;
          return n.apply(r, arguments);
        };
      }
      function Fr(n, e) {
        var t = -1, i = n.length, a = i - 1;
        for (e = e === r ? i : e; ++t < e; ) {
          var l = Xi(t, a), h = n[l];
          n[l] = n[t], n[t] = h;
        }
        return n.length = e, n;
      }
      var Lo = lh(function(n) {
        var e = [];
        return n.charCodeAt(0) === 46 && e.push(""), n.replace(rf, function(t, i, a, l) {
          e.push(a ? l.replace(hf, "$1") : i || t);
        }), e;
      });
      function fe(n) {
        if (typeof n == "string" || Nn(n))
          return n;
        var e = n + "";
        return e == "0" && 1 / n == -ae ? "-0" : e;
      }
      function Ze(n) {
        if (n != null) {
          try {
            return hr.call(n);
          } catch {
          }
          try {
            return n + "";
          } catch {
          }
        }
        return "";
      }
      function dh(n, e) {
        return Kn(nr, function(t) {
          var i = "_." + t[0];
          e & t[1] && !or(n, i) && n.push(i);
        }), n.sort();
      }
      function Po(n) {
        if (n instanceof K)
          return n.clone();
        var e = new Yn(n.__wrapped__, n.__chain__);
        return e.__actions__ = Mn(n.__actions__), e.__index__ = n.__index__, e.__values__ = n.__values__, e;
      }
      function vh(n, e, t) {
        (t ? Ln(n, e, t) : e === r) ? e = 1 : e = mn(k(e), 0);
        var i = n == null ? 0 : n.length;
        if (!i || e < 1)
          return [];
        for (var a = 0, l = 0, h = m(wr(i / e)); a < i; )
          h[l++] = Jn(n, a, a += e);
        return h;
      }
      function _h(n) {
        for (var e = -1, t = n == null ? 0 : n.length, i = 0, a = []; ++e < t; ) {
          var l = n[e];
          l && (a[i++] = l);
        }
        return a;
      }
      function mh() {
        var n = arguments.length;
        if (!n)
          return [];
        for (var e = m(n - 1), t = arguments[0], i = n; i--; )
          e[i - 1] = arguments[i];
        return Ce(D(t) ? Mn(t) : [t], Tn(e, 1));
      }
      var wh = G(function(n, e) {
        return cn(n) ? Dt(n, Tn(e, 1, cn, !0)) : [];
      }), bh = G(function(n, e) {
        var t = Vn(e);
        return cn(t) && (t = r), cn(n) ? Dt(n, Tn(e, 1, cn, !0), M(t, 2)) : [];
      }), yh = G(function(n, e) {
        var t = Vn(e);
        return cn(t) && (t = r), cn(n) ? Dt(n, Tn(e, 1, cn, !0), r, t) : [];
      });
      function xh(n, e, t) {
        var i = n == null ? 0 : n.length;
        return i ? (e = t || e === r ? 1 : k(e), Jn(n, e < 0 ? 0 : e, i)) : [];
      }
      function Ah(n, e, t) {
        var i = n == null ? 0 : n.length;
        return i ? (e = t || e === r ? 1 : k(e), e = i - e, Jn(n, 0, e < 0 ? 0 : e)) : [];
      }
      function Th(n, e) {
        return n && n.length ? Cr(n, M(e, 3), !0, !0) : [];
      }
      function Oh(n, e) {
        return n && n.length ? Cr(n, M(e, 3), !0) : [];
      }
      function Rh(n, e, t, i) {
        var a = n == null ? 0 : n.length;
        return a ? (t && typeof t != "number" && Ln(n, e, t) && (t = 0, i = a), mc(n, e, t, i)) : [];
      }
      function Mo(n, e, t) {
        var i = n == null ? 0 : n.length;
        if (!i)
          return -1;
        var a = t == null ? 0 : k(t);
        return a < 0 && (a = mn(i + a, 0)), sr(n, M(e, 3), a);
      }
      function Bo(n, e, t) {
        var i = n == null ? 0 : n.length;
        if (!i)
          return -1;
        var a = i - 1;
        return t !== r && (a = k(t), a = t < 0 ? mn(i + a, 0) : Rn(a, i - 1)), sr(n, M(e, 3), a, !0);
      }
      function Wo(n) {
        var e = n == null ? 0 : n.length;
        return e ? Tn(n, 1) : [];
      }
      function Ih(n) {
        var e = n == null ? 0 : n.length;
        return e ? Tn(n, ae) : [];
      }
      function Eh(n, e) {
        var t = n == null ? 0 : n.length;
        return t ? (e = e === r ? 1 : k(e), Tn(n, e)) : [];
      }
      function Ch(n) {
        for (var e = -1, t = n == null ? 0 : n.length, i = {}; ++e < t; ) {
          var a = n[e];
          i[a[0]] = a[1];
        }
        return i;
      }
      function Uo(n) {
        return n && n.length ? n[0] : r;
      }
      function Sh(n, e, t) {
        var i = n == null ? 0 : n.length;
        if (!i)
          return -1;
        var a = t == null ? 0 : k(t);
        return a < 0 && (a = mn(i + a, 0)), ut(n, e, a);
      }
      function Lh(n) {
        var e = n == null ? 0 : n.length;
        return e ? Jn(n, 0, -1) : [];
      }
      var Ph = G(function(n) {
        var e = un(n, Qi);
        return e.length && e[0] === n[0] ? $i(e) : [];
      }), Mh = G(function(n) {
        var e = Vn(n), t = un(n, Qi);
        return e === Vn(t) ? e = r : t.pop(), t.length && t[0] === n[0] ? $i(t, M(e, 2)) : [];
      }), Bh = G(function(n) {
        var e = Vn(n), t = un(n, Qi);
        return e = typeof e == "function" ? e : r, e && t.pop(), t.length && t[0] === n[0] ? $i(t, r, e) : [];
      });
      function Wh(n, e) {
        return n == null ? "" : Ll.call(n, e);
      }
      function Vn(n) {
        var e = n == null ? 0 : n.length;
        return e ? n[e - 1] : r;
      }
      function Uh(n, e, t) {
        var i = n == null ? 0 : n.length;
        if (!i)
          return -1;
        var a = i;
        return t !== r && (a = k(t), a = a < 0 ? mn(i + a, 0) : Rn(a, i - 1)), e === e ? dl(n, e, a) : sr(n, da, a, !0);
      }
      function Fh(n, e) {
        return n && n.length ? Ka(n, k(e)) : r;
      }
      var Dh = G(Fo);
      function Fo(n, e) {
        return n && n.length && e && e.length ? Ki(n, e) : n;
      }
      function kh(n, e, t) {
        return n && n.length && e && e.length ? Ki(n, e, M(t, 2)) : n;
      }
      function Hh(n, e, t) {
        return n && n.length && e && e.length ? Ki(n, e, r, t) : n;
      }
      var Nh = me(function(n, e) {
        var t = n == null ? 0 : n.length, i = Di(n, e);
        return Za(n, un(e, function(a) {
          return we(a, t) ? +a : a;
        }).sort(uo)), i;
      });
      function $h(n, e) {
        var t = [];
        if (!(n && n.length))
          return t;
        var i = -1, a = [], l = n.length;
        for (e = M(e, 3); ++i < l; ) {
          var h = n[i];
          e(h, i, n) && (t.push(h), a.push(i));
        }
        return Za(n, a), t;
      }
      function hu(n) {
        return n == null ? n : Wl.call(n);
      }
      function Gh(n, e, t) {
        var i = n == null ? 0 : n.length;
        return i ? (t && typeof t != "number" && Ln(n, e, t) ? (e = 0, t = i) : (e = e == null ? 0 : k(e), t = t === r ? i : k(t)), Jn(n, e, t)) : [];
      }
      function zh(n, e) {
        return Er(n, e);
      }
      function qh(n, e, t) {
        return Zi(n, e, M(t, 2));
      }
      function Kh(n, e) {
        var t = n == null ? 0 : n.length;
        if (t) {
          var i = Er(n, e);
          if (i < t && ie(n[i], e))
            return i;
        }
        return -1;
      }
      function Xh(n, e) {
        return Er(n, e, !0);
      }
      function Yh(n, e, t) {
        return Zi(n, e, M(t, 2), !0);
      }
      function Zh(n, e) {
        var t = n == null ? 0 : n.length;
        if (t) {
          var i = Er(n, e, !0) - 1;
          if (ie(n[i], e))
            return i;
        }
        return -1;
      }
      function Jh(n) {
        return n && n.length ? Va(n) : [];
      }
      function Vh(n, e) {
        return n && n.length ? Va(n, M(e, 2)) : [];
      }
      function Qh(n) {
        var e = n == null ? 0 : n.length;
        return e ? Jn(n, 1, e) : [];
      }
      function jh(n, e, t) {
        return n && n.length ? (e = t || e === r ? 1 : k(e), Jn(n, 0, e < 0 ? 0 : e)) : [];
      }
      function n0(n, e, t) {
        var i = n == null ? 0 : n.length;
        return i ? (e = t || e === r ? 1 : k(e), e = i - e, Jn(n, e < 0 ? 0 : e, i)) : [];
      }
      function e0(n, e) {
        return n && n.length ? Cr(n, M(e, 3), !1, !0) : [];
      }
      function t0(n, e) {
        return n && n.length ? Cr(n, M(e, 3)) : [];
      }
      var r0 = G(function(n) {
        return Me(Tn(n, 1, cn, !0));
      }), i0 = G(function(n) {
        var e = Vn(n);
        return cn(e) && (e = r), Me(Tn(n, 1, cn, !0), M(e, 2));
      }), u0 = G(function(n) {
        var e = Vn(n);
        return e = typeof e == "function" ? e : r, Me(Tn(n, 1, cn, !0), r, e);
      });
      function a0(n) {
        return n && n.length ? Me(n) : [];
      }
      function o0(n, e) {
        return n && n.length ? Me(n, M(e, 2)) : [];
      }
      function s0(n, e) {
        return e = typeof e == "function" ? e : r, n && n.length ? Me(n, r, e) : [];
      }
      function gu(n) {
        if (!(n && n.length))
          return [];
        var e = 0;
        return n = Ee(n, function(t) {
          if (cn(t))
            return e = mn(t.length, e), !0;
        }), Si(e, function(t) {
          return un(n, Ii(t));
        });
      }
      function Do(n, e) {
        if (!(n && n.length))
          return [];
        var t = gu(n);
        return e == null ? t : un(t, function(i) {
          return Dn(e, r, i);
        });
      }
      var f0 = G(function(n, e) {
        return cn(n) ? Dt(n, e) : [];
      }), l0 = G(function(n) {
        return Vi(Ee(n, cn));
      }), c0 = G(function(n) {
        var e = Vn(n);
        return cn(e) && (e = r), Vi(Ee(n, cn), M(e, 2));
      }), h0 = G(function(n) {
        var e = Vn(n);
        return e = typeof e == "function" ? e : r, Vi(Ee(n, cn), r, e);
      }), g0 = G(gu);
      function p0(n, e) {
        return eo(n || [], e || [], Ft);
      }
      function d0(n, e) {
        return eo(n || [], e || [], Nt);
      }
      var v0 = G(function(n) {
        var e = n.length, t = e > 1 ? n[e - 1] : r;
        return t = typeof t == "function" ? (n.pop(), t) : r, Do(n, t);
      });
      function ko(n) {
        var e = f(n);
        return e.__chain__ = !0, e;
      }
      function _0(n, e) {
        return e(n), n;
      }
      function Dr(n, e) {
        return e(n);
      }
      var m0 = me(function(n) {
        var e = n.length, t = e ? n[0] : 0, i = this.__wrapped__, a = function(l) {
          return Di(l, n);
        };
        return e > 1 || this.__actions__.length || !(i instanceof K) || !we(t) ? this.thru(a) : (i = i.slice(t, +t + (e ? 1 : 0)), i.__actions__.push({
          func: Dr,
          args: [a],
          thisArg: r
        }), new Yn(i, this.__chain__).thru(function(l) {
          return e && !l.length && l.push(r), l;
        }));
      });
      function w0() {
        return ko(this);
      }
      function b0() {
        return new Yn(this.value(), this.__chain__);
      }
      function y0() {
        this.__values__ === r && (this.__values__ = jo(this.value()));
        var n = this.__index__ >= this.__values__.length, e = n ? r : this.__values__[this.__index__++];
        return { done: n, value: e };
      }
      function x0() {
        return this;
      }
      function A0(n) {
        for (var e, t = this; t instanceof Ar; ) {
          var i = Po(t);
          i.__index__ = 0, i.__values__ = r, e ? a.__wrapped__ = i : e = i;
          var a = i;
          t = t.__wrapped__;
        }
        return a.__wrapped__ = n, e;
      }
      function T0() {
        var n = this.__wrapped__;
        if (n instanceof K) {
          var e = n;
          return this.__actions__.length && (e = new K(this)), e = e.reverse(), e.__actions__.push({
            func: Dr,
            args: [hu],
            thisArg: r
          }), new Yn(e, this.__chain__);
        }
        return this.thru(hu);
      }
      function O0() {
        return no(this.__wrapped__, this.__actions__);
      }
      var R0 = Sr(function(n, e, t) {
        V.call(n, t) ? ++n[t] : ve(n, t, 1);
      });
      function I0(n, e, t) {
        var i = D(n) ? ga : _c;
        return t && Ln(n, e, t) && (e = r), i(n, M(e, 3));
      }
      function E0(n, e) {
        var t = D(n) ? Ee : Fa;
        return t(n, M(e, 3));
      }
      var C0 = co(Mo), S0 = co(Bo);
      function L0(n, e) {
        return Tn(kr(n, e), 1);
      }
      function P0(n, e) {
        return Tn(kr(n, e), ae);
      }
      function M0(n, e, t) {
        return t = t === r ? 1 : k(t), Tn(kr(n, e), t);
      }
      function Ho(n, e) {
        var t = D(n) ? Kn : Pe;
        return t(n, M(e, 3));
      }
      function No(n, e) {
        var t = D(n) ? Qf : Ua;
        return t(n, M(e, 3));
      }
      var B0 = Sr(function(n, e, t) {
        V.call(n, t) ? n[t].push(e) : ve(n, t, [e]);
      });
      function W0(n, e, t, i) {
        n = Bn(n) ? n : _t(n), t = t && !i ? k(t) : 0;
        var a = n.length;
        return t < 0 && (t = mn(a + t, 0)), zr(n) ? t <= a && n.indexOf(e, t) > -1 : !!a && ut(n, e, t) > -1;
      }
      var U0 = G(function(n, e, t) {
        var i = -1, a = typeof e == "function", l = Bn(n) ? m(n.length) : [];
        return Pe(n, function(h) {
          l[++i] = a ? Dn(e, h, t) : kt(h, e, t);
        }), l;
      }), F0 = Sr(function(n, e, t) {
        ve(n, t, e);
      });
      function kr(n, e) {
        var t = D(n) ? un : Ga;
        return t(n, M(e, 3));
      }
      function D0(n, e, t, i) {
        return n == null ? [] : (D(e) || (e = e == null ? [] : [e]), t = i ? r : t, D(t) || (t = t == null ? [] : [t]), Xa(n, e, t));
      }
      var k0 = Sr(function(n, e, t) {
        n[t ? 0 : 1].push(e);
      }, function() {
        return [[], []];
      });
      function H0(n, e, t) {
        var i = D(n) ? Oi : _a, a = arguments.length < 3;
        return i(n, M(e, 4), t, a, Pe);
      }
      function N0(n, e, t) {
        var i = D(n) ? jf : _a, a = arguments.length < 3;
        return i(n, M(e, 4), t, a, Ua);
      }
      function $0(n, e) {
        var t = D(n) ? Ee : Fa;
        return t(n, $r(M(e, 3)));
      }
      function G0(n) {
        var e = D(n) ? Pa : Wc;
        return e(n);
      }
      function z0(n, e, t) {
        (t ? Ln(n, e, t) : e === r) ? e = 1 : e = k(e);
        var i = D(n) ? hc : Uc;
        return i(n, e);
      }
      function q0(n) {
        var e = D(n) ? gc : Dc;
        return e(n);
      }
      function K0(n) {
        if (n == null)
          return 0;
        if (Bn(n))
          return zr(n) ? ot(n) : n.length;
        var e = In(n);
        return e == ne || e == ee ? n.size : zi(n).length;
      }
      function X0(n, e, t) {
        var i = D(n) ? Ri : kc;
        return t && Ln(n, e, t) && (e = r), i(n, M(e, 3));
      }
      var Y0 = G(function(n, e) {
        if (n == null)
          return [];
        var t = e.length;
        return t > 1 && Ln(n, e[0], e[1]) ? e = [] : t > 2 && Ln(e[0], e[1], e[2]) && (e = [e[0]]), Xa(n, Tn(e, 1), []);
      }), Hr = El || function() {
        return An.Date.now();
      };
      function Z0(n, e) {
        if (typeof e != "function")
          throw new Xn(d);
        return n = k(n), function() {
          if (--n < 1)
            return e.apply(this, arguments);
        };
      }
      function $o(n, e, t) {
        return e = t ? r : e, e = n && e == null ? n.length : e, _e(n, vn, r, r, r, r, e);
      }
      function Go(n, e) {
        var t;
        if (typeof e != "function")
          throw new Xn(d);
        return n = k(n), function() {
          return --n > 0 && (t = e.apply(this, arguments)), n <= 1 && (e = r), t;
        };
      }
      var pu = G(function(n, e, t) {
        var i = z;
        if (t.length) {
          var a = Se(t, dt(pu));
          i |= j;
        }
        return _e(n, i, e, t, a);
      }), zo = G(function(n, e, t) {
        var i = z | dn;
        if (t.length) {
          var a = Se(t, dt(zo));
          i |= j;
        }
        return _e(e, i, n, t, a);
      });
      function qo(n, e, t) {
        e = t ? r : e;
        var i = _e(n, fn, r, r, r, r, r, e);
        return i.placeholder = qo.placeholder, i;
      }
      function Ko(n, e, t) {
        e = t ? r : e;
        var i = _e(n, an, r, r, r, r, r, e);
        return i.placeholder = Ko.placeholder, i;
      }
      function Xo(n, e, t) {
        var i, a, l, h, g, _, y = 0, x = !1, T = !1, R = !0;
        if (typeof n != "function")
          throw new Xn(d);
        e = Qn(e) || 0, sn(t) && (x = !!t.leading, T = "maxWait" in t, l = T ? mn(Qn(t.maxWait) || 0, e) : l, R = "trailing" in t ? !!t.trailing : R);
        function L(hn) {
          var ue = i, xe = a;
          return i = a = r, y = hn, h = n.apply(xe, ue), h;
        }
        function B(hn) {
          return y = hn, g = zt(q, e), x ? L(hn) : h;
        }
        function N(hn) {
          var ue = hn - _, xe = hn - y, hs = e - ue;
          return T ? Rn(hs, l - xe) : hs;
        }
        function W(hn) {
          var ue = hn - _, xe = hn - y;
          return _ === r || ue >= e || ue < 0 || T && xe >= l;
        }
        function q() {
          var hn = Hr();
          if (W(hn))
            return X(hn);
          g = zt(q, N(hn));
        }
        function X(hn) {
          return g = r, R && i ? L(hn) : (i = a = r, h);
        }
        function $n() {
          g !== r && to(g), y = 0, i = _ = a = g = r;
        }
        function Pn() {
          return g === r ? h : X(Hr());
        }
        function Gn() {
          var hn = Hr(), ue = W(hn);
          if (i = arguments, a = this, _ = hn, ue) {
            if (g === r)
              return B(_);
            if (T)
              return to(g), g = zt(q, e), L(_);
          }
          return g === r && (g = zt(q, e)), h;
        }
        return Gn.cancel = $n, Gn.flush = Pn, Gn;
      }
      var J0 = G(function(n, e) {
        return Wa(n, 1, e);
      }), V0 = G(function(n, e, t) {
        return Wa(n, Qn(e) || 0, t);
      });
      function Q0(n) {
        return _e(n, on);
      }
      function Nr(n, e) {
        if (typeof n != "function" || e != null && typeof e != "function")
          throw new Xn(d);
        var t = function() {
          var i = arguments, a = e ? e.apply(this, i) : i[0], l = t.cache;
          if (l.has(a))
            return l.get(a);
          var h = n.apply(this, i);
          return t.cache = l.set(a, h) || l, h;
        };
        return t.cache = new (Nr.Cache || de)(), t;
      }
      Nr.Cache = de;
      function $r(n) {
        if (typeof n != "function")
          throw new Xn(d);
        return function() {
          var e = arguments;
          switch (e.length) {
            case 0:
              return !n.call(this);
            case 1:
              return !n.call(this, e[0]);
            case 2:
              return !n.call(this, e[0], e[1]);
            case 3:
              return !n.call(this, e[0], e[1], e[2]);
          }
          return !n.apply(this, e);
        };
      }
      function j0(n) {
        return Go(2, n);
      }
      var ng = Hc(function(n, e) {
        e = e.length == 1 && D(e[0]) ? un(e[0], kn(M())) : un(Tn(e, 1), kn(M()));
        var t = e.length;
        return G(function(i) {
          for (var a = -1, l = Rn(i.length, t); ++a < l; )
            i[a] = e[a].call(this, i[a]);
          return Dn(n, this, i);
        });
      }), du = G(function(n, e) {
        var t = Se(e, dt(du));
        return _e(n, j, r, e, t);
      }), Yo = G(function(n, e) {
        var t = Se(e, dt(Yo));
        return _e(n, Cn, r, e, t);
      }), eg = me(function(n, e) {
        return _e(n, en, r, r, r, e);
      });
      function tg(n, e) {
        if (typeof n != "function")
          throw new Xn(d);
        return e = e === r ? e : k(e), G(n, e);
      }
      function rg(n, e) {
        if (typeof n != "function")
          throw new Xn(d);
        return e = e == null ? 0 : mn(k(e), 0), G(function(t) {
          var i = t[e], a = We(t, 0, e);
          return i && Ce(a, i), Dn(n, this, a);
        });
      }
      function ig(n, e, t) {
        var i = !0, a = !0;
        if (typeof n != "function")
          throw new Xn(d);
        return sn(t) && (i = "leading" in t ? !!t.leading : i, a = "trailing" in t ? !!t.trailing : a), Xo(n, e, {
          leading: i,
          maxWait: e,
          trailing: a
        });
      }
      function ug(n) {
        return $o(n, 1);
      }
      function ag(n, e) {
        return du(ji(e), n);
      }
      function og() {
        if (!arguments.length)
          return [];
        var n = arguments[0];
        return D(n) ? n : [n];
      }
      function sg(n) {
        return Zn(n, U);
      }
      function fg(n, e) {
        return e = typeof e == "function" ? e : r, Zn(n, U, e);
      }
      function lg(n) {
        return Zn(n, C | U);
      }
      function cg(n, e) {
        return e = typeof e == "function" ? e : r, Zn(n, C | U, e);
      }
      function hg(n, e) {
        return e == null || Ba(n, e, bn(e));
      }
      function ie(n, e) {
        return n === e || n !== n && e !== e;
      }
      var gg = Br(Ni), pg = Br(function(n, e) {
        return n >= e;
      }), Je = Ha(function() {
        return arguments;
      }()) ? Ha : function(n) {
        return ln(n) && V.call(n, "callee") && !Ra.call(n, "callee");
      }, D = m.isArray, dg = oa ? kn(oa) : Ac;
      function Bn(n) {
        return n != null && Gr(n.length) && !be(n);
      }
      function cn(n) {
        return ln(n) && Bn(n);
      }
      function vg(n) {
        return n === !0 || n === !1 || ln(n) && Sn(n) == Re;
      }
      var Ue = Sl || Ru, _g = sa ? kn(sa) : Tc;
      function mg(n) {
        return ln(n) && n.nodeType === 1 && !qt(n);
      }
      function wg(n) {
        if (n == null)
          return !0;
        if (Bn(n) && (D(n) || typeof n == "string" || typeof n.splice == "function" || Ue(n) || vt(n) || Je(n)))
          return !n.length;
        var e = In(n);
        if (e == ne || e == ee)
          return !n.size;
        if (Gt(n))
          return !zi(n).length;
        for (var t in n)
          if (V.call(n, t))
            return !1;
        return !0;
      }
      function bg(n, e) {
        return Ht(n, e);
      }
      function yg(n, e, t) {
        t = typeof t == "function" ? t : r;
        var i = t ? t(n, e) : r;
        return i === r ? Ht(n, e, r, t) : !!i;
      }
      function vu(n) {
        if (!ln(n))
          return !1;
        var e = Sn(n);
        return e == Ne || e == er || typeof n.message == "string" && typeof n.name == "string" && !qt(n);
      }
      function xg(n) {
        return typeof n == "number" && Ea(n);
      }
      function be(n) {
        if (!sn(n))
          return !1;
        var e = Sn(n);
        return e == Ot || e == tr || e == Tt || e == qs;
      }
      function Zo(n) {
        return typeof n == "number" && n == k(n);
      }
      function Gr(n) {
        return typeof n == "number" && n > -1 && n % 1 == 0 && n <= jn;
      }
      function sn(n) {
        var e = typeof n;
        return n != null && (e == "object" || e == "function");
      }
      function ln(n) {
        return n != null && typeof n == "object";
      }
      var Jo = fa ? kn(fa) : Rc;
      function Ag(n, e) {
        return n === e || Gi(n, e, au(e));
      }
      function Tg(n, e, t) {
        return t = typeof t == "function" ? t : r, Gi(n, e, au(e), t);
      }
      function Og(n) {
        return Vo(n) && n != +n;
      }
      function Rg(n) {
        if (fh(n))
          throw new F(p);
        return Na(n);
      }
      function Ig(n) {
        return n === null;
      }
      function Eg(n) {
        return n == null;
      }
      function Vo(n) {
        return typeof n == "number" || ln(n) && Sn(n) == Rt;
      }
      function qt(n) {
        if (!ln(n) || Sn(n) != ge)
          return !1;
        var e = vr(n);
        if (e === null)
          return !0;
        var t = V.call(e, "constructor") && e.constructor;
        return typeof t == "function" && t instanceof t && hr.call(t) == Tl;
      }
      var _u = la ? kn(la) : Ic;
      function Cg(n) {
        return Zo(n) && n >= -jn && n <= jn;
      }
      var Qo = ca ? kn(ca) : Ec;
      function zr(n) {
        return typeof n == "string" || !D(n) && ln(n) && Sn(n) == Et;
      }
      function Nn(n) {
        return typeof n == "symbol" || ln(n) && Sn(n) == rr;
      }
      var vt = ha ? kn(ha) : Cc;
      function Sg(n) {
        return n === r;
      }
      function Lg(n) {
        return ln(n) && In(n) == Ct;
      }
      function Pg(n) {
        return ln(n) && Sn(n) == Xs;
      }
      var Mg = Br(qi), Bg = Br(function(n, e) {
        return n <= e;
      });
      function jo(n) {
        if (!n)
          return [];
        if (Bn(n))
          return zr(n) ? te(n) : Mn(n);
        if (Pt && n[Pt])
          return hl(n[Pt]());
        var e = In(n), t = e == ne ? Pi : e == ee ? fr : _t;
        return t(n);
      }
      function ye(n) {
        if (!n)
          return n === 0 ? n : 0;
        if (n = Qn(n), n === ae || n === -ae) {
          var e = n < 0 ? -1 : 1;
          return e * ii;
        }
        return n === n ? n : 0;
      }
      function k(n) {
        var e = ye(n), t = e % 1;
        return e === e ? t ? e - t : e : 0;
      }
      function ns(n) {
        return n ? Ke(k(n), 0, zn) : 0;
      }
      function Qn(n) {
        if (typeof n == "number")
          return n;
        if (Nn(n))
          return tt;
        if (sn(n)) {
          var e = typeof n.valueOf == "function" ? n.valueOf() : n;
          n = sn(e) ? e + "" : e;
        }
        if (typeof n != "string")
          return n === 0 ? n : +n;
        n = ma(n);
        var t = df.test(n);
        return t || _f.test(n) ? Zf(n.slice(2), t ? 2 : 8) : pf.test(n) ? tt : +n;
      }
      function es(n) {
        return se(n, Wn(n));
      }
      function Wg(n) {
        return n ? Ke(k(n), -jn, jn) : n === 0 ? n : 0;
      }
      function Z(n) {
        return n == null ? "" : Hn(n);
      }
      var Ug = gt(function(n, e) {
        if (Gt(e) || Bn(e)) {
          se(e, bn(e), n);
          return;
        }
        for (var t in e)
          V.call(e, t) && Ft(n, t, e[t]);
      }), ts = gt(function(n, e) {
        se(e, Wn(e), n);
      }), qr = gt(function(n, e, t, i) {
        se(e, Wn(e), n, i);
      }), Fg = gt(function(n, e, t, i) {
        se(e, bn(e), n, i);
      }), Dg = me(Di);
      function kg(n, e) {
        var t = ht(n);
        return e == null ? t : Ma(t, e);
      }
      var Hg = G(function(n, e) {
        n = nn(n);
        var t = -1, i = e.length, a = i > 2 ? e[2] : r;
        for (a && Ln(e[0], e[1], a) && (i = 1); ++t < i; )
          for (var l = e[t], h = Wn(l), g = -1, _ = h.length; ++g < _; ) {
            var y = h[g], x = n[y];
            (x === r || ie(x, ft[y]) && !V.call(n, y)) && (n[y] = l[y]);
          }
        return n;
      }), Ng = G(function(n) {
        return n.push(r, wo), Dn(rs, r, n);
      });
      function $g(n, e) {
        return pa(n, M(e, 3), oe);
      }
      function Gg(n, e) {
        return pa(n, M(e, 3), Hi);
      }
      function zg(n, e) {
        return n == null ? n : ki(n, M(e, 3), Wn);
      }
      function qg(n, e) {
        return n == null ? n : Da(n, M(e, 3), Wn);
      }
      function Kg(n, e) {
        return n && oe(n, M(e, 3));
      }
      function Xg(n, e) {
        return n && Hi(n, M(e, 3));
      }
      function Yg(n) {
        return n == null ? [] : Rr(n, bn(n));
      }
      function Zg(n) {
        return n == null ? [] : Rr(n, Wn(n));
      }
      function mu(n, e, t) {
        var i = n == null ? r : Xe(n, e);
        return i === r ? t : i;
      }
      function Jg(n, e) {
        return n != null && xo(n, e, wc);
      }
      function wu(n, e) {
        return n != null && xo(n, e, bc);
      }
      var Vg = go(function(n, e, t) {
        e != null && typeof e.toString != "function" && (e = gr.call(e)), n[e] = t;
      }, yu(Un)), Qg = go(function(n, e, t) {
        e != null && typeof e.toString != "function" && (e = gr.call(e)), V.call(n, e) ? n[e].push(t) : n[e] = [t];
      }, M), jg = G(kt);
      function bn(n) {
        return Bn(n) ? La(n) : zi(n);
      }
      function Wn(n) {
        return Bn(n) ? La(n, !0) : Sc(n);
      }
      function n1(n, e) {
        var t = {};
        return e = M(e, 3), oe(n, function(i, a, l) {
          ve(t, e(i, a, l), i);
        }), t;
      }
      function e1(n, e) {
        var t = {};
        return e = M(e, 3), oe(n, function(i, a, l) {
          ve(t, a, e(i, a, l));
        }), t;
      }
      var t1 = gt(function(n, e, t) {
        Ir(n, e, t);
      }), rs = gt(function(n, e, t, i) {
        Ir(n, e, t, i);
      }), r1 = me(function(n, e) {
        var t = {};
        if (n == null)
          return t;
        var i = !1;
        e = un(e, function(l) {
          return l = Be(l, n), i || (i = l.length > 1), l;
        }), se(n, iu(n), t), i && (t = Zn(t, C | H | U, Vc));
        for (var a = e.length; a--; )
          Ji(t, e[a]);
        return t;
      });
      function i1(n, e) {
        return is(n, $r(M(e)));
      }
      var u1 = me(function(n, e) {
        return n == null ? {} : Pc(n, e);
      });
      function is(n, e) {
        if (n == null)
          return {};
        var t = un(iu(n), function(i) {
          return [i];
        });
        return e = M(e), Ya(n, t, function(i, a) {
          return e(i, a[0]);
        });
      }
      function a1(n, e, t) {
        e = Be(e, n);
        var i = -1, a = e.length;
        for (a || (a = 1, n = r); ++i < a; ) {
          var l = n == null ? r : n[fe(e[i])];
          l === r && (i = a, l = t), n = be(l) ? l.call(n) : l;
        }
        return n;
      }
      function o1(n, e, t) {
        return n == null ? n : Nt(n, e, t);
      }
      function s1(n, e, t, i) {
        return i = typeof i == "function" ? i : r, n == null ? n : Nt(n, e, t, i);
      }
      var us = _o(bn), as = _o(Wn);
      function f1(n, e, t) {
        var i = D(n), a = i || Ue(n) || vt(n);
        if (e = M(e, 4), t == null) {
          var l = n && n.constructor;
          a ? t = i ? new l() : [] : sn(n) ? t = be(l) ? ht(vr(n)) : {} : t = {};
        }
        return (a ? Kn : oe)(n, function(h, g, _) {
          return e(t, h, g, _);
        }), t;
      }
      function l1(n, e) {
        return n == null ? !0 : Ji(n, e);
      }
      function c1(n, e, t) {
        return n == null ? n : ja(n, e, ji(t));
      }
      function h1(n, e, t, i) {
        return i = typeof i == "function" ? i : r, n == null ? n : ja(n, e, ji(t), i);
      }
      function _t(n) {
        return n == null ? [] : Li(n, bn(n));
      }
      function g1(n) {
        return n == null ? [] : Li(n, Wn(n));
      }
      function p1(n, e, t) {
        return t === r && (t = e, e = r), t !== r && (t = Qn(t), t = t === t ? t : 0), e !== r && (e = Qn(e), e = e === e ? e : 0), Ke(Qn(n), e, t);
      }
      function d1(n, e, t) {
        return e = ye(e), t === r ? (t = e, e = 0) : t = ye(t), n = Qn(n), yc(n, e, t);
      }
      function v1(n, e, t) {
        if (t && typeof t != "boolean" && Ln(n, e, t) && (e = t = r), t === r && (typeof e == "boolean" ? (t = e, e = r) : typeof n == "boolean" && (t = n, n = r)), n === r && e === r ? (n = 0, e = 1) : (n = ye(n), e === r ? (e = n, n = 0) : e = ye(e)), n > e) {
          var i = n;
          n = e, e = i;
        }
        if (t || n % 1 || e % 1) {
          var a = Ca();
          return Rn(n + a * (e - n + Yf("1e-" + ((a + "").length - 1))), e);
        }
        return Xi(n, e);
      }
      var _1 = pt(function(n, e, t) {
        return e = e.toLowerCase(), n + (t ? os(e) : e);
      });
      function os(n) {
        return bu(Z(n).toLowerCase());
      }
      function ss(n) {
        return n = Z(n), n && n.replace(wf, ol).replace(Df, "");
      }
      function m1(n, e, t) {
        n = Z(n), e = Hn(e);
        var i = n.length;
        t = t === r ? i : Ke(k(t), 0, i);
        var a = t;
        return t -= e.length, t >= 0 && n.slice(t, a) == e;
      }
      function w1(n) {
        return n = Z(n), n && Qs.test(n) ? n.replace(Du, sl) : n;
      }
      function b1(n) {
        return n = Z(n), n && uf.test(n) ? n.replace(di, "\\$&") : n;
      }
      var y1 = pt(function(n, e, t) {
        return n + (t ? "-" : "") + e.toLowerCase();
      }), x1 = pt(function(n, e, t) {
        return n + (t ? " " : "") + e.toLowerCase();
      }), A1 = lo("toLowerCase");
      function T1(n, e, t) {
        n = Z(n), e = k(e);
        var i = e ? ot(n) : 0;
        if (!e || i >= e)
          return n;
        var a = (e - i) / 2;
        return Mr(br(a), t) + n + Mr(wr(a), t);
      }
      function O1(n, e, t) {
        n = Z(n), e = k(e);
        var i = e ? ot(n) : 0;
        return e && i < e ? n + Mr(e - i, t) : n;
      }
      function R1(n, e, t) {
        n = Z(n), e = k(e);
        var i = e ? ot(n) : 0;
        return e && i < e ? Mr(e - i, t) + n : n;
      }
      function I1(n, e, t) {
        return t || e == null ? e = 0 : e && (e = +e), Bl(Z(n).replace(vi, ""), e || 0);
      }
      function E1(n, e, t) {
        return (t ? Ln(n, e, t) : e === r) ? e = 1 : e = k(e), Yi(Z(n), e);
      }
      function C1() {
        var n = arguments, e = Z(n[0]);
        return n.length < 3 ? e : e.replace(n[1], n[2]);
      }
      var S1 = pt(function(n, e, t) {
        return n + (t ? "_" : "") + e.toLowerCase();
      });
      function L1(n, e, t) {
        return t && typeof t != "number" && Ln(n, e, t) && (e = t = r), t = t === r ? zn : t >>> 0, t ? (n = Z(n), n && (typeof e == "string" || e != null && !_u(e)) && (e = Hn(e), !e && at(n)) ? We(te(n), 0, t) : n.split(e, t)) : [];
      }
      var P1 = pt(function(n, e, t) {
        return n + (t ? " " : "") + bu(e);
      });
      function M1(n, e, t) {
        return n = Z(n), t = t == null ? 0 : Ke(k(t), 0, n.length), e = Hn(e), n.slice(t, t + e.length) == e;
      }
      function B1(n, e, t) {
        var i = f.templateSettings;
        t && Ln(n, e, t) && (e = r), n = Z(n), e = qr({}, e, i, mo);
        var a = qr({}, e.imports, i.imports, mo), l = bn(a), h = Li(a, l), g, _, y = 0, x = e.interpolate || ir, T = "__p += '", R = Mi(
          (e.escape || ir).source + "|" + x.source + "|" + (x === ku ? gf : ir).source + "|" + (e.evaluate || ir).source + "|$",
          "g"
        ), L = "//# sourceURL=" + (V.call(e, "sourceURL") ? (e.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++Gf + "]") + `
`;
        n.replace(R, function(W, q, X, $n, Pn, Gn) {
          return X || (X = $n), T += n.slice(y, Gn).replace(bf, fl), q && (g = !0, T += `' +
__e(` + q + `) +
'`), Pn && (_ = !0, T += `';
` + Pn + `;
__p += '`), X && (T += `' +
((__t = (` + X + `)) == null ? '' : __t) +
'`), y = Gn + W.length, W;
        }), T += `';
`;
        var B = V.call(e, "variable") && e.variable;
        if (!B)
          T = `with (obj) {
` + T + `
}
`;
        else if (cf.test(B))
          throw new F(b);
        T = (_ ? T.replace(Ys, "") : T).replace(Zs, "$1").replace(Js, "$1;"), T = "function(" + (B || "obj") + `) {
` + (B ? "" : `obj || (obj = {});
`) + "var __t, __p = ''" + (g ? ", __e = _.escape" : "") + (_ ? `, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
` : `;
`) + T + `return __p
}`;
        var N = ls(function() {
          return Y(l, L + "return " + T).apply(r, h);
        });
        if (N.source = T, vu(N))
          throw N;
        return N;
      }
      function W1(n) {
        return Z(n).toLowerCase();
      }
      function U1(n) {
        return Z(n).toUpperCase();
      }
      function F1(n, e, t) {
        if (n = Z(n), n && (t || e === r))
          return ma(n);
        if (!n || !(e = Hn(e)))
          return n;
        var i = te(n), a = te(e), l = wa(i, a), h = ba(i, a) + 1;
        return We(i, l, h).join("");
      }
      function D1(n, e, t) {
        if (n = Z(n), n && (t || e === r))
          return n.slice(0, xa(n) + 1);
        if (!n || !(e = Hn(e)))
          return n;
        var i = te(n), a = ba(i, te(e)) + 1;
        return We(i, 0, a).join("");
      }
      function k1(n, e, t) {
        if (n = Z(n), n && (t || e === r))
          return n.replace(vi, "");
        if (!n || !(e = Hn(e)))
          return n;
        var i = te(n), a = wa(i, te(e));
        return We(i, a).join("");
      }
      function H1(n, e) {
        var t = et, i = $;
        if (sn(e)) {
          var a = "separator" in e ? e.separator : a;
          t = "length" in e ? k(e.length) : t, i = "omission" in e ? Hn(e.omission) : i;
        }
        n = Z(n);
        var l = n.length;
        if (at(n)) {
          var h = te(n);
          l = h.length;
        }
        if (t >= l)
          return n;
        var g = t - ot(i);
        if (g < 1)
          return i;
        var _ = h ? We(h, 0, g).join("") : n.slice(0, g);
        if (a === r)
          return _ + i;
        if (h && (g += _.length - g), _u(a)) {
          if (n.slice(g).search(a)) {
            var y, x = _;
            for (a.global || (a = Mi(a.source, Z(Hu.exec(a)) + "g")), a.lastIndex = 0; y = a.exec(x); )
              var T = y.index;
            _ = _.slice(0, T === r ? g : T);
          }
        } else if (n.indexOf(Hn(a), g) != g) {
          var R = _.lastIndexOf(a);
          R > -1 && (_ = _.slice(0, R));
        }
        return _ + i;
      }
      function N1(n) {
        return n = Z(n), n && Vs.test(n) ? n.replace(Fu, vl) : n;
      }
      var $1 = pt(function(n, e, t) {
        return n + (t ? " " : "") + e.toUpperCase();
      }), bu = lo("toUpperCase");
      function fs(n, e, t) {
        return n = Z(n), e = t ? r : e, e === r ? cl(n) ? wl(n) : tl(n) : n.match(e) || [];
      }
      var ls = G(function(n, e) {
        try {
          return Dn(n, r, e);
        } catch (t) {
          return vu(t) ? t : new F(t);
        }
      }), G1 = me(function(n, e) {
        return Kn(e, function(t) {
          t = fe(t), ve(n, t, pu(n[t], n));
        }), n;
      });
      function z1(n) {
        var e = n == null ? 0 : n.length, t = M();
        return n = e ? un(n, function(i) {
          if (typeof i[1] != "function")
            throw new Xn(d);
          return [t(i[0]), i[1]];
        }) : [], G(function(i) {
          for (var a = -1; ++a < e; ) {
            var l = n[a];
            if (Dn(l[0], this, i))
              return Dn(l[1], this, i);
          }
        });
      }
      function q1(n) {
        return vc(Zn(n, C));
      }
      function yu(n) {
        return function() {
          return n;
        };
      }
      function K1(n, e) {
        return n == null || n !== n ? e : n;
      }
      var X1 = ho(), Y1 = ho(!0);
      function Un(n) {
        return n;
      }
      function xu(n) {
        return $a(typeof n == "function" ? n : Zn(n, C));
      }
      function Z1(n) {
        return za(Zn(n, C));
      }
      function J1(n, e) {
        return qa(n, Zn(e, C));
      }
      var V1 = G(function(n, e) {
        return function(t) {
          return kt(t, n, e);
        };
      }), Q1 = G(function(n, e) {
        return function(t) {
          return kt(n, t, e);
        };
      });
      function Au(n, e, t) {
        var i = bn(e), a = Rr(e, i);
        t == null && !(sn(e) && (a.length || !i.length)) && (t = e, e = n, n = this, a = Rr(e, bn(e)));
        var l = !(sn(t) && "chain" in t) || !!t.chain, h = be(n);
        return Kn(a, function(g) {
          var _ = e[g];
          n[g] = _, h && (n.prototype[g] = function() {
            var y = this.__chain__;
            if (l || y) {
              var x = n(this.__wrapped__), T = x.__actions__ = Mn(this.__actions__);
              return T.push({ func: _, args: arguments, thisArg: n }), x.__chain__ = y, x;
            }
            return _.apply(n, Ce([this.value()], arguments));
          });
        }), n;
      }
      function j1() {
        return An._ === this && (An._ = Ol), this;
      }
      function Tu() {
      }
      function np(n) {
        return n = k(n), G(function(e) {
          return Ka(e, n);
        });
      }
      var ep = eu(un), tp = eu(ga), rp = eu(Ri);
      function cs(n) {
        return su(n) ? Ii(fe(n)) : Mc(n);
      }
      function ip(n) {
        return function(e) {
          return n == null ? r : Xe(n, e);
        };
      }
      var up = po(), ap = po(!0);
      function Ou() {
        return [];
      }
      function Ru() {
        return !1;
      }
      function op() {
        return {};
      }
      function sp() {
        return "";
      }
      function fp() {
        return !0;
      }
      function lp(n, e) {
        if (n = k(n), n < 1 || n > jn)
          return [];
        var t = zn, i = Rn(n, zn);
        e = M(e), n -= zn;
        for (var a = Si(i, e); ++t < n; )
          e(t);
        return a;
      }
      function cp(n) {
        return D(n) ? un(n, fe) : Nn(n) ? [n] : Mn(Lo(Z(n)));
      }
      function hp(n) {
        var e = ++Al;
        return Z(n) + e;
      }
      var gp = Pr(function(n, e) {
        return n + e;
      }, 0), pp = tu("ceil"), dp = Pr(function(n, e) {
        return n / e;
      }, 1), vp = tu("floor");
      function _p(n) {
        return n && n.length ? Or(n, Un, Ni) : r;
      }
      function mp(n, e) {
        return n && n.length ? Or(n, M(e, 2), Ni) : r;
      }
      function wp(n) {
        return va(n, Un);
      }
      function bp(n, e) {
        return va(n, M(e, 2));
      }
      function yp(n) {
        return n && n.length ? Or(n, Un, qi) : r;
      }
      function xp(n, e) {
        return n && n.length ? Or(n, M(e, 2), qi) : r;
      }
      var Ap = Pr(function(n, e) {
        return n * e;
      }, 1), Tp = tu("round"), Op = Pr(function(n, e) {
        return n - e;
      }, 0);
      function Rp(n) {
        return n && n.length ? Ci(n, Un) : 0;
      }
      function Ip(n, e) {
        return n && n.length ? Ci(n, M(e, 2)) : 0;
      }
      return f.after = Z0, f.ary = $o, f.assign = Ug, f.assignIn = ts, f.assignInWith = qr, f.assignWith = Fg, f.at = Dg, f.before = Go, f.bind = pu, f.bindAll = G1, f.bindKey = zo, f.castArray = og, f.chain = ko, f.chunk = vh, f.compact = _h, f.concat = mh, f.cond = z1, f.conforms = q1, f.constant = yu, f.countBy = R0, f.create = kg, f.curry = qo, f.curryRight = Ko, f.debounce = Xo, f.defaults = Hg, f.defaultsDeep = Ng, f.defer = J0, f.delay = V0, f.difference = wh, f.differenceBy = bh, f.differenceWith = yh, f.drop = xh, f.dropRight = Ah, f.dropRightWhile = Th, f.dropWhile = Oh, f.fill = Rh, f.filter = E0, f.flatMap = L0, f.flatMapDeep = P0, f.flatMapDepth = M0, f.flatten = Wo, f.flattenDeep = Ih, f.flattenDepth = Eh, f.flip = Q0, f.flow = X1, f.flowRight = Y1, f.fromPairs = Ch, f.functions = Yg, f.functionsIn = Zg, f.groupBy = B0, f.initial = Lh, f.intersection = Ph, f.intersectionBy = Mh, f.intersectionWith = Bh, f.invert = Vg, f.invertBy = Qg, f.invokeMap = U0, f.iteratee = xu, f.keyBy = F0, f.keys = bn, f.keysIn = Wn, f.map = kr, f.mapKeys = n1, f.mapValues = e1, f.matches = Z1, f.matchesProperty = J1, f.memoize = Nr, f.merge = t1, f.mergeWith = rs, f.method = V1, f.methodOf = Q1, f.mixin = Au, f.negate = $r, f.nthArg = np, f.omit = r1, f.omitBy = i1, f.once = j0, f.orderBy = D0, f.over = ep, f.overArgs = ng, f.overEvery = tp, f.overSome = rp, f.partial = du, f.partialRight = Yo, f.partition = k0, f.pick = u1, f.pickBy = is, f.property = cs, f.propertyOf = ip, f.pull = Dh, f.pullAll = Fo, f.pullAllBy = kh, f.pullAllWith = Hh, f.pullAt = Nh, f.range = up, f.rangeRight = ap, f.rearg = eg, f.reject = $0, f.remove = $h, f.rest = tg, f.reverse = hu, f.sampleSize = z0, f.set = o1, f.setWith = s1, f.shuffle = q0, f.slice = Gh, f.sortBy = Y0, f.sortedUniq = Jh, f.sortedUniqBy = Vh, f.split = L1, f.spread = rg, f.tail = Qh, f.take = jh, f.takeRight = n0, f.takeRightWhile = e0, f.takeWhile = t0, f.tap = _0, f.throttle = ig, f.thru = Dr, f.toArray = jo, f.toPairs = us, f.toPairsIn = as, f.toPath = cp, f.toPlainObject = es, f.transform = f1, f.unary = ug, f.union = r0, f.unionBy = i0, f.unionWith = u0, f.uniq = a0, f.uniqBy = o0, f.uniqWith = s0, f.unset = l1, f.unzip = gu, f.unzipWith = Do, f.update = c1, f.updateWith = h1, f.values = _t, f.valuesIn = g1, f.without = f0, f.words = fs, f.wrap = ag, f.xor = l0, f.xorBy = c0, f.xorWith = h0, f.zip = g0, f.zipObject = p0, f.zipObjectDeep = d0, f.zipWith = v0, f.entries = us, f.entriesIn = as, f.extend = ts, f.extendWith = qr, Au(f, f), f.add = gp, f.attempt = ls, f.camelCase = _1, f.capitalize = os, f.ceil = pp, f.clamp = p1, f.clone = sg, f.cloneDeep = lg, f.cloneDeepWith = cg, f.cloneWith = fg, f.conformsTo = hg, f.deburr = ss, f.defaultTo = K1, f.divide = dp, f.endsWith = m1, f.eq = ie, f.escape = w1, f.escapeRegExp = b1, f.every = I0, f.find = C0, f.findIndex = Mo, f.findKey = $g, f.findLast = S0, f.findLastIndex = Bo, f.findLastKey = Gg, f.floor = vp, f.forEach = Ho, f.forEachRight = No, f.forIn = zg, f.forInRight = qg, f.forOwn = Kg, f.forOwnRight = Xg, f.get = mu, f.gt = gg, f.gte = pg, f.has = Jg, f.hasIn = wu, f.head = Uo, f.identity = Un, f.includes = W0, f.indexOf = Sh, f.inRange = d1, f.invoke = jg, f.isArguments = Je, f.isArray = D, f.isArrayBuffer = dg, f.isArrayLike = Bn, f.isArrayLikeObject = cn, f.isBoolean = vg, f.isBuffer = Ue, f.isDate = _g, f.isElement = mg, f.isEmpty = wg, f.isEqual = bg, f.isEqualWith = yg, f.isError = vu, f.isFinite = xg, f.isFunction = be, f.isInteger = Zo, f.isLength = Gr, f.isMap = Jo, f.isMatch = Ag, f.isMatchWith = Tg, f.isNaN = Og, f.isNative = Rg, f.isNil = Eg, f.isNull = Ig, f.isNumber = Vo, f.isObject = sn, f.isObjectLike = ln, f.isPlainObject = qt, f.isRegExp = _u, f.isSafeInteger = Cg, f.isSet = Qo, f.isString = zr, f.isSymbol = Nn, f.isTypedArray = vt, f.isUndefined = Sg, f.isWeakMap = Lg, f.isWeakSet = Pg, f.join = Wh, f.kebabCase = y1, f.last = Vn, f.lastIndexOf = Uh, f.lowerCase = x1, f.lowerFirst = A1, f.lt = Mg, f.lte = Bg, f.max = _p, f.maxBy = mp, f.mean = wp, f.meanBy = bp, f.min = yp, f.minBy = xp, f.stubArray = Ou, f.stubFalse = Ru, f.stubObject = op, f.stubString = sp, f.stubTrue = fp, f.multiply = Ap, f.nth = Fh, f.noConflict = j1, f.noop = Tu, f.now = Hr, f.pad = T1, f.padEnd = O1, f.padStart = R1, f.parseInt = I1, f.random = v1, f.reduce = H0, f.reduceRight = N0, f.repeat = E1, f.replace = C1, f.result = a1, f.round = Tp, f.runInContext = v, f.sample = G0, f.size = K0, f.snakeCase = S1, f.some = X0, f.sortedIndex = zh, f.sortedIndexBy = qh, f.sortedIndexOf = Kh, f.sortedLastIndex = Xh, f.sortedLastIndexBy = Yh, f.sortedLastIndexOf = Zh, f.startCase = P1, f.startsWith = M1, f.subtract = Op, f.sum = Rp, f.sumBy = Ip, f.template = B1, f.times = lp, f.toFinite = ye, f.toInteger = k, f.toLength = ns, f.toLower = W1, f.toNumber = Qn, f.toSafeInteger = Wg, f.toString = Z, f.toUpper = U1, f.trim = F1, f.trimEnd = D1, f.trimStart = k1, f.truncate = H1, f.unescape = N1, f.uniqueId = hp, f.upperCase = $1, f.upperFirst = bu, f.each = Ho, f.eachRight = No, f.first = Uo, Au(f, function() {
        var n = {};
        return oe(f, function(e, t) {
          V.call(f.prototype, t) || (n[t] = e);
        }), n;
      }(), { chain: !1 }), f.VERSION = s, Kn(["bind", "bindKey", "curry", "curryRight", "partial", "partialRight"], function(n) {
        f[n].placeholder = f;
      }), Kn(["drop", "take"], function(n, e) {
        K.prototype[n] = function(t) {
          t = t === r ? 1 : mn(k(t), 0);
          var i = this.__filtered__ && !e ? new K(this) : this.clone();
          return i.__filtered__ ? i.__takeCount__ = Rn(t, i.__takeCount__) : i.__views__.push({
            size: Rn(t, zn),
            type: n + (i.__dir__ < 0 ? "Right" : "")
          }), i;
        }, K.prototype[n + "Right"] = function(t) {
          return this.reverse()[n](t).reverse();
        };
      }), Kn(["filter", "map", "takeWhile"], function(n, e) {
        var t = e + 1, i = t == xn || t == jt;
        K.prototype[n] = function(a) {
          var l = this.clone();
          return l.__iteratees__.push({
            iteratee: M(a, 3),
            type: t
          }), l.__filtered__ = l.__filtered__ || i, l;
        };
      }), Kn(["head", "last"], function(n, e) {
        var t = "take" + (e ? "Right" : "");
        K.prototype[n] = function() {
          return this[t](1).value()[0];
        };
      }), Kn(["initial", "tail"], function(n, e) {
        var t = "drop" + (e ? "" : "Right");
        K.prototype[n] = function() {
          return this.__filtered__ ? new K(this) : this[t](1);
        };
      }), K.prototype.compact = function() {
        return this.filter(Un);
      }, K.prototype.find = function(n) {
        return this.filter(n).head();
      }, K.prototype.findLast = function(n) {
        return this.reverse().find(n);
      }, K.prototype.invokeMap = G(function(n, e) {
        return typeof n == "function" ? new K(this) : this.map(function(t) {
          return kt(t, n, e);
        });
      }), K.prototype.reject = function(n) {
        return this.filter($r(M(n)));
      }, K.prototype.slice = function(n, e) {
        n = k(n);
        var t = this;
        return t.__filtered__ && (n > 0 || e < 0) ? new K(t) : (n < 0 ? t = t.takeRight(-n) : n && (t = t.drop(n)), e !== r && (e = k(e), t = e < 0 ? t.dropRight(-e) : t.take(e - n)), t);
      }, K.prototype.takeRightWhile = function(n) {
        return this.reverse().takeWhile(n).reverse();
      }, K.prototype.toArray = function() {
        return this.take(zn);
      }, oe(K.prototype, function(n, e) {
        var t = /^(?:filter|find|map|reject)|While$/.test(e), i = /^(?:head|last)$/.test(e), a = f[i ? "take" + (e == "last" ? "Right" : "") : e], l = i || /^find/.test(e);
        !a || (f.prototype[e] = function() {
          var h = this.__wrapped__, g = i ? [1] : arguments, _ = h instanceof K, y = g[0], x = _ || D(h), T = function(q) {
            var X = a.apply(f, Ce([q], g));
            return i && R ? X[0] : X;
          };
          x && t && typeof y == "function" && y.length != 1 && (_ = x = !1);
          var R = this.__chain__, L = !!this.__actions__.length, B = l && !R, N = _ && !L;
          if (!l && x) {
            h = N ? h : new K(this);
            var W = n.apply(h, g);
            return W.__actions__.push({ func: Dr, args: [T], thisArg: r }), new Yn(W, R);
          }
          return B && N ? n.apply(this, g) : (W = this.thru(T), B ? i ? W.value()[0] : W.value() : W);
        });
      }), Kn(["pop", "push", "shift", "sort", "splice", "unshift"], function(n) {
        var e = lr[n], t = /^(?:push|sort|unshift)$/.test(n) ? "tap" : "thru", i = /^(?:pop|shift)$/.test(n);
        f.prototype[n] = function() {
          var a = arguments;
          if (i && !this.__chain__) {
            var l = this.value();
            return e.apply(D(l) ? l : [], a);
          }
          return this[t](function(h) {
            return e.apply(D(h) ? h : [], a);
          });
        };
      }), oe(K.prototype, function(n, e) {
        var t = f[e];
        if (t) {
          var i = t.name + "";
          V.call(ct, i) || (ct[i] = []), ct[i].push({ name: e, func: t });
        }
      }), ct[Lr(r, dn).name] = [{
        name: "wrapper",
        func: r
      }], K.prototype.clone = Nl, K.prototype.reverse = $l, K.prototype.value = Gl, f.prototype.at = m0, f.prototype.chain = w0, f.prototype.commit = b0, f.prototype.next = y0, f.prototype.plant = A0, f.prototype.reverse = T0, f.prototype.toJSON = f.prototype.valueOf = f.prototype.value = O0, f.prototype.first = f.prototype.head, Pt && (f.prototype[Pt] = x0), f;
    }, st = bl();
    $e ? (($e.exports = st)._ = st, xi._ = st) : An._ = st;
  }).call(Kt);
})(Jr, Jr.exports);
function ri(u, o) {
  return u + ": " + o + " is not a valid hex color.";
}
function zp(u, o) {
  return u + ": " + o + " is not in range [0, 1].";
}
function qp(u, o) {
  return typeof o == "string" ? u + ": " + o + " is not a valid color." : u + ": " + JSON.stringify(o) + " is not a valid color.";
}
function Kp(u, o) {
  return u.match(new RegExp(".{1," + o + "}", "g"));
}
function Ds(u, o) {
  if (o === void 0 && (o = 2), !ei.alpha.test(u))
    throw new Error(u + " is not a valid hex color.");
  if (u.length !== 2)
    throw new Error(u + " lenght is not 2.");
  var r = Np(u), s = r / 255;
  return Jr.exports.round(s, o);
}
function Eu(u) {
  return Math.round(Ds(u) * 255);
}
var ps = globalThis && globalThis.__assign || function() {
  return ps = Object.assign || function(u) {
    for (var o, r = 1, s = arguments.length; r < s; r++) {
      o = arguments[r];
      for (var c in o)
        Object.prototype.hasOwnProperty.call(o, c) && (u[c] = o[c]);
    }
    return u;
  }, ps.apply(this, arguments);
}, ds = globalThis && globalThis.__assign || function() {
  return ds = Object.assign || function(u) {
    for (var o, r = 1, s = arguments.length; r < s; r++) {
      o = arguments[r];
      for (var c in o)
        Object.prototype.hasOwnProperty.call(o, c) && (u[c] = o[c]);
    }
    return u;
  }, ds.apply(this, arguments);
}, vs = globalThis && globalThis.__assign || function() {
  return vs = Object.assign || function(u) {
    for (var o, r = 1, s = arguments.length; r < s; r++) {
      o = arguments[r];
      for (var c in o)
        Object.prototype.hasOwnProperty.call(o, c) && (u[c] = o[c]);
    }
    return u;
  }, vs.apply(this, arguments);
}, _s = globalThis && globalThis.__assign || function() {
  return _s = Object.assign || function(u) {
    for (var o, r = 1, s = arguments.length; r < s; r++) {
      o = arguments[r];
      for (var c in o)
        Object.prototype.hasOwnProperty.call(o, c) && (u[c] = o[c]);
    }
    return u;
  }, _s.apply(this, arguments);
}, Xp = 4, bt = globalThis && globalThis.__assign || function() {
  return bt = Object.assign || function(u) {
    for (var o, r = 1, s = arguments.length; r < s; r++) {
      o = arguments[r];
      for (var c in o)
        Object.prototype.hasOwnProperty.call(o, c) && (u[c] = o[c]);
    }
    return u;
  }, bt.apply(this, arguments);
};
function Yp(u) {
  if (!xt(u))
    throw new Error(ri("hexToRgbOrRgba", u));
  var o = Jp(u).substring(1), r = Kp(o, 2), s = r[0], c = r[1], p = r[2], d = r[3], b = Eu(s), A = Eu(c), O = Eu(p), E = { r: b, g: A, b: O };
  return d ? bt(bt({}, E), { a: Ds(d, Xp) }) : E;
}
function Zp(u) {
  if (!xt(u))
    throw new Error(ri("hexToRgb", u));
  var o = Cu(u), r = o.r, s = o.g, c = o.b;
  return { r, g: s, b: c };
}
function Cu(u, o) {
  if (o === void 0 && (o = 1), !xt(u))
    throw new Error(ri("hex2rgba", u));
  if (!yt(o, [0, 1]))
    throw new Error(zp("hex2rgba", o));
  var r = Yp(u);
  return ti(r) ? bt(bt({}, r), { a: o }) : r;
}
function Jp(u) {
  if (!xt(u))
    throw new Error(ri("shortToLongHex", u));
  if (!ei.short.test(u))
    return u;
  var o = Array.from(u), r = o[0], s = o[1], c = o[2], p = o[3], d = o[4];
  return d ? "" + r + s + s + c + c + p + p + d + d : "" + r + s + s + c + c + p + p;
}
var ms = globalThis && globalThis.__assign || function() {
  return ms = Object.assign || function(u) {
    for (var o, r = 1, s = arguments.length; r < s; r++) {
      o = arguments[r];
      for (var c in o)
        Object.prototype.hasOwnProperty.call(o, c) && (u[c] = o[c]);
    }
    return u;
  }, ms.apply(this, arguments);
};
function ws(u) {
  if (!Gp(u))
    throw new Error(qp("colorToString", u));
  return xt(u) ? Jr.exports.toUpper(u) : ti(u) ? u.r + ", " + u.g + ", " + u.b : Us(u) ? u.r + ", " + u.g + ", " + u.b + ", " + u.a : Fs(u) ? u.c + "%, " + u.m + "%, " + u.y + "%, " + u.k + "%" : Wu(u) ? u.h + ", " + u.s + "%, " + u.l + "%" : u.h + ", " + u.s + "%, " + u.l + "%, " + u.a;
}
var Vr = function() {
  return Vr = Object.assign || function(o) {
    for (var r, s = 1, c = arguments.length; s < c; s++) {
      r = arguments[s];
      for (var p in r)
        Object.prototype.hasOwnProperty.call(r, p) && (o[p] = r[p]);
    }
    return o;
  }, Vr.apply(this, arguments);
};
function Vp(u) {
  return u.toLowerCase();
}
var Qp = [/([a-z0-9])([A-Z])/g, /([A-Z])([A-Z][a-z])/g], jp = /[^A-Z0-9]+/gi;
function nd(u, o) {
  o === void 0 && (o = {});
  for (var r = o.splitRegexp, s = r === void 0 ? Qp : r, c = o.stripRegexp, p = c === void 0 ? jp : c, d = o.transform, b = d === void 0 ? Vp : d, A = o.delimiter, O = A === void 0 ? " " : A, E = bs(bs(u, s, "$1\0$2"), p, "\0"), C = 0, H = E.length; E.charAt(C) === "\0"; )
    C++;
  for (; E.charAt(H - 1) === "\0"; )
    H--;
  return E.slice(C, H).split("\0").map(b).join(O);
}
function bs(u, o, r) {
  return o instanceof RegExp ? u.replace(o, r) : o.reduce(function(s, c) {
    return s.replace(c, r);
  }, u);
}
function ed(u, o) {
  return o === void 0 && (o = {}), nd(u, Vr({ delimiter: "." }, o));
}
function td(u, o) {
  return o === void 0 && (o = {}), ed(u, Vr({ delimiter: "-" }, o));
}
var rd = {
  aliceblue: [240, 248, 255],
  antiquewhite: [250, 235, 215],
  aqua: [0, 255, 255],
  aquamarine: [127, 255, 212],
  azure: [240, 255, 255],
  beige: [245, 245, 220],
  bisque: [255, 228, 196],
  black: [0, 0, 0],
  blanchedalmond: [255, 235, 205],
  blue: [0, 0, 255],
  blueviolet: [138, 43, 226],
  brown: [165, 42, 42],
  burlywood: [222, 184, 135],
  cadetblue: [95, 158, 160],
  chartreuse: [127, 255, 0],
  chocolate: [210, 105, 30],
  coral: [255, 127, 80],
  cornflowerblue: [100, 149, 237],
  cornsilk: [255, 248, 220],
  crimson: [220, 20, 60],
  cyan: [0, 255, 255],
  darkblue: [0, 0, 139],
  darkcyan: [0, 139, 139],
  darkgoldenrod: [184, 134, 11],
  darkgray: [169, 169, 169],
  darkgreen: [0, 100, 0],
  darkgrey: [169, 169, 169],
  darkkhaki: [189, 183, 107],
  darkmagenta: [139, 0, 139],
  darkolivegreen: [85, 107, 47],
  darkorange: [255, 140, 0],
  darkorchid: [153, 50, 204],
  darkred: [139, 0, 0],
  darksalmon: [233, 150, 122],
  darkseagreen: [143, 188, 143],
  darkslateblue: [72, 61, 139],
  darkslategray: [47, 79, 79],
  darkslategrey: [47, 79, 79],
  darkturquoise: [0, 206, 209],
  darkviolet: [148, 0, 211],
  deeppink: [255, 20, 147],
  deepskyblue: [0, 191, 255],
  dimgray: [105, 105, 105],
  dimgrey: [105, 105, 105],
  dodgerblue: [30, 144, 255],
  firebrick: [178, 34, 34],
  floralwhite: [255, 250, 240],
  forestgreen: [34, 139, 34],
  fuchsia: [255, 0, 255],
  gainsboro: [220, 220, 220],
  ghostwhite: [248, 248, 255],
  gold: [255, 215, 0],
  goldenrod: [218, 165, 32],
  gray: [128, 128, 128],
  green: [0, 128, 0],
  greenyellow: [173, 255, 47],
  grey: [128, 128, 128],
  honeydew: [240, 255, 240],
  hotpink: [255, 105, 180],
  indianred: [205, 92, 92],
  indigo: [75, 0, 130],
  ivory: [255, 255, 240],
  khaki: [240, 230, 140],
  lavender: [230, 230, 250],
  lavenderblush: [255, 240, 245],
  lawngreen: [124, 252, 0],
  lemonchiffon: [255, 250, 205],
  lightblue: [173, 216, 230],
  lightcoral: [240, 128, 128],
  lightcyan: [224, 255, 255],
  lightgoldenrodyellow: [250, 250, 210],
  lightgray: [211, 211, 211],
  lightgreen: [144, 238, 144],
  lightgrey: [211, 211, 211],
  lightpink: [255, 182, 193],
  lightsalmon: [255, 160, 122],
  lightseagreen: [32, 178, 170],
  lightskyblue: [135, 206, 250],
  lightslategray: [119, 136, 153],
  lightslategrey: [119, 136, 153],
  lightsteelblue: [176, 196, 222],
  lightyellow: [255, 255, 224],
  lime: [0, 255, 0],
  limegreen: [50, 205, 50],
  linen: [250, 240, 230],
  magenta: [255, 0, 255],
  maroon: [128, 0, 0],
  mediumaquamarine: [102, 205, 170],
  mediumblue: [0, 0, 205],
  mediumorchid: [186, 85, 211],
  mediumpurple: [147, 112, 219],
  mediumseagreen: [60, 179, 113],
  mediumslateblue: [123, 104, 238],
  mediumspringgreen: [0, 250, 154],
  mediumturquoise: [72, 209, 204],
  mediumvioletred: [199, 21, 133],
  midnightblue: [25, 25, 112],
  mintcream: [245, 255, 250],
  mistyrose: [255, 228, 225],
  moccasin: [255, 228, 181],
  navajowhite: [255, 222, 173],
  navy: [0, 0, 128],
  oldlace: [253, 245, 230],
  olive: [128, 128, 0],
  olivedrab: [107, 142, 35],
  orange: [255, 165, 0],
  orangered: [255, 69, 0],
  orchid: [218, 112, 214],
  palegoldenrod: [238, 232, 170],
  palegreen: [152, 251, 152],
  paleturquoise: [175, 238, 238],
  palevioletred: [219, 112, 147],
  papayawhip: [255, 239, 213],
  peachpuff: [255, 218, 185],
  peru: [205, 133, 63],
  pink: [255, 192, 203],
  plum: [221, 160, 221],
  powderblue: [176, 224, 230],
  purple: [128, 0, 128],
  rebeccapurple: [102, 51, 153],
  red: [255, 0, 0],
  rosybrown: [188, 143, 143],
  royalblue: [65, 105, 225],
  saddlebrown: [139, 69, 19],
  salmon: [250, 128, 114],
  sandybrown: [244, 164, 96],
  seagreen: [46, 139, 87],
  seashell: [255, 245, 238],
  sienna: [160, 82, 45],
  silver: [192, 192, 192],
  skyblue: [135, 206, 235],
  slateblue: [106, 90, 205],
  slategray: [112, 128, 144],
  slategrey: [112, 128, 144],
  snow: [255, 250, 250],
  springgreen: [0, 255, 127],
  steelblue: [70, 130, 180],
  tan: [210, 180, 140],
  teal: [0, 128, 128],
  thistle: [216, 191, 216],
  tomato: [255, 99, 71],
  turquoise: [64, 224, 208],
  violet: [238, 130, 238],
  wheat: [245, 222, 179],
  white: [255, 255, 255],
  whitesmoke: [245, 245, 245],
  yellow: [255, 255, 0],
  yellowgreen: [154, 205, 50]
};
const Jt = rd, ks = {};
for (const u of Object.keys(Jt))
  ks[Jt[u]] = u;
const S = {
  rgb: { channels: 3, labels: "rgb" },
  hsl: { channels: 3, labels: "hsl" },
  hsv: { channels: 3, labels: "hsv" },
  hwb: { channels: 3, labels: "hwb" },
  cmyk: { channels: 4, labels: "cmyk" },
  xyz: { channels: 3, labels: "xyz" },
  lab: { channels: 3, labels: "lab" },
  lch: { channels: 3, labels: "lch" },
  hex: { channels: 1, labels: ["hex"] },
  keyword: { channels: 1, labels: ["keyword"] },
  ansi16: { channels: 1, labels: ["ansi16"] },
  ansi256: { channels: 1, labels: ["ansi256"] },
  hcg: { channels: 3, labels: ["h", "c", "g"] },
  apple: { channels: 3, labels: ["r16", "g16", "b16"] },
  gray: { channels: 1, labels: ["gray"] }
};
var Hs = S;
for (const u of Object.keys(S)) {
  if (!("channels" in S[u]))
    throw new Error("missing channels property: " + u);
  if (!("labels" in S[u]))
    throw new Error("missing channel labels property: " + u);
  if (S[u].labels.length !== S[u].channels)
    throw new Error("channel and label counts mismatch: " + u);
  const { channels: o, labels: r } = S[u];
  delete S[u].channels, delete S[u].labels, Object.defineProperty(S[u], "channels", { value: o }), Object.defineProperty(S[u], "labels", { value: r });
}
S.rgb.hsl = function(u) {
  const o = u[0] / 255, r = u[1] / 255, s = u[2] / 255, c = Math.min(o, r, s), p = Math.max(o, r, s), d = p - c;
  let b, A;
  p === c ? b = 0 : o === p ? b = (r - s) / d : r === p ? b = 2 + (s - o) / d : s === p && (b = 4 + (o - r) / d), b = Math.min(b * 60, 360), b < 0 && (b += 360);
  const O = (c + p) / 2;
  return p === c ? A = 0 : O <= 0.5 ? A = d / (p + c) : A = d / (2 - p - c), [b, A * 100, O * 100];
};
S.rgb.hsv = function(u) {
  let o, r, s, c, p;
  const d = u[0] / 255, b = u[1] / 255, A = u[2] / 255, O = Math.max(d, b, A), E = O - Math.min(d, b, A), C = function(H) {
    return (O - H) / 6 / E + 1 / 2;
  };
  return E === 0 ? (c = 0, p = 0) : (p = E / O, o = C(d), r = C(b), s = C(A), d === O ? c = s - r : b === O ? c = 1 / 3 + o - s : A === O && (c = 2 / 3 + r - o), c < 0 ? c += 1 : c > 1 && (c -= 1)), [
    c * 360,
    p * 100,
    O * 100
  ];
};
S.rgb.hwb = function(u) {
  const o = u[0], r = u[1];
  let s = u[2];
  const c = S.rgb.hsl(u)[0], p = 1 / 255 * Math.min(o, Math.min(r, s));
  return s = 1 - 1 / 255 * Math.max(o, Math.max(r, s)), [c, p * 100, s * 100];
};
S.rgb.cmyk = function(u) {
  const o = u[0] / 255, r = u[1] / 255, s = u[2] / 255, c = Math.min(1 - o, 1 - r, 1 - s), p = (1 - o - c) / (1 - c) || 0, d = (1 - r - c) / (1 - c) || 0, b = (1 - s - c) / (1 - c) || 0;
  return [p * 100, d * 100, b * 100, c * 100];
};
function id(u, o) {
  return (u[0] - o[0]) ** 2 + (u[1] - o[1]) ** 2 + (u[2] - o[2]) ** 2;
}
S.rgb.keyword = function(u) {
  const o = ks[u];
  if (o)
    return o;
  let r = 1 / 0, s;
  for (const c of Object.keys(Jt)) {
    const p = Jt[c], d = id(u, p);
    d < r && (r = d, s = c);
  }
  return s;
};
S.keyword.rgb = function(u) {
  return Jt[u];
};
S.rgb.xyz = function(u) {
  let o = u[0] / 255, r = u[1] / 255, s = u[2] / 255;
  o = o > 0.04045 ? ((o + 0.055) / 1.055) ** 2.4 : o / 12.92, r = r > 0.04045 ? ((r + 0.055) / 1.055) ** 2.4 : r / 12.92, s = s > 0.04045 ? ((s + 0.055) / 1.055) ** 2.4 : s / 12.92;
  const c = o * 0.4124 + r * 0.3576 + s * 0.1805, p = o * 0.2126 + r * 0.7152 + s * 0.0722, d = o * 0.0193 + r * 0.1192 + s * 0.9505;
  return [c * 100, p * 100, d * 100];
};
S.rgb.lab = function(u) {
  const o = S.rgb.xyz(u);
  let r = o[0], s = o[1], c = o[2];
  r /= 95.047, s /= 100, c /= 108.883, r = r > 8856e-6 ? r ** (1 / 3) : 7.787 * r + 16 / 116, s = s > 8856e-6 ? s ** (1 / 3) : 7.787 * s + 16 / 116, c = c > 8856e-6 ? c ** (1 / 3) : 7.787 * c + 16 / 116;
  const p = 116 * s - 16, d = 500 * (r - s), b = 200 * (s - c);
  return [p, d, b];
};
S.hsl.rgb = function(u) {
  const o = u[0] / 360, r = u[1] / 100, s = u[2] / 100;
  let c, p, d;
  if (r === 0)
    return d = s * 255, [d, d, d];
  s < 0.5 ? c = s * (1 + r) : c = s + r - s * r;
  const b = 2 * s - c, A = [0, 0, 0];
  for (let O = 0; O < 3; O++)
    p = o + 1 / 3 * -(O - 1), p < 0 && p++, p > 1 && p--, 6 * p < 1 ? d = b + (c - b) * 6 * p : 2 * p < 1 ? d = c : 3 * p < 2 ? d = b + (c - b) * (2 / 3 - p) * 6 : d = b, A[O] = d * 255;
  return A;
};
S.hsl.hsv = function(u) {
  const o = u[0];
  let r = u[1] / 100, s = u[2] / 100, c = r;
  const p = Math.max(s, 0.01);
  s *= 2, r *= s <= 1 ? s : 2 - s, c *= p <= 1 ? p : 2 - p;
  const d = (s + r) / 2, b = s === 0 ? 2 * c / (p + c) : 2 * r / (s + r);
  return [o, b * 100, d * 100];
};
S.hsv.rgb = function(u) {
  const o = u[0] / 60, r = u[1] / 100;
  let s = u[2] / 100;
  const c = Math.floor(o) % 6, p = o - Math.floor(o), d = 255 * s * (1 - r), b = 255 * s * (1 - r * p), A = 255 * s * (1 - r * (1 - p));
  switch (s *= 255, c) {
    case 0:
      return [s, A, d];
    case 1:
      return [b, s, d];
    case 2:
      return [d, s, A];
    case 3:
      return [d, b, s];
    case 4:
      return [A, d, s];
    case 5:
      return [s, d, b];
  }
};
S.hsv.hsl = function(u) {
  const o = u[0], r = u[1] / 100, s = u[2] / 100, c = Math.max(s, 0.01);
  let p, d;
  d = (2 - r) * s;
  const b = (2 - r) * c;
  return p = r * c, p /= b <= 1 ? b : 2 - b, p = p || 0, d /= 2, [o, p * 100, d * 100];
};
S.hwb.rgb = function(u) {
  const o = u[0] / 360;
  let r = u[1] / 100, s = u[2] / 100;
  const c = r + s;
  let p;
  c > 1 && (r /= c, s /= c);
  const d = Math.floor(6 * o), b = 1 - s;
  p = 6 * o - d, (d & 1) !== 0 && (p = 1 - p);
  const A = r + p * (b - r);
  let O, E, C;
  switch (d) {
    default:
    case 6:
    case 0:
      O = b, E = A, C = r;
      break;
    case 1:
      O = A, E = b, C = r;
      break;
    case 2:
      O = r, E = b, C = A;
      break;
    case 3:
      O = r, E = A, C = b;
      break;
    case 4:
      O = A, E = r, C = b;
      break;
    case 5:
      O = b, E = r, C = A;
      break;
  }
  return [O * 255, E * 255, C * 255];
};
S.cmyk.rgb = function(u) {
  const o = u[0] / 100, r = u[1] / 100, s = u[2] / 100, c = u[3] / 100, p = 1 - Math.min(1, o * (1 - c) + c), d = 1 - Math.min(1, r * (1 - c) + c), b = 1 - Math.min(1, s * (1 - c) + c);
  return [p * 255, d * 255, b * 255];
};
S.xyz.rgb = function(u) {
  const o = u[0] / 100, r = u[1] / 100, s = u[2] / 100;
  let c, p, d;
  return c = o * 3.2406 + r * -1.5372 + s * -0.4986, p = o * -0.9689 + r * 1.8758 + s * 0.0415, d = o * 0.0557 + r * -0.204 + s * 1.057, c = c > 31308e-7 ? 1.055 * c ** (1 / 2.4) - 0.055 : c * 12.92, p = p > 31308e-7 ? 1.055 * p ** (1 / 2.4) - 0.055 : p * 12.92, d = d > 31308e-7 ? 1.055 * d ** (1 / 2.4) - 0.055 : d * 12.92, c = Math.min(Math.max(0, c), 1), p = Math.min(Math.max(0, p), 1), d = Math.min(Math.max(0, d), 1), [c * 255, p * 255, d * 255];
};
S.xyz.lab = function(u) {
  let o = u[0], r = u[1], s = u[2];
  o /= 95.047, r /= 100, s /= 108.883, o = o > 8856e-6 ? o ** (1 / 3) : 7.787 * o + 16 / 116, r = r > 8856e-6 ? r ** (1 / 3) : 7.787 * r + 16 / 116, s = s > 8856e-6 ? s ** (1 / 3) : 7.787 * s + 16 / 116;
  const c = 116 * r - 16, p = 500 * (o - r), d = 200 * (r - s);
  return [c, p, d];
};
S.lab.xyz = function(u) {
  const o = u[0], r = u[1], s = u[2];
  let c, p, d;
  p = (o + 16) / 116, c = r / 500 + p, d = p - s / 200;
  const b = p ** 3, A = c ** 3, O = d ** 3;
  return p = b > 8856e-6 ? b : (p - 16 / 116) / 7.787, c = A > 8856e-6 ? A : (c - 16 / 116) / 7.787, d = O > 8856e-6 ? O : (d - 16 / 116) / 7.787, c *= 95.047, p *= 100, d *= 108.883, [c, p, d];
};
S.lab.lch = function(u) {
  const o = u[0], r = u[1], s = u[2];
  let c;
  c = Math.atan2(s, r) * 360 / 2 / Math.PI, c < 0 && (c += 360);
  const d = Math.sqrt(r * r + s * s);
  return [o, d, c];
};
S.lch.lab = function(u) {
  const o = u[0], r = u[1], c = u[2] / 360 * 2 * Math.PI, p = r * Math.cos(c), d = r * Math.sin(c);
  return [o, p, d];
};
S.rgb.ansi16 = function(u, o = null) {
  const [r, s, c] = u;
  let p = o === null ? S.rgb.hsv(u)[2] : o;
  if (p = Math.round(p / 50), p === 0)
    return 30;
  let d = 30 + (Math.round(c / 255) << 2 | Math.round(s / 255) << 1 | Math.round(r / 255));
  return p === 2 && (d += 60), d;
};
S.hsv.ansi16 = function(u) {
  return S.rgb.ansi16(S.hsv.rgb(u), u[2]);
};
S.rgb.ansi256 = function(u) {
  const o = u[0], r = u[1], s = u[2];
  return o === r && r === s ? o < 8 ? 16 : o > 248 ? 231 : Math.round((o - 8) / 247 * 24) + 232 : 16 + 36 * Math.round(o / 255 * 5) + 6 * Math.round(r / 255 * 5) + Math.round(s / 255 * 5);
};
S.ansi16.rgb = function(u) {
  let o = u % 10;
  if (o === 0 || o === 7)
    return u > 50 && (o += 3.5), o = o / 10.5 * 255, [o, o, o];
  const r = (~~(u > 50) + 1) * 0.5, s = (o & 1) * r * 255, c = (o >> 1 & 1) * r * 255, p = (o >> 2 & 1) * r * 255;
  return [s, c, p];
};
S.ansi256.rgb = function(u) {
  if (u >= 232) {
    const p = (u - 232) * 10 + 8;
    return [p, p, p];
  }
  u -= 16;
  let o;
  const r = Math.floor(u / 36) / 5 * 255, s = Math.floor((o = u % 36) / 6) / 5 * 255, c = o % 6 / 5 * 255;
  return [r, s, c];
};
S.rgb.hex = function(u) {
  const r = (((Math.round(u[0]) & 255) << 16) + ((Math.round(u[1]) & 255) << 8) + (Math.round(u[2]) & 255)).toString(16).toUpperCase();
  return "000000".substring(r.length) + r;
};
S.hex.rgb = function(u) {
  const o = u.toString(16).match(/[a-f0-9]{6}|[a-f0-9]{3}/i);
  if (!o)
    return [0, 0, 0];
  let r = o[0];
  o[0].length === 3 && (r = r.split("").map((b) => b + b).join(""));
  const s = parseInt(r, 16), c = s >> 16 & 255, p = s >> 8 & 255, d = s & 255;
  return [c, p, d];
};
S.rgb.hcg = function(u) {
  const o = u[0] / 255, r = u[1] / 255, s = u[2] / 255, c = Math.max(Math.max(o, r), s), p = Math.min(Math.min(o, r), s), d = c - p;
  let b, A;
  return d < 1 ? b = p / (1 - d) : b = 0, d <= 0 ? A = 0 : c === o ? A = (r - s) / d % 6 : c === r ? A = 2 + (s - o) / d : A = 4 + (o - r) / d, A /= 6, A %= 1, [A * 360, d * 100, b * 100];
};
S.hsl.hcg = function(u) {
  const o = u[1] / 100, r = u[2] / 100, s = r < 0.5 ? 2 * o * r : 2 * o * (1 - r);
  let c = 0;
  return s < 1 && (c = (r - 0.5 * s) / (1 - s)), [u[0], s * 100, c * 100];
};
S.hsv.hcg = function(u) {
  const o = u[1] / 100, r = u[2] / 100, s = o * r;
  let c = 0;
  return s < 1 && (c = (r - s) / (1 - s)), [u[0], s * 100, c * 100];
};
S.hcg.rgb = function(u) {
  const o = u[0] / 360, r = u[1] / 100, s = u[2] / 100;
  if (r === 0)
    return [s * 255, s * 255, s * 255];
  const c = [0, 0, 0], p = o % 1 * 6, d = p % 1, b = 1 - d;
  let A = 0;
  switch (Math.floor(p)) {
    case 0:
      c[0] = 1, c[1] = d, c[2] = 0;
      break;
    case 1:
      c[0] = b, c[1] = 1, c[2] = 0;
      break;
    case 2:
      c[0] = 0, c[1] = 1, c[2] = d;
      break;
    case 3:
      c[0] = 0, c[1] = b, c[2] = 1;
      break;
    case 4:
      c[0] = d, c[1] = 0, c[2] = 1;
      break;
    default:
      c[0] = 1, c[1] = 0, c[2] = b;
  }
  return A = (1 - r) * s, [
    (r * c[0] + A) * 255,
    (r * c[1] + A) * 255,
    (r * c[2] + A) * 255
  ];
};
S.hcg.hsv = function(u) {
  const o = u[1] / 100, r = u[2] / 100, s = o + r * (1 - o);
  let c = 0;
  return s > 0 && (c = o / s), [u[0], c * 100, s * 100];
};
S.hcg.hsl = function(u) {
  const o = u[1] / 100, s = u[2] / 100 * (1 - o) + 0.5 * o;
  let c = 0;
  return s > 0 && s < 0.5 ? c = o / (2 * s) : s >= 0.5 && s < 1 && (c = o / (2 * (1 - s))), [u[0], c * 100, s * 100];
};
S.hcg.hwb = function(u) {
  const o = u[1] / 100, r = u[2] / 100, s = o + r * (1 - o);
  return [u[0], (s - o) * 100, (1 - s) * 100];
};
S.hwb.hcg = function(u) {
  const o = u[1] / 100, s = 1 - u[2] / 100, c = s - o;
  let p = 0;
  return c < 1 && (p = (s - c) / (1 - c)), [u[0], c * 100, p * 100];
};
S.apple.rgb = function(u) {
  return [u[0] / 65535 * 255, u[1] / 65535 * 255, u[2] / 65535 * 255];
};
S.rgb.apple = function(u) {
  return [u[0] / 255 * 65535, u[1] / 255 * 65535, u[2] / 255 * 65535];
};
S.gray.rgb = function(u) {
  return [u[0] / 100 * 255, u[0] / 100 * 255, u[0] / 100 * 255];
};
S.gray.hsl = function(u) {
  return [0, 0, u[0]];
};
S.gray.hsv = S.gray.hsl;
S.gray.hwb = function(u) {
  return [0, 100, u[0]];
};
S.gray.cmyk = function(u) {
  return [0, 0, 0, u[0]];
};
S.gray.lab = function(u) {
  return [u[0], 0, 0];
};
S.gray.hex = function(u) {
  const o = Math.round(u[0] / 100 * 255) & 255, s = ((o << 16) + (o << 8) + o).toString(16).toUpperCase();
  return "000000".substring(s.length) + s;
};
S.rgb.gray = function(u) {
  return [(u[0] + u[1] + u[2]) / 3 / 255 * 100];
};
const Qr = Hs;
function ud() {
  const u = {}, o = Object.keys(Qr);
  for (let r = o.length, s = 0; s < r; s++)
    u[o[s]] = {
      distance: -1,
      parent: null
    };
  return u;
}
function ad(u) {
  const o = ud(), r = [u];
  for (o[u].distance = 0; r.length; ) {
    const s = r.pop(), c = Object.keys(Qr[s]);
    for (let p = c.length, d = 0; d < p; d++) {
      const b = c[d], A = o[b];
      A.distance === -1 && (A.distance = o[s].distance + 1, A.parent = s, r.unshift(b));
    }
  }
  return o;
}
function od(u, o) {
  return function(r) {
    return o(u(r));
  };
}
function sd(u, o) {
  const r = [o[u].parent, u];
  let s = Qr[o[u].parent][u], c = o[u].parent;
  for (; o[c].parent; )
    r.unshift(o[c].parent), s = od(Qr[o[c].parent][c], s), c = o[c].parent;
  return s.conversion = r, s;
}
var fd = function(u) {
  const o = ad(u), r = {}, s = Object.keys(o);
  for (let c = s.length, p = 0; p < c; p++) {
    const d = s[p];
    o[d].parent !== null && (r[d] = sd(d, o));
  }
  return r;
};
const Su = Hs, ld = fd, Xt = {}, cd = Object.keys(Su);
function hd(u) {
  const o = function(...r) {
    const s = r[0];
    return s == null ? s : (s.length > 1 && (r = s), u(r));
  };
  return "conversion" in u && (o.conversion = u.conversion), o;
}
function gd(u) {
  const o = function(...r) {
    const s = r[0];
    if (s == null)
      return s;
    s.length > 1 && (r = s);
    const c = u(r);
    if (typeof c == "object")
      for (let p = c.length, d = 0; d < p; d++)
        c[d] = Math.round(c[d]);
    return c;
  };
  return "conversion" in u && (o.conversion = u.conversion), o;
}
cd.forEach((u) => {
  Xt[u] = {}, Object.defineProperty(Xt[u], "channels", { value: Su[u].channels }), Object.defineProperty(Xt[u], "labels", { value: Su[u].labels });
  const o = ld(u);
  Object.keys(o).forEach((s) => {
    const c = o[s];
    Xt[u][s] = gd(c), Xt[u][s].raw = hd(c);
  });
});
function pd(u) {
  return Object.fromEntries(Object.entries(u).map(([o, r]) => [`--${td(o)}`, r]));
}
function dd(u) {
  return new Promise(function(o, r) {
    const s = Object.assign(document.createElement("input"), {
      type: "file",
      accept: u.types.join(","),
      style: `
        position: fixed;
        left: -100%;
        top: -100%;
        visibility: hidden;
      `
    });
    s.addEventListener("change", () => {
      if (document.body.removeChild(s), s.files) {
        const c = s.files[0];
        c.size > u.maxSize ? r({ err: "File size too big" }) : o(c);
      }
    }), document.body.appendChild(s), s.click();
  });
}
function vd(u) {
  return new Promise(function(o) {
    const r = new Image();
    r.addEventListener("load", () => {
      o({
        width: r.naturalWidth,
        height: r.naturalHeight,
        ratio: r.naturalWidth / r.naturalHeight
      });
    }), r.src = URL.createObjectURL(u);
  });
}
const _d = (u) => (Ep("data-v-3b18db5f"), u = u(), Cp(), u), md = { class: "inner" }, wd = {
  key: 0,
  class: "pointer-wrapper"
}, bd = /* @__PURE__ */ _d(() => /* @__PURE__ */ yn("div", { class: "pointer" }, null, -1)), yd = [
  bd
], xd = /* @__PURE__ */ nt({
  __name: "NTabsNav",
  props: {
    value: {},
    pointer: { default: "normal" },
    shape: { type: Boolean, default: !1 },
    vertical: { type: Boolean, default: !0 }
  },
  emits: ["update:value"],
  setup(u, { emit: o }) {
    const r = u, s = Pu(), c = Es(), p = le(null), d = Iu(r, "shape");
    Qe("shape", d);
    const b = Iu(r, "pointer");
    Qe("pointer", b);
    const A = Iu(r, "vertical");
    Qe("vertical", A);
    const O = En(() => s.default ? s.default() : []), E = En({
      get() {
        return r.value;
      },
      set(U) {
        o("update:value", U);
      }
    }), C = En(() => {
      const U = O.value.find((P) => {
        var Q;
        return ((Q = P.props) == null ? void 0 : Q.name) === E.value;
      });
      return U ? O.value.indexOf(U) : -1;
    });
    Qe("activeTabItemName", E);
    const H = En(() => pd(c.value));
    return (U, P) => (J(), pn("div", {
      class: wt(["n-tabs-nav", { [`pointer-${b.value}`]: !0, vertical: A.value }]),
      style: Xr({ ["--tabs-count"]: O.value.length, ["--active-tab-index"]: C.value, ...H.value, ["--primary-color-shape"]: `rgba(${gn(ws)(gn(Cu)(gn(c).primaryColor, 0.1))})`, ["--text-color-unfocus"]: `rgba(${gn(ws)(gn(Cu)(gn(c).textColorBase, 0.7))})` })
    }, [
      yn("div", md, [
        b.value !== "none" ? (J(), pn("div", wd, yd)) : Zt("", !0),
        yn("div", {
          ref_key: "innerRef",
          ref: p,
          class: "items-wrapper"
        }, [
          De(U.$slots, "default", {}, void 0, !0)
        ], 512)
      ])
    ], 6));
  }
});
const Qt = (u, o) => {
  const r = u.__vccOpts || u;
  for (const [s, c] of o)
    r[s] = c;
  return r;
}, _v = /* @__PURE__ */ Qt(xd, [["__scopeId", "data-v-3b18db5f"]]), Ad = { class: "inner" }, Td = { class: "icon-wrapper" }, Od = { class: "label-wrapper" }, Rd = { class: "label" }, Id = /* @__PURE__ */ nt({
  __name: "NTabItemNav",
  props: {
    name: {}
  },
  setup(u) {
    const o = u, r = mt("shape"), s = mt("vertical"), c = mt("activeTabItemName"), p = En(() => c.value === o.name), d = () => {
      c.value = o.name;
    };
    return (b, A) => (J(), pn("div", {
      class: wt(["n-tab-item-nav", { active: p.value, shape: gn(r), vertical: gn(s) }]),
      onClick: d
    }, [
      yn("div", Ad, [
        yn("div", Td, [
          De(b.$slots, "icon", {}, void 0, !0)
        ]),
        yn("div", Od, [
          yn("div", Rd, [
            De(b.$slots, "default", {}, void 0, !0)
          ])
        ])
      ])
    ], 2));
  }
});
const mv = /* @__PURE__ */ Qt(Id, [["__scopeId", "data-v-124ec683"]]);
function Ns() {
  return En(() => Zp(Es().value.baseColor).r < 128);
}
const Ed = {
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  viewBox: "0 0 512 512"
}, Cd = /* @__PURE__ */ yn(
  "path",
  {
    fill: "none",
    stroke: "currentColor",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "32",
    d: "M368 368L144 144"
  },
  null,
  -1
), Sd = /* @__PURE__ */ yn(
  "path",
  {
    fill: "none",
    stroke: "currentColor",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "32",
    d: "M368 144L144 368"
  },
  null,
  -1
), Ld = [Cd, Sd], Pd = nt({
  name: "CloseOutline",
  render: function(o, r) {
    return J(), pn("svg", Ed, Ld);
  }
}), Md = ((u = 50) => {
  let o, r, s, c;
  function p() {
    o = null, c = 0;
  }
  return p(), function(d) {
    return r = d(), o != null && (c = r - o), o = r, clearTimeout(s), s = setTimeout(p, u), c;
  };
})();
function Bd(u) {
  const o = Sp({ x: 0, y: 0, width: 0, height: 0 }), r = () => {
    if (u.value) {
      const c = u.value.getBoundingClientRect();
      for (const p of ["x", "y", "width", "height"])
        o[p] = c[p];
    }
  }, s = new ResizeObserver(r);
  return Mu(() => s.disconnect()), Yr(u, (c) => {
    !c || s.observe(c);
  }, { immediate: !0 }), o;
}
function Wd(u) {
  const o = le(0), r = () => {
    u.value && (o.value = u.value.scrollHeight);
  }, s = new MutationObserver(r);
  return Mu(() => s.disconnect()), Yr(u, (c) => {
    !c || (r(), s.observe(c, { attributes: !0, childList: !0, subtree: !0 }));
  }, { immediate: !0 }), o;
}
const Ud = ["data-popup-id"], Fd = { class: "wrapper-inner" }, Dd = { class: "area-title" }, kd = { class: "area-actions" }, Hd = 50, ys = 2, Nd = /* @__PURE__ */ nt({
  __name: "NPopupWrapper",
  props: {
    id: {},
    slotNodes: {},
    slotNodesTitle: {},
    slotNodesCloseBtn: {},
    slotNodesActions: {},
    slotNodesHeader: {},
    title: {},
    level: {},
    type: {},
    fixedHeight: { type: [Boolean, Number] },
    fixedWidth: { type: [Boolean, Number] },
    transculent: { type: Boolean },
    pullDownTolerance: { default: 15 },
    customClasses: {},
    minOffset: {},
    maxOffset: {}
  },
  emits: ["close"],
  setup(u, { emit: o }) {
    const r = u, s = Ns(), c = Pu(), p = le(0), d = En(() => r.minOffset), b = En(() => r.maxOffset), A = le(), O = le(), E = Bd(A), C = Wd(A), H = le(0), U = En(() => Math.min(Math.max(Hd, E.height * (E.height / C.value)), E.height)), P = En(() => {
      const $ = H.value / (C.value - E.height);
      return ys + (E.height - U.value + d.value - ys * 2) * $;
    }), Q = ($) => {
      $.target.classList.contains("n-popup-wrapper") && o("close");
    }, z = le(0), dn = () => {
      var On, wn, xn;
      const $ = (xn = (wn = (On = O.value) == null ? void 0 : On.getBoundingClientRect()) == null ? void 0 : wn.y) != null ? xn : 0;
      z.value = -$ + d.value;
    };
    gs(() => {
      A.value && A.value.addEventListener("scroll", dn);
    }), gs(dn);
    const Fn = le(!1);
    let fn = 0;
    const an = ($) => {
      console.log("touchstart", $), Fn.value = !0, A.value && A.value.scrollTop++, fn = $.touches[0].screenY;
    }, j = () => {
      Fn.value = !1, p.value >= r.pullDownTolerance && o("close");
    }, Cn = ($) => {
      $.touches[0].screenY - fn;
    };
    window.addEventListener("touchend", j), window.addEventListener("touchmove", Cn), Mu(() => {
      window.removeEventListener("touchend", j), window.removeEventListener("touchmove", Cn);
    });
    let vn = (($ = 5) => ({
      state: [],
      push(On) {
        this.state.push(On), this.state = this.state.slice(-$);
      }
    }))();
    const en = le(!1);
    let on;
    const et = ($) => {
      var On;
      if (A.value) {
        if (Fn.value) {
          const wn = Md(() => {
            var xn, He;
            return (He = (xn = A.value) == null ? void 0 : xn.scrollTop) != null ? He : 0;
          });
          vn.push(wn), p.value = Math.abs(Math.min(...vn.state));
        }
        H.value = (On = A.value) == null ? void 0 : On.scrollTop, en.value = !0, clearTimeout(on), on = setTimeout(() => {
          en.value = !1;
        }, 1e3);
      }
    };
    return ($, On) => (J(), pn("div", {
      class: wt(["n-popup-wrapper", { [`type-${$.type}`]: !0, transculent: $.transculent, "touch-action-active": Fn.value }]),
      "data-popup-id": $.id,
      style: Xr({ ["--min-offset"]: d.value, ["--max-offset"]: b.value, ["--mask-offset"]: z.value, ["--level"]: $.level, ["--popup-background-color-default"]: gn(s) ? "#2e3337" : "rgb(252, 252, 252)" }),
      onClick: Q
    }, [
      yn("div", Fd, [
        yn("div", {
          ref_key: "popupRef",
          ref: A,
          class: wt(["popup", { "fixed-height": $.fixedHeight === !0 || typeof $.fixedHeight == "number", "fixed-width": $.fixedWidth === !0 || typeof $.fixedWidth == "number", ...Object.fromEntries($.customClasses.map((wn) => [wn, !0])) }]),
          style: Xr({ ["--fixed-height"]: typeof $.fixedHeight == "number" ? `${$.fixedHeight}px` : "auto", ["--fixed-width"]: typeof $.fixedWidth == "number" ? `${$.fixedWidth}px` : "auto" }),
          onScroll: et
        }, [
          yn("header", {
            ref: "headerRef",
            onTouchstart: an
          }, [
            gn(c).header ? De($.$slots, "header", { key: 0 }, void 0, !0) : (J(), pn(Ae, { key: 1 }, [
              yn("section", Dd, [
                gn(c).title ? De($.$slots, "title", { key: 0 }, void 0, !0) : Zt("", !0)
              ]),
              yn("section", kd, [
                gn(c).actions ? (J(!0), pn(Ae, { key: 0 }, Fe(gn(c).actions(), (wn, xn) => (J(), pn("div", {
                  key: xn,
                  class: "action"
                }, [
                  (J(), ce(je(wn)))
                ]))), 128)) : Zt("", !0),
                yn("div", {
                  class: "action actions-close",
                  onClick: On[0] || (On[0] = (wn) => o("close"))
                }, [
                  gn(c)["close-btn"] ? De($.$slots, "close-btn", { key: 0 }, void 0, !0) : (J(), ce(gn(Cs), {
                    key: 1,
                    tertiary: "",
                    circle: "",
                    size: "medium"
                  }, {
                    icon: Te(() => [
                      Zr(gn(Wp), null, {
                        default: Te(() => [
                          Zr(gn(Pd))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                ])
              ])
            ], 64))
          ], 544),
          yn("main", {
            ref_key: "mainRef",
            ref: O
          }, [
            $.type === "frame" ? (J(), ce(gn(Up), { key: 0 }, {
              default: Te(() => [
                (J(!0), pn(Ae, null, Fe($.slotNodes, (wn, xn) => (J(), ce(je(wn), { key: xn }))), 128))
              ]),
              _: 1
            })) : (J(!0), pn(Ae, { key: 1 }, Fe($.slotNodes, (wn, xn) => (J(), ce(je(wn), { key: xn }))), 128))
          ], 512)
        ], 38)
      ]),
      en.value ? (J(), pn("div", {
        key: 0,
        class: "scroll-thumb",
        style: Xr({ ["--thumb-height"]: `${U.value}px`, ["--scroll-thumb-pos"]: P.value + "px" })
      }, null, 4)) : Zt("", !0)
    ], 14, Ud));
  }
});
const $d = /* @__PURE__ */ Qt(Nd, [["__scopeId", "data-v-3460b15e"]]), Gd = { class: "popups-wrapper" }, zd = /* @__PURE__ */ nt({
  __name: "NPopupProvider",
  props: {
    minOffset: { default: 20 },
    maxOffset: { default: 55 }
  },
  setup(u) {
    const o = Ns(), r = le([]);
    function s({ id: d, type: b, transculent: A, fixedHeight: O, fixedWidth: E, customClasses: C, slotTitle: H, slotActions: U, slotCloseBtn: P, slotHeader: Q, slot: z }) {
      r.value = [
        ...r.value,
        {
          id: d,
          slotNodes: En(() => z ? z() : void 0),
          slotNodesTitle: En(() => H ? H() : void 0),
          slotNodesActions: En(() => U ? U() : void 0),
          slotNodesCloseBtn: En(() => P ? P() : void 0),
          slotNodesHeader: En(() => Q ? Q() : void 0),
          type: b,
          transculent: A,
          fixedHeight: O,
          fixedWidth: E,
          customClasses: C
        }
      ];
    }
    function c(d) {
      r.value = r.value.filter(({ id: b }) => b !== d);
    }
    function p(d) {
      const b = r.value.find(({ id: A }) => A === d);
      return b ? r.value.indexOf(b) : -1;
    }
    return Qe("showPopup", s), Qe("leavePopup", c), Qe("getPopupIndex", p), (d, b) => (J(), pn("div", {
      class: wt(["n-popup-provider", { "dark-mode": gn(o) }])
    }, [
      yn("div", {
        class: wt(["app-wrapper", { unfocused: r.value.length >= 1 }])
      }, [
        De(d.$slots, "default", {}, void 0, !0)
      ], 2),
      yn("div", Gd, [
        Zr(Lp, { name: "popup" }, {
          default: Te(() => [
            (J(!0), pn(Ae, null, Fe(r.value, ({ slotNodes: A, slotNodesTitle: O, slotNodesActions: E, slotNodesCloseBtn: C, slotNodesHeader: H, customClasses: U, id: P, type: Q, transculent: z, fixedHeight: dn, fixedWidth: Fn }, fn) => (J(), ce($d, {
              id: P,
              key: fn,
              level: r.value.length - 1 - fn,
              type: Q,
              transculent: z,
              "fixed-height": dn,
              "fixed-width": Fn,
              "slot-nodes": A,
              "slot-nodes-title": O,
              "slot-nodes-actions": E,
              "slot-nodes-close-btn": C,
              "slot-nodes-header": H,
              "custom-classes": U,
              "pull-down-tolerance": 15,
              "min-offset": d.minOffset,
              "max-offset": d.maxOffset,
              onClose: (an) => c(P)
            }, Pp({ _: 2 }, [
              O ? {
                name: "title",
                fn: Te(() => [
                  (J(!0), pn(Ae, null, Fe(O, (an, j) => (J(), ce(je(an), { key: j }))), 128))
                ]),
                key: "0"
              } : void 0,
              E ? {
                name: "actions",
                fn: Te(() => [
                  (J(!0), pn(Ae, null, Fe(E, (an, j) => (J(), ce(je(an), { key: j }))), 128))
                ]),
                key: "1"
              } : void 0,
              C ? {
                name: "close-btn",
                fn: Te(() => [
                  (J(!0), pn(Ae, null, Fe(C, (an, j) => (J(), ce(je(an), { key: j }))), 128))
                ]),
                key: "2"
              } : void 0,
              H ? {
                name: "header",
                fn: Te(() => [
                  (J(!0), pn(Ae, null, Fe(H, (an, j) => (J(), ce(je(an), { key: j }))), 128))
                ]),
                key: "3"
              } : void 0
            ]), 1032, ["id", "level", "type", "transculent", "fixed-height", "fixed-width", "slot-nodes", "slot-nodes-title", "slot-nodes-actions", "slot-nodes-close-btn", "slot-nodes-header", "custom-classes", "min-offset", "max-offset", "onClose"]))), 128))
          ]),
          _: 1
        })
      ])
    ], 2));
  }
});
const wv = /* @__PURE__ */ Qt(zd, [["__scopeId", "data-v-622e404e"]]);
let qd = (u = 21) => crypto.getRandomValues(new Uint8Array(u)).reduce((o, r) => (r &= 63, r < 36 ? o += r.toString(36) : r < 62 ? o += (r - 26).toString(36).toUpperCase() : r > 62 ? o += "-" : o += "_", o), "");
const Kd = { class: "n-popup__root" }, Xd = /* @__PURE__ */ nt({
  __name: "NPopup",
  props: {
    trigger: { default: "click" },
    title: { default: void 0 },
    show: { type: Boolean },
    type: { default: "layer" },
    transculent: { type: Boolean, default: !1 },
    fixedHeight: { type: [Boolean, Number], default: !1 },
    fixedWidth: { type: [Boolean, Number], default: !1 },
    customClasses: { default: () => [] }
  },
  emits: ["update:show"],
  setup(u, { expose: o, emit: r }) {
    const s = u, c = qd(), p = Pu(), d = mt("showPopup"), b = mt("leavePopup"), A = mt("getPopupIndex"), O = En({
      get() {
        return A ? A(c) >= 0 : !1;
      },
      set(U) {
        if (U !== O.value && p.default)
          if (U) {
            if (d) {
              const P = p.title ? p.title : s.title ? () => [
                Mp(Fp, { innerHTML: s.title })
              ] : void 0;
              d({
                id: c,
                type: s.type,
                transculent: s.transculent,
                fixedHeight: s.fixedHeight,
                fixedWidth: s.fixedWidth,
                customClasses: s.customClasses,
                slot: p.default,
                slotTitle: P,
                slotActions: p.actions,
                slotCloseBtn: p["close-btn"],
                slotHeader: p.header
              });
            }
          } else
            b && b(c);
      }
    });
    Yr(O, (U) => {
      r("update:show", U);
    }), Yr(() => s.show, (U) => {
      s.show !== O.value && (O.value = !!s.show);
    }, {
      immediate: !0
    });
    const E = () => {
      s.trigger === "click" && (O.value = !0);
    }, C = () => {
      s.trigger === "hover" && (O.value = !0);
    };
    return o({
      destroy: () => {
        O.value = !1;
      }
    }), (U, P) => (J(), pn("div", Kd, [
      U.trigger !== "manual" ? (J(), pn("div", {
        key: 0,
        class: "trigger-wrapper",
        onClick: E,
        onMouseenter: C
      }, [
        De(U.$slots, "trigger", {}, void 0, !0)
      ], 32)) : Zt("", !0)
    ]));
  }
});
const bv = /* @__PURE__ */ Qt(Xd, [["__scopeId", "data-v-7d5d1df5"]]);
/*!
 * Compressor.js v1.1.1
 * https://fengyuanchen.github.io/compressorjs
 *
 * Copyright 2018-present Chen Fengyuan
 * Released under the MIT license
 *
 * Date: 2021-10-05T02:32:40.212Z
 */
function xs(u, o) {
  var r = Object.keys(u);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(u);
    o && (s = s.filter(function(c) {
      return Object.getOwnPropertyDescriptor(u, c).enumerable;
    })), r.push.apply(r, s);
  }
  return r;
}
function Kr(u) {
  for (var o = 1; o < arguments.length; o++) {
    var r = arguments[o] != null ? arguments[o] : {};
    o % 2 ? xs(Object(r), !0).forEach(function(s) {
      Jd(u, s, r[s]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(u, Object.getOwnPropertyDescriptors(r)) : xs(Object(r)).forEach(function(s) {
      Object.defineProperty(u, s, Object.getOwnPropertyDescriptor(r, s));
    });
  }
  return u;
}
function Yd(u, o) {
  if (!(u instanceof o))
    throw new TypeError("Cannot call a class as a function");
}
function As(u, o) {
  for (var r = 0; r < o.length; r++) {
    var s = o[r];
    s.enumerable = s.enumerable || !1, s.configurable = !0, "value" in s && (s.writable = !0), Object.defineProperty(u, s.key, s);
  }
}
function Zd(u, o, r) {
  return o && As(u.prototype, o), r && As(u, r), u;
}
function Jd(u, o, r) {
  return o in u ? Object.defineProperty(u, o, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : u[o] = r, u;
}
function jr() {
  return jr = Object.assign || function(u) {
    for (var o = 1; o < arguments.length; o++) {
      var r = arguments[o];
      for (var s in r)
        Object.prototype.hasOwnProperty.call(r, s) && (u[s] = r[s]);
    }
    return u;
  }, jr.apply(this, arguments);
}
var $s = { exports: {} };
(function(u) {
  typeof window > "u" || function(o) {
    var r = o.HTMLCanvasElement && o.HTMLCanvasElement.prototype, s = o.Blob && function() {
      try {
        return Boolean(new Blob());
      } catch {
        return !1;
      }
    }(), c = s && o.Uint8Array && function() {
      try {
        return new Blob([new Uint8Array(100)]).size === 100;
      } catch {
        return !1;
      }
    }(), p = o.BlobBuilder || o.WebKitBlobBuilder || o.MozBlobBuilder || o.MSBlobBuilder, d = /^data:((.*?)(;charset=.*?)?)(;base64)?,/, b = (s || p) && o.atob && o.ArrayBuffer && o.Uint8Array && function(A) {
      var O, E, C, H, U, P, Q, z, dn;
      if (O = A.match(d), !O)
        throw new Error("invalid data URI");
      for (E = O[2] ? O[1] : "text/plain" + (O[3] || ";charset=US-ASCII"), C = !!O[4], H = A.slice(O[0].length), C ? U = atob(H) : U = decodeURIComponent(H), P = new ArrayBuffer(U.length), Q = new Uint8Array(P), z = 0; z < U.length; z += 1)
        Q[z] = U.charCodeAt(z);
      return s ? new Blob([c ? Q : P], {
        type: E
      }) : (dn = new p(), dn.append(P), dn.getBlob(E));
    };
    o.HTMLCanvasElement && !r.toBlob && (r.mozGetAsFile ? r.toBlob = function(A, O, E) {
      var C = this;
      setTimeout(function() {
        E && r.toDataURL && b ? A(b(C.toDataURL(O, E))) : A(C.mozGetAsFile("blob", O));
      });
    } : r.toDataURL && b && (r.msToBlob ? r.toBlob = function(A, O, E) {
      var C = this;
      setTimeout(function() {
        (O && O !== "image/png" || E) && r.toDataURL && b ? A(b(C.toDataURL(O, E))) : A(C.msToBlob(O));
      });
    } : r.toBlob = function(A, O, E) {
      var C = this;
      setTimeout(function() {
        A(b(C.toDataURL(O, E)));
      });
    })), u.exports ? u.exports = b : o.dataURLtoBlob = b;
  }(window);
})($s);
var Vd = $s.exports, Qd = function(o) {
  return typeof Blob > "u" ? !1 : o instanceof Blob || Object.prototype.toString.call(o) === "[object Blob]";
}, Ts = {
  strict: !0,
  checkOrientation: !0,
  maxWidth: 1 / 0,
  maxHeight: 1 / 0,
  minWidth: 0,
  minHeight: 0,
  width: void 0,
  height: void 0,
  resize: "none",
  quality: 0.8,
  mimeType: "auto",
  convertTypes: ["image/png"],
  convertSize: 5e6,
  beforeDraw: null,
  drew: null,
  success: null,
  error: null
}, jd = typeof window < "u" && typeof window.document < "u", ke = jd ? window : {}, ni = function(o) {
  return o > 0 && o < 1 / 0;
}, nv = Array.prototype.slice;
function ev(u) {
  return Array.from ? Array.from(u) : nv.call(u);
}
var tv = /^image\/.+$/;
function Lu(u) {
  return tv.test(u);
}
function rv(u) {
  var o = Lu(u) ? u.substr(6) : "";
  return o === "jpeg" && (o = "jpg"), ".".concat(o);
}
var Gs = String.fromCharCode;
function iv(u, o, r) {
  var s = "", c;
  for (r += o, c = o; c < r; c += 1)
    s += Gs(u.getUint8(c));
  return s;
}
var uv = ke.btoa;
function av(u, o) {
  for (var r = [], s = 8192, c = new Uint8Array(u); c.length > 0; )
    r.push(Gs.apply(null, ev(c.subarray(0, s)))), c = c.subarray(s);
  return "data:".concat(o, ";base64,").concat(uv(r.join("")));
}
function ov(u) {
  var o = new DataView(u), r;
  try {
    var s, c, p;
    if (o.getUint8(0) === 255 && o.getUint8(1) === 216)
      for (var d = o.byteLength, b = 2; b + 1 < d; ) {
        if (o.getUint8(b) === 255 && o.getUint8(b + 1) === 225) {
          c = b;
          break;
        }
        b += 1;
      }
    if (c) {
      var A = c + 4, O = c + 10;
      if (iv(o, A, 4) === "Exif") {
        var E = o.getUint16(O);
        if (s = E === 18761, (s || E === 19789) && o.getUint16(O + 2, s) === 42) {
          var C = o.getUint32(O + 4, s);
          C >= 8 && (p = O + C);
        }
      }
    }
    if (p) {
      var H = o.getUint16(p, s), U, P;
      for (P = 0; P < H; P += 1)
        if (U = p + P * 12 + 2, o.getUint16(U, s) === 274) {
          U += 8, r = o.getUint16(U, s), o.setUint16(U, 1, s);
          break;
        }
    }
  } catch {
    r = 1;
  }
  return r;
}
function sv(u) {
  var o = 0, r = 1, s = 1;
  switch (u) {
    case 2:
      r = -1;
      break;
    case 3:
      o = -180;
      break;
    case 4:
      s = -1;
      break;
    case 5:
      o = 90, s = -1;
      break;
    case 6:
      o = 90;
      break;
    case 7:
      o = 90, r = -1;
      break;
    case 8:
      o = -90;
      break;
  }
  return {
    rotate: o,
    scaleX: r,
    scaleY: s
  };
}
var fv = /\.\d*(?:0|9){12}\d*$/;
function Os(u) {
  var o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1e11;
  return fv.test(u) ? Math.round(u * o) / o : u;
}
function Yt(u) {
  var o = u.aspectRatio, r = u.height, s = u.width, c = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "none", p = ni(s), d = ni(r);
  if (p && d) {
    var b = r * o;
    (c === "contain" || c === "none") && b > s || c === "cover" && b < s ? r = s / o : s = r * o;
  } else
    p ? r = s / o : d && (s = r * o);
  return {
    width: s,
    height: r
  };
}
var lv = ke.ArrayBuffer, Rs = ke.FileReader, Ve = ke.URL || ke.webkitURL, cv = /\.\w+$/, hv = ke.Compressor, gv = /* @__PURE__ */ function() {
  function u(o, r) {
    Yd(this, u), this.file = o, this.image = new Image(), this.options = Kr(Kr({}, Ts), r), this.aborted = !1, this.result = null, this.init();
  }
  return Zd(u, [{
    key: "init",
    value: function() {
      var r = this, s = this.file, c = this.options;
      if (!Qd(s)) {
        this.fail(new Error("The first argument must be a File or Blob object."));
        return;
      }
      var p = s.type;
      if (!Lu(p)) {
        this.fail(new Error("The first argument must be an image File or Blob object."));
        return;
      }
      if (!Ve || !Rs) {
        this.fail(new Error("The current browser does not support image compression."));
        return;
      }
      if (lv || (c.checkOrientation = !1), Ve && !c.checkOrientation)
        this.load({
          url: Ve.createObjectURL(s)
        });
      else {
        var d = new Rs(), b = c.checkOrientation && p === "image/jpeg";
        this.reader = d, d.onload = function(A) {
          var O = A.target, E = O.result, C = {};
          if (b) {
            var H = ov(E);
            H > 1 || !Ve ? (C.url = av(E, p), H > 1 && jr(C, sv(H))) : C.url = Ve.createObjectURL(s);
          } else
            C.url = E;
          r.load(C);
        }, d.onabort = function() {
          r.fail(new Error("Aborted to read the image with FileReader."));
        }, d.onerror = function() {
          r.fail(new Error("Failed to read the image with FileReader."));
        }, d.onloadend = function() {
          r.reader = null;
        }, b ? d.readAsArrayBuffer(s) : d.readAsDataURL(s);
      }
    }
  }, {
    key: "load",
    value: function(r) {
      var s = this, c = this.file, p = this.image;
      p.onload = function() {
        s.draw(Kr(Kr({}, r), {}, {
          naturalWidth: p.naturalWidth,
          naturalHeight: p.naturalHeight
        }));
      }, p.onabort = function() {
        s.fail(new Error("Aborted to load the image."));
      }, p.onerror = function() {
        s.fail(new Error("Failed to load the image."));
      }, ke.navigator && /(?:iPad|iPhone|iPod).*?AppleWebKit/i.test(ke.navigator.userAgent) && (p.crossOrigin = "anonymous"), p.alt = c.name, p.src = r.url;
    }
  }, {
    key: "draw",
    value: function(r) {
      var s = this, c = r.naturalWidth, p = r.naturalHeight, d = r.rotate, b = d === void 0 ? 0 : d, A = r.scaleX, O = A === void 0 ? 1 : A, E = r.scaleY, C = E === void 0 ? 1 : E, H = this.file, U = this.image, P = this.options, Q = document.createElement("canvas"), z = Q.getContext("2d"), dn = Math.abs(b) % 180 === 90, Fn = (P.resize === "contain" || P.resize === "cover") && ni(P.width) && ni(P.height), fn = Math.max(P.maxWidth, 0) || 1 / 0, an = Math.max(P.maxHeight, 0) || 1 / 0, j = Math.max(P.minWidth, 0) || 0, Cn = Math.max(P.minHeight, 0) || 0, vn = c / p, en = P.width, on = P.height;
      if (dn) {
        var et = [an, fn];
        fn = et[0], an = et[1];
        var $ = [Cn, j];
        j = $[0], Cn = $[1];
        var On = [on, en];
        en = On[0], on = On[1];
      }
      Fn && (vn = en / on);
      var wn = Yt({
        aspectRatio: vn,
        width: fn,
        height: an
      }, "contain");
      fn = wn.width, an = wn.height;
      var xn = Yt({
        aspectRatio: vn,
        width: j,
        height: Cn
      }, "cover");
      if (j = xn.width, Cn = xn.height, Fn) {
        var He = Yt({
          aspectRatio: vn,
          width: en,
          height: on
        }, P.resize);
        en = He.width, on = He.height;
      } else {
        var jt = Yt({
          aspectRatio: vn,
          width: en,
          height: on
        }), ae = jt.width;
        en = ae === void 0 ? c : ae;
        var jn = jt.height;
        on = jn === void 0 ? p : jn;
      }
      en = Math.floor(Os(Math.min(Math.max(en, j), fn))), on = Math.floor(Os(Math.min(Math.max(on, Cn), an)));
      var ii = -en / 2, tt = -on / 2, zn = en, ui = on, At = [];
      if (Fn) {
        var nr = 0, he = 0, Oe = c, Tt = p, Re = Yt({
          aspectRatio: vn,
          width: c,
          height: p
        }, {
          contain: "cover",
          cover: "contain"
        }[P.resize]);
        Oe = Re.width, Tt = Re.height, nr = (c - Oe) / 2, he = (p - Tt) / 2, At.push(nr, he, Oe, Tt);
      }
      if (At.push(ii, tt, zn, ui), dn) {
        var Ie = [on, en];
        en = Ie[0], on = Ie[1];
      }
      Q.width = en, Q.height = on, Lu(P.mimeType) || (P.mimeType = H.type);
      var er = "transparent";
      if (H.size > P.convertSize && P.convertTypes.indexOf(P.mimeType) >= 0 && (P.mimeType = "image/jpeg"), P.mimeType === "image/jpeg" && (er = "#fff"), z.fillStyle = er, z.fillRect(0, 0, en, on), P.beforeDraw && P.beforeDraw.call(this, z, Q), !this.aborted && (z.save(), z.translate(en / 2, on / 2), z.rotate(b * Math.PI / 180), z.scale(O, C), z.drawImage.apply(z, [U].concat(At)), z.restore(), P.drew && P.drew.call(this, z, Q), !this.aborted)) {
        var Ne = function(tr) {
          s.aborted || s.done({
            naturalWidth: c,
            naturalHeight: p,
            result: tr
          });
        };
        Q.toBlob ? Q.toBlob(Ne, P.mimeType, P.quality) : Ne(Vd(Q.toDataURL(P.mimeType, P.quality)));
      }
    }
  }, {
    key: "done",
    value: function(r) {
      var s = r.naturalWidth, c = r.naturalHeight, p = r.result, d = this.file, b = this.image, A = this.options;
      if (Ve && !A.checkOrientation && Ve.revokeObjectURL(b.src), p)
        if (A.strict && p.size > d.size && A.mimeType === d.type && !(A.width > s || A.height > c || A.minWidth > s || A.minHeight > c || A.maxWidth < s || A.maxHeight < c))
          p = d;
        else {
          var O = new Date();
          p.lastModified = O.getTime(), p.lastModifiedDate = O, p.name = d.name, p.name && p.type !== d.type && (p.name = p.name.replace(cv, rv(p.type)));
        }
      else
        p = d;
      this.result = p, A.success && A.success.call(this, p);
    }
  }, {
    key: "fail",
    value: function(r) {
      var s = this.options;
      if (s.error)
        s.error.call(this, r);
      else
        throw r;
    }
  }, {
    key: "abort",
    value: function() {
      this.aborted || (this.aborted = !0, this.reader ? this.reader.abort() : this.image.complete ? this.fail(new Error("The compression process has been aborted.")) : (this.image.onload = null, this.image.onabort()));
    }
  }], [{
    key: "noConflict",
    value: function() {
      return window.Compressor = hv, u;
    }
  }, {
    key: "setDefaults",
    value: function(r) {
      jr(Ts, r);
    }
  }]), u;
}();
async function Is({ width: u, height: o, mode: r, quality: s, type: c }) {
  return new Promise(async (p, d) => {
    const b = await dd({
      maxSize: 32e6,
      types: ["image/*"]
    }), A = await vd(b), O = A.height / A.width, E = o / u, C = (() => {
      switch (r) {
        case "max":
          return O >= E ? "height" : "width";
        default:
          return O >= E ? "width" : "height";
      }
    })();
    new gv(b, {
      mimeType: c,
      quality: s,
      checkOrientation: !0,
      [C]: { width: u, height: o }[C],
      async success(H) {
        const U = H instanceof Blob ? H : new Blob([H]);
        p(U);
      },
      error(H) {
        d(H);
      }
    });
  });
}
const pv = { class: "n-image-upload" }, yv = /* @__PURE__ */ nt({
  __name: "NImageUpload",
  setup(u) {
    console.log(Is);
    const o = async () => {
      const r = await Is({
        width: 1080,
        height: 1080,
        type: "image/jpeg",
        quality: 85
      });
      console.log(r);
    };
    return (r, s) => (J(), pn("div", pv, [
      Zr(gn(Cs), { onClick: o }, {
        default: Te(() => [
          Bp(" Test ")
        ]),
        _: 1
      })
    ]));
  }
});
export {
  yv as NImageUpload,
  bv as NPopup,
  wv as NPopupProvider,
  mv as NTabItemNav,
  _v as NTabsNav
};
